var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _g, _path1212, _g2, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _g3, _path1224, _g4, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _g5, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _g6, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearnerSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.426 346.522V128.677L450.749 108.073L423.983 123.526V176.978L410.6 169.251V148.647L397.218 140.921V94.0135L357.069 70.8345L339.225 81.1365V110.844L321.381 100.542L303.538 110.844V155.489L285.693 165.765V72.8665L267.85 62.5635L245.544 75.4415V159.516L223.24 146.639V44.5995L196.474 29.1465L165.247 47.1745V114.04L151.864 121.767V148.843L134.02 159.146V84.8195L111.716 71.9415L84.9502 87.3955V109.39L71.5672 117.117V212.193L53.7232 222.495V115.652L26.9582 100.199L13.5752 107.925L13.5742 346.522H486.426Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 225.6L328.636 223.412V220.107L324.847 222.295V225.6Z",
    fill: "#FFE7C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 237.789L328.636 235.601V232.297L324.847 234.484V237.789Z",
    fill: "#FFE7C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 219.506L328.636 217.319V214.014L324.847 216.202V219.506Z",
    fill: "#FFE7C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 212.99L328.636 210.803V207.498L324.847 209.685V212.99Z",
    fill: "#FFE7C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 231.696L328.636 229.508V226.203L324.847 228.391V231.696Z",
    fill: "#FFE7C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 188.614L328.636 186.426V183.121L324.847 185.309V188.614Z",
    fill: "#FFE7C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 182.52L328.636 180.332V177.027L324.847 179.215V182.52Z",
    fill: "#FFE7C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 194.707L328.636 192.519V189.215L324.847 191.402V194.707Z",
    fill: "#FFE7C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 206.896L328.636 204.709V201.404L324.847 203.591V206.896Z",
    fill: "#FFE7C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 200.801L328.636 198.614V195.309L324.847 197.496V200.801Z",
    fill: "#FFE7C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 256.072L328.636 253.885V250.58L324.847 252.767V256.072Z",
    fill: "#FFE7C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 286.965L328.636 284.777V281.473L324.847 283.66V286.965Z",
    fill: "#FFE7C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 274.354L328.636 272.166V268.861L324.847 271.049V274.354Z",
    fill: "#FFE7C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 280.872L328.636 278.685V275.379L324.847 277.567V280.872Z",
    fill: "#FFE7C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 299.154L328.636 296.967V293.662L324.847 295.849V299.154Z",
    fill: "#FFE7C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 293.058L328.636 290.871V287.566L324.847 289.753V293.058Z",
    fill: "#FFE7C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 249.978L328.636 247.791V244.486L324.847 246.673V249.978Z",
    fill: "#FFE7C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 268.26L328.636 266.073V262.768L324.847 264.956V268.26Z",
    fill: "#FFE7C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 243.883L328.636 241.696V238.391L324.847 240.578V243.883Z",
    fill: "#FFE7C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 176.425L328.636 174.237V170.932L324.847 173.12V176.425Z",
    fill: "#FFE7C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 262.166L328.636 259.979V256.674L324.847 258.861V262.166Z",
    fill: "#FFE7C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 300.706L336.491 298.518V295.213L332.702 297.401V300.706Z",
    fill: "#FFE7C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 294.611L336.491 292.424V289.119L332.702 291.307V294.611Z",
    fill: "#FFE7C4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 306.8L336.491 304.612V301.307L332.702 303.495V306.8Z",
    fill: "#FFE7C4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 312.894L336.491 310.706V307.402L332.702 309.589V312.894Z",
    fill: "#FFE7C4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 305.248L328.636 303.061V299.756L324.847 301.944V305.248Z",
    fill: "#FFE7C4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 151.176L328.636 148.989V145.684L324.847 147.871V151.176Z",
    fill: "#FFE7C4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 144.66L328.636 142.473V139.168L324.847 141.355V144.66Z",
    fill: "#FFE7C4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 158.142L328.636 155.955V152.65L324.847 154.837V158.142Z",
    fill: "#FFE7C4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 137.693L328.636 135.506V132.201L324.847 134.388V137.693Z",
    fill: "#FFE7C4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 164.236L328.636 162.049V158.744L324.847 160.931V164.236Z",
    fill: "#FFE7C4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 170.33L328.636 168.143V164.838L324.847 167.025V170.33Z",
    fill: "#FFE7C4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 131.599L328.636 129.412V126.107L324.847 128.294V131.599Z",
    fill: "#FFE7C4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 125.506L328.636 123.319V120.014L324.847 122.201V125.506Z",
    fill: "#FFE7C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 105.221L394.619 103.034V99.7285L390.83 101.916V105.221Z",
    fill: "#FFE7C4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 216.339L394.619 214.151V210.846L390.83 213.034V216.339Z",
    fill: "#FFE7C4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 210.244L394.619 208.056V204.752L390.83 206.939V210.244Z",
    fill: "#FFE7C4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 204.151L394.619 201.963V198.658L390.83 200.846V204.151Z",
    fill: "#FFE7C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 222.431L394.619 220.243V216.939L390.83 219.126V222.431Z",
    fill: "#FFE7C4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 228.527L394.619 226.339V223.035L390.83 225.222V228.527Z",
    fill: "#FFE7C4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 166.713L394.619 164.526V161.221L390.83 163.408V166.713Z",
    fill: "#FFE7C4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 179.773L394.619 177.586V174.281L390.83 176.468V179.773Z",
    fill: "#FFE7C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 198.055L394.619 195.868V192.562L390.83 194.75V198.055Z",
    fill: "#FFE7C4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 173.679L394.619 171.492V168.188L390.83 170.374V173.679Z",
    fill: "#FFE7C4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 185.867L394.619 183.68V180.375L390.83 182.562V185.867Z",
    fill: "#FFE7C4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 235.043L394.619 232.856V229.551L390.83 231.739V235.043Z",
    fill: "#FFE7C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 191.961L394.619 189.774V186.469L390.83 188.657V191.961Z",
    fill: "#FFE7C4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 283.797L394.619 281.61V278.305L390.83 280.492V283.797Z",
    fill: "#FFE7C4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 277.703L394.619 275.516V272.211L390.83 274.398V277.703Z",
    fill: "#FFE7C4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 296.409L394.619 294.221V290.916L390.83 293.104V296.409Z",
    fill: "#FFE7C4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 271.609L394.619 269.422V266.117L390.83 268.304V271.609Z",
    fill: "#FFE7C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 289.89L394.619 287.703V284.398L390.83 286.585V289.89Z",
    fill: "#FFE7C4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 253.327L394.619 251.139V247.834L390.83 250.022V253.327Z",
    fill: "#FFE7C4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 265.513L394.619 263.326V260.021L390.83 262.208V265.513Z",
    fill: "#FFE7C4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 247.232L394.619 245.045V241.74L390.83 243.928V247.232Z",
    fill: "#FFE7C4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 241.137L394.619 238.95V235.645L390.83 237.832V241.137Z",
    fill: "#FFE7C4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 259.421L394.619 257.233V253.928L390.83 256.116V259.421Z",
    fill: "#FFE7C4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 111.314L394.619 109.127V105.822L390.83 108.009V111.314Z",
    fill: "#FFE7C4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 160.619L394.619 158.431V155.127L390.83 157.314V160.619Z",
    fill: "#FFE7C4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 142.219L394.619 140.032V136.727L390.83 138.915V142.219Z",
    fill: "#FFE7C4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 136.126L394.619 133.938V130.633L390.83 132.82V136.126Z",
    fill: "#FFE7C4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 154.407L394.619 152.219V148.914L390.83 151.102V154.407Z",
    fill: "#FFE7C4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 148.313L394.619 146.125V142.82L390.83 145.008V148.313Z",
    fill: "#FFE7C4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 129.597L394.619 127.409V124.105L390.83 126.292V129.597Z",
    fill: "#FFE7C4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M324.847 311.342L328.636 309.155V305.85L324.847 308.038V311.342Z",
    fill: "#FFE7C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 288.517L336.491 286.33V283.025L332.702 285.213V288.517Z",
    fill: "#FFE7C4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 117.409L394.619 115.221V111.916L390.83 114.104V117.409Z",
    fill: "#FFE7C4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 123.503L394.619 121.315V118.01L390.83 120.198V123.503Z",
    fill: "#FFE7C4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 86.6336L197.7 84.4456V81.1406L193.911 83.3286V86.6336Z",
    fill: "#FFE7C4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 172.439L197.7 170.252V166.947L193.911 169.134V172.439Z",
    fill: "#FFE7C4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 184.627L197.7 182.44V179.135L193.911 181.322V184.627Z",
    fill: "#FFE7C4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 202.911L197.7 200.723V197.418L193.911 199.606V202.911Z",
    fill: "#FFE7C4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 190.721L197.7 188.534V185.229L193.911 187.417V190.721Z",
    fill: "#FFE7C4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 196.817L197.7 194.629V191.324L193.911 193.512V196.817Z",
    fill: "#FFE7C4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 178.533L197.7 176.346V173.041L193.911 175.229V178.533Z",
    fill: "#FFE7C4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 135.388L197.7 133.2V129.895L193.911 132.083V135.388Z",
    fill: "#FFE7C4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 141.482L197.7 139.294V135.99L193.911 138.177V141.482Z",
    fill: "#FFE7C4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 147.576L197.7 145.389V142.084L193.911 144.271V147.576Z",
    fill: "#FFE7C4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 154.157L197.7 151.97V148.664L193.911 150.852V154.157Z",
    fill: "#FFE7C4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 160.252L197.7 158.064V154.76L193.911 156.947V160.252Z",
    fill: "#FFE7C4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 166.346L197.7 164.158V160.854L193.911 163.041V166.346Z",
    fill: "#FFE7C4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 245.992L197.7 243.804V240.5L193.911 242.687V245.992Z",
    fill: "#FFE7C4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 252.087L197.7 249.9V246.594L193.911 248.782V252.087Z",
    fill: "#FFE7C4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 258.18L197.7 255.992V252.688L193.911 254.875V258.18Z",
    fill: "#FFE7C4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 264.275L197.7 262.088V258.783L193.911 260.97V264.275Z",
    fill: "#FFE7C4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 239.898L197.7 237.711V234.406L193.911 236.594V239.898Z",
    fill: "#FFE7C4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 227.709L197.7 225.522V222.217L193.911 224.404V227.709Z",
    fill: "#FFE7C4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 221.615L197.7 219.428V216.123L193.911 218.31V221.615Z",
    fill: "#FFE7C4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 233.804L197.7 231.616V228.311L193.911 230.499V233.804Z",
    fill: "#FFE7C4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 215.521L197.7 213.334V210.029L193.911 212.216V215.521Z",
    fill: "#FFE7C4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 209.004L197.7 206.817V203.512L193.911 205.699V209.004Z",
    fill: "#FFE7C4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 270.369L197.7 268.182V264.877L193.911 267.064V270.369Z",
    fill: "#FFE7C4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 308.908L205.556 306.721V303.416L201.768 305.604V308.908Z",
    fill: "#FFE7C4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 129.293L197.7 127.106V123.801L193.911 125.989V129.293Z",
    fill: "#FFE7C4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 302.814L205.556 300.627V297.322L201.768 299.51V302.814Z",
    fill: "#FFE7C4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 284.533L205.556 282.346V279.041L201.768 281.228V284.533Z",
    fill: "#FFE7C4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 290.627L205.556 288.44V285.135L201.768 287.322V290.627Z",
    fill: "#FFE7C4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 296.721L205.556 294.534V291.229L201.768 293.417V296.721Z",
    fill: "#FFE7C4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 68.3514L197.7 66.1644V62.8594L193.911 65.0474V68.3514Z",
    fill: "#FFE7C4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 111.01L197.7 108.823V105.518L193.911 107.705V111.01Z",
    fill: "#FFE7C4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 104.916L197.7 102.729V99.4238L193.911 101.611V104.916Z",
    fill: "#FFE7C4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 123.199L197.7 121.012V117.707L193.911 119.895V123.199Z",
    fill: "#FFE7C4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 117.105L197.7 114.918V111.613L193.911 113.8V117.105Z",
    fill: "#FFE7C4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 98.8221L197.7 96.6341V93.3301L193.911 95.5171V98.8221Z",
    fill: "#FFE7C4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 80.5389L197.7 78.3519V75.0469L193.911 77.2349V80.5389Z",
    fill: "#FFE7C4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 92.7283L197.7 90.5403V87.2363L193.911 89.4233V92.7283Z",
    fill: "#FFE7C4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 74.4451L197.7 72.2581V68.9531L193.911 71.1411V74.4451Z",
    fill: "#FFE7C4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 302.503L394.619 300.315V297.01L390.83 299.198V302.503Z",
    fill: "#FFE7C4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 184.072L336.491 181.885V178.58L332.702 180.767V184.072Z",
    fill: "#FFE7C4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 190.166L336.491 187.979V184.674L332.702 186.861V190.166Z",
    fill: "#FFE7C4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 276.885L197.7 274.698V271.393L193.911 273.581V276.885Z",
    fill: "#FFE7C4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 202.353L336.491 200.166V196.861L332.702 199.048V202.353Z",
    fill: "#FFE7C4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 208.448L336.491 206.26V202.955L332.702 205.143V208.448Z",
    fill: "#FFE7C4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 214.966L336.491 212.778V209.473L332.702 211.661V214.966Z",
    fill: "#FFE7C4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 165.79L336.491 163.602V160.297L332.702 162.485V165.79Z",
    fill: "#FFE7C4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 159.696L336.491 157.508V154.203L332.702 156.391V159.696Z",
    fill: "#FFE7C4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 153.6L336.491 151.412V148.107L332.702 150.294V153.6Z",
    fill: "#FFE7C4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 171.884L336.491 169.696V166.391L332.702 168.579V171.884Z",
    fill: "#FFE7C4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 177.978L336.491 175.791V172.486L332.702 174.673V177.978Z",
    fill: "#FFE7C4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 263.719L336.491 261.531V258.227L332.702 260.414V263.719Z",
    fill: "#FFE7C4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 221.058L336.491 218.871V215.566L332.702 217.753V221.058Z",
    fill: "#FFE7C4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 269.812L336.491 267.624V264.32L332.702 266.507V269.812Z",
    fill: "#FFE7C4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 251.53L336.491 249.342V246.037L332.702 248.225V251.53Z",
    fill: "#FFE7C4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 276.33L336.491 274.143V270.838L332.702 273.025V276.33Z",
    fill: "#FFE7C4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 257.625L336.491 255.437V252.133L332.702 254.32V257.625Z",
    fill: "#FFE7C4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 227.154L336.491 224.967V221.662L332.702 223.849V227.154Z",
    fill: "#FFE7C4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 245.435L336.491 243.248V239.943L332.702 242.131V245.435Z",
    fill: "#FFE7C4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 233.248L336.491 231.061V227.756L332.702 229.943V233.248Z",
    fill: "#FFE7C4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 239.342L336.491 237.155V233.85L332.702 236.037V239.342Z",
    fill: "#FFE7C4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 196.26L336.491 194.073V190.768L332.702 192.956V196.26Z",
    fill: "#FFE7C4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 313.451L197.7 311.264V307.959L193.911 310.146V313.451Z",
    fill: "#FFE7C4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 307.357L197.7 305.17V301.865L193.911 304.052V307.357Z",
    fill: "#FFE7C4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 282.424L336.491 280.237V276.932L332.702 279.119V282.424Z",
    fill: "#FFE7C4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 146.635L336.491 144.448V141.143L332.702 143.331V146.635Z",
    fill: "#FFE7C4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 289.075L197.7 286.887V283.582L193.911 285.77V289.075Z",
    fill: "#FFE7C4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 295.169L197.7 292.981V289.676L193.911 291.864V295.169Z",
    fill: "#FFE7C4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 301.262L197.7 299.075V295.77L193.911 297.957V301.262Z",
    fill: "#FFE7C4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M193.911 282.981L197.7 280.793V277.488L193.911 279.676V282.981Z",
    fill: "#FFE7C4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 120.963L336.491 118.776V115.471L332.702 117.658V120.963Z",
    fill: "#FFE7C4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 127.056L336.491 124.869V121.564L332.702 123.752V127.056Z",
    fill: "#FFE7C4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 133.153L336.491 130.965V127.66L332.702 129.848V133.153Z",
    fill: "#FFE7C4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M332.702 140.117L336.491 137.93V134.625L332.702 136.813V140.117Z",
    fill: "#FFE7C4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 301.515L467.241 299.328V296.023L463.452 298.21V301.515Z",
    fill: "#FFE7C4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 308.596L394.619 306.409V303.104L390.83 305.292V308.596Z",
    fill: "#FFE7C4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 272.176L475.097 269.988V266.684L471.309 268.871V272.176Z",
    fill: "#FFE7C4"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 284.787L475.097 282.6V279.295L471.309 281.483V284.787Z",
    fill: "#FFE7C4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 266.082L475.097 263.894V260.59L471.309 262.777V266.082Z",
    fill: "#FFE7C4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 290.881L475.097 288.694V285.389L471.309 287.577V290.881Z",
    fill: "#FFE7C4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 253.893L475.097 251.705V248.4L471.309 250.588V253.893Z",
    fill: "#FFE7C4"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 235.611L475.097 233.424V230.119L471.309 232.306V235.611Z",
    fill: "#FFE7C4"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 241.705L475.097 239.518V236.213L471.309 238.401V241.705Z",
    fill: "#FFE7C4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 247.799L475.097 245.612V242.307L471.309 244.495V247.799Z",
    fill: "#FFE7C4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 296.975L475.097 294.787V291.482L471.309 293.67V296.975Z",
    fill: "#FFE7C4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 309.164L475.097 306.976V303.672L471.309 305.859V309.164Z",
    fill: "#FFE7C4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 315.258L475.097 313.07V309.766L471.309 311.953V315.258Z",
    fill: "#FFE7C4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 303.069L475.097 300.881V297.576L471.309 299.764V303.069Z",
    fill: "#FFE7C4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 229.515L475.097 227.328V224.023L471.309 226.21V229.515Z",
    fill: "#FFE7C4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 259.987L475.097 257.799V254.494L471.309 256.682V259.987Z",
    fill: "#FFE7C4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 223.422L475.097 221.235V217.93L471.309 220.117V223.422Z",
    fill: "#FFE7C4"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 149.66L475.097 147.473V144.168L471.309 146.355V149.66Z",
    fill: "#FFE7C4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 155.754L475.097 153.567V150.262L471.309 152.45V155.754Z",
    fill: "#FFE7C4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 143.543L475.097 141.355V138.051L471.309 140.238V143.543Z",
    fill: "#FFE7C4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 198.624L475.097 196.436V193.131L471.309 195.319V198.624Z",
    fill: "#FFE7C4"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 162.057L475.097 159.869V156.564L471.309 158.752V162.057Z",
    fill: "#FFE7C4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 204.717L475.097 202.53V199.225L471.309 201.413V204.717Z",
    fill: "#FFE7C4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 216.905L475.097 214.717V211.412L471.309 213.6V216.905Z",
    fill: "#FFE7C4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 210.811L475.097 208.623V205.318L471.309 207.506V210.811Z",
    fill: "#FFE7C4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 192.529L475.097 190.342V187.037L471.309 189.224V192.529Z",
    fill: "#FFE7C4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 168.152L475.097 165.964V162.66L471.309 164.847V168.152Z",
    fill: "#FFE7C4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 174.246L475.097 172.058V168.754L471.309 170.941V174.246Z",
    fill: "#FFE7C4"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 180.34L475.097 178.152V174.848L471.309 177.035V180.34Z",
    fill: "#FFE7C4"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 186.433L475.097 184.246V180.941L471.309 183.128V186.433Z",
    fill: "#FFE7C4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 264.53L467.241 262.342V259.037L463.452 261.225V264.53Z",
    fill: "#FFE7C4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 295.422L467.241 293.235V289.93L463.452 292.117V295.422Z",
    fill: "#FFE7C4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 278.439L205.556 276.251V272.947L201.768 275.134V278.439Z",
    fill: "#FFE7C4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 313.705L467.241 311.518V308.213L463.452 310.401V313.705Z",
    fill: "#FFE7C4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 282.812L467.241 280.625V277.32L463.452 279.507V282.812Z",
    fill: "#FFE7C4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 276.718L467.241 274.53V271.225L463.452 273.413V276.718Z",
    fill: "#FFE7C4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 289.328L467.241 287.141V283.836L463.452 286.023V289.328Z",
    fill: "#FFE7C4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 270.623L467.241 268.436V265.131L463.452 267.319V270.623Z",
    fill: "#FFE7C4"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 307.612L467.241 305.424V302.119L463.452 304.306V307.612Z",
    fill: "#FFE7C4"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 258.433L467.241 256.246V252.941L463.452 255.128V258.433Z",
    fill: "#FFE7C4"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 166.599L467.241 164.412V161.107L463.452 163.295V166.599Z",
    fill: "#FFE7C4"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 160.297L467.241 158.109V154.805L463.452 156.992V160.297Z",
    fill: "#FFE7C4"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 178.788L467.241 176.6V173.295L463.452 175.483V178.788Z",
    fill: "#FFE7C4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 184.882L467.241 182.694V179.389L463.452 181.577V184.882Z",
    fill: "#FFE7C4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 148.084L467.241 145.897V142.592L463.452 144.779V148.084Z",
    fill: "#FFE7C4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 190.975L467.241 188.787V185.482L463.452 187.67V190.975Z",
    fill: "#FFE7C4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 154.203L467.241 152.015V148.711L463.452 150.898V154.203Z",
    fill: "#FFE7C4"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 172.693L467.241 170.506V167.201L463.452 169.388V172.693Z",
    fill: "#FFE7C4"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 234.057L467.241 231.869V228.564L463.452 230.752V234.057Z",
    fill: "#FFE7C4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 240.152L467.241 237.964V234.66L463.452 236.847V240.152Z",
    fill: "#FFE7C4"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 246.246L467.241 244.058V240.754L463.452 242.941V246.246Z",
    fill: "#FFE7C4"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 227.964L467.241 225.776V222.471L463.452 224.659V227.964Z",
    fill: "#FFE7C4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 252.34L467.241 250.153V246.848L463.452 249.035V252.34Z",
    fill: "#FFE7C4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 221.447L467.241 219.26V215.955L463.452 218.143V221.447Z",
    fill: "#FFE7C4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 203.164L467.241 200.976V197.672L463.452 199.859V203.164Z",
    fill: "#FFE7C4"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 209.258L467.241 207.071V203.766L463.452 205.953V209.258Z",
    fill: "#FFE7C4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 215.353L467.241 213.166V209.861L463.452 212.048V215.353Z",
    fill: "#FFE7C4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M463.452 197.07L467.241 194.882V191.578L463.452 193.765V197.07Z",
    fill: "#FFE7C4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M471.309 278.269L475.097 276.082V272.777L471.309 274.964V278.269Z",
    fill: "#FFE7C4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 214.785L386.764 212.598V209.293L382.975 211.48V214.785Z",
    fill: "#FFE7C4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 208.691L386.764 206.504V203.199L382.975 205.386V208.691Z",
    fill: "#FFE7C4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 220.879L386.764 218.692V215.387L382.975 217.575V220.879Z",
    fill: "#FFE7C4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 226.973L386.764 224.785V221.48L382.975 223.668V226.973Z",
    fill: "#FFE7C4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 165.16L386.764 162.973V159.668L382.975 161.856V165.16Z",
    fill: "#FFE7C4"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 196.504L386.764 194.316V191.012L382.975 193.199V196.504Z",
    fill: "#FFE7C4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 178.222L386.764 176.034V172.729L382.975 174.917V178.222Z",
    fill: "#FFE7C4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 233.068L386.764 230.88V227.576L382.975 229.763V233.068Z",
    fill: "#FFE7C4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 171.255L386.764 169.068V165.764L382.975 167.951V171.255Z",
    fill: "#FFE7C4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 184.316L386.764 182.128V178.824L382.975 181.011V184.316Z",
    fill: "#FFE7C4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 190.409L386.764 188.221V184.916L382.975 187.104V190.409Z",
    fill: "#FFE7C4"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 202.597L386.764 200.41V197.105L382.975 199.292V202.597Z",
    fill: "#FFE7C4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 276.151L386.764 273.963V270.658L382.975 272.846V276.151Z",
    fill: "#FFE7C4"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 270.055L386.764 267.867V264.562L382.975 266.751V270.055Z",
    fill: "#FFE7C4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 282.244L386.764 280.056V276.752L382.975 278.939V282.244Z",
    fill: "#FFE7C4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 294.431L386.764 292.244V288.939L382.975 291.126V294.431Z",
    fill: "#FFE7C4"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 288.338L386.764 286.15V282.846L382.975 285.033V288.338Z",
    fill: "#FFE7C4"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 245.679L386.764 243.492V240.188L382.975 242.374V245.679Z",
    fill: "#FFE7C4"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 239.586L386.764 237.398V234.094L382.975 236.281V239.586Z",
    fill: "#FFE7C4"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 251.773L386.764 249.586V246.281L382.975 248.468V251.773Z",
    fill: "#FFE7C4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 263.961L386.764 261.774V258.469L382.975 260.657V263.961Z",
    fill: "#FFE7C4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 257.867L386.764 255.68V252.375L382.975 254.563V257.867Z",
    fill: "#FFE7C4"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 300.949L386.764 298.762V295.457L382.975 297.645V300.949Z",
    fill: "#FFE7C4"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 314.691L394.619 312.504V309.199L390.83 311.386V314.691Z",
    fill: "#FFE7C4"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 158.949L386.764 156.762V153.457L382.975 155.645V158.949Z",
    fill: "#FFE7C4"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 140.666L386.764 138.479V135.174L382.975 137.361V140.666Z",
    fill: "#FFE7C4"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 134.138L386.764 131.951V128.646L382.975 130.834V134.138Z",
    fill: "#FFE7C4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 146.76L386.764 144.573V141.268L382.975 143.455V146.76Z",
    fill: "#FFE7C4"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 128.045L386.764 125.858V122.553L382.975 124.741V128.045Z",
    fill: "#FFE7C4"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 152.855L386.764 150.668V147.363L382.975 149.551V152.855Z",
    fill: "#FFE7C4"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 109.762L386.764 107.575V104.27L382.975 106.457V109.762Z",
    fill: "#FFE7C4"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 115.857L386.764 113.67V110.365L382.975 112.552V115.857Z",
    fill: "#FFE7C4"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 121.951L386.764 119.764V116.459L382.975 118.646V121.951Z",
    fill: "#FFE7C4"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 237.163L482.952 234.975V231.67L479.164 233.858V237.163Z",
    fill: "#FFE7C4"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 200.175L482.952 197.987V194.682L479.164 196.87V200.175Z",
    fill: "#FFE7C4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 249.351L482.952 247.164V243.859L479.164 246.046V249.351Z",
    fill: "#FFE7C4"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 255.445L482.952 253.258V249.953L479.164 252.14V255.445Z",
    fill: "#FFE7C4"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 261.539L482.952 259.352V256.047L479.164 258.234V261.539Z",
    fill: "#FFE7C4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 231.068L482.952 228.881V225.576L479.164 227.764V231.068Z",
    fill: "#FFE7C4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 206.269L482.952 204.081V200.777L479.164 202.964V206.269Z",
    fill: "#FFE7C4"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 224.974L482.952 222.787V219.482L479.164 221.67V224.974Z",
    fill: "#FFE7C4"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 212.363L482.952 210.176V206.871L479.164 209.058V212.363Z",
    fill: "#FFE7C4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 218.881L482.952 216.694V213.389L479.164 215.577V218.881Z",
    fill: "#FFE7C4"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 243.258L482.952 241.07V237.766L479.164 239.953V243.258Z",
    fill: "#FFE7C4"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 304.621L482.952 302.434V299.129L479.164 301.316V304.621Z",
    fill: "#FFE7C4"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 267.633L482.952 265.446V262.141L479.164 264.328V267.633Z",
    fill: "#FFE7C4"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 298.527L482.952 296.34V293.035L479.164 295.222V298.527Z",
    fill: "#FFE7C4"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 310.715L482.952 308.528V305.223L479.164 307.41V310.715Z",
    fill: "#FFE7C4"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 273.728L482.952 271.541V268.236L479.164 270.424V273.728Z",
    fill: "#FFE7C4"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 280.245L482.952 278.057V274.752L479.164 276.94V280.245Z",
    fill: "#FFE7C4"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 307.043L386.764 304.856V301.551L382.975 303.738V307.043Z",
    fill: "#FFE7C4"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 292.433L482.952 290.245V286.941L479.164 289.128V292.433Z",
    fill: "#FFE7C4"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 286.34L482.952 284.152V280.848L479.164 283.035V286.34Z",
    fill: "#FFE7C4"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 194.081L482.952 191.893V188.588L479.164 190.776V194.081Z",
    fill: "#FFE7C4"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M382.975 313.138L386.764 310.95V307.645L382.975 309.833V313.138Z",
    fill: "#FFE7C4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 175.799L482.952 173.612V170.307L479.164 172.494V175.799Z",
    fill: "#FFE7C4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 169.705L482.952 167.518V164.213L479.164 166.4V169.705Z",
    fill: "#FFE7C4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 163.611L482.952 161.424V158.119L479.164 160.306V163.611Z",
    fill: "#FFE7C4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 181.893L482.952 179.705V176.4L479.164 178.588V181.893Z",
    fill: "#FFE7C4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 187.987L482.952 185.799V182.494L479.164 184.682V187.987Z",
    fill: "#FFE7C4"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 139L482.952 136.813V133.508L479.164 135.695V139Z",
    fill: "#FFE7C4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 157.515L482.952 155.328V152.023L479.164 154.21V157.515Z",
    fill: "#FFE7C4"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 145.12L482.952 142.932V139.627L479.164 141.815V145.12Z",
    fill: "#FFE7C4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M479.164 151.214L482.952 149.026V145.721L479.164 147.909V151.214Z",
    fill: "#FFE7C4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 278.926L36.7275 281.113V277.808L32.9385 275.621V278.926Z",
    fill: "#FFE7C4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 103.88L131.026 101.692V98.3867L127.237 100.575V103.88Z",
    fill: "#FFE7C4"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 109.973L131.026 107.785V104.48L127.237 106.668V109.973Z",
    fill: "#FFE7C4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 97.786L131.026 95.598V92.293L127.237 94.481V97.786Z",
    fill: "#FFE7C4"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 116.068L131.026 113.881V110.576L127.237 112.763V116.068Z",
    fill: "#FFE7C4"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 122.162L131.026 119.975V116.67L127.237 118.857V122.162Z",
    fill: "#FFE7C4"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 128.256L131.026 126.069V122.764L127.237 124.951V128.256Z",
    fill: "#FFE7C4"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 300.735L21.0155 302.923V299.618L17.2275 297.43V300.735Z",
    fill: "#FFE7C4"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 312.923L21.0155 315.111V311.806L17.2275 309.619V312.923Z",
    fill: "#FFE7C4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 306.828L21.0155 309.016V305.711L17.2275 303.523V306.828Z",
    fill: "#FFE7C4"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 177.008L131.026 174.821V171.516L127.237 173.703V177.008Z",
    fill: "#FFE7C4"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 134.349L131.026 132.162V128.857L127.237 131.044V134.349Z",
    fill: "#FFE7C4"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 183.103L131.026 180.916V177.611L127.237 179.798V183.103Z",
    fill: "#FFE7C4"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 189.197L131.026 187.01V183.705L127.237 185.893V189.197Z",
    fill: "#FFE7C4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 164.82L131.026 162.632V159.328L127.237 161.515V164.82Z",
    fill: "#FFE7C4"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 170.914L131.026 168.726V165.422L127.237 167.609V170.914Z",
    fill: "#FFE7C4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 140.443L131.026 138.256V134.951L127.237 137.139V140.443Z",
    fill: "#FFE7C4"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 146.538L131.026 144.35V141.045L127.237 143.233V146.538Z",
    fill: "#FFE7C4"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 158.725L131.026 156.537V153.232L127.237 155.42V158.725Z",
    fill: "#FFE7C4"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 152.632L131.026 150.444V147.139L127.237 149.327V152.632Z",
    fill: "#FFE7C4"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 294.641L21.0155 296.828V293.524L17.2275 291.336V294.641Z",
    fill: "#FFE7C4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 208.477L21.0155 210.664V207.36L17.2275 205.172V208.477Z",
    fill: "#FFE7C4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 196.289L21.0155 198.476V195.171L17.2275 192.984V196.289Z",
    fill: "#FFE7C4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 202.383L21.0155 204.571V201.265L17.2275 199.078V202.383Z",
    fill: "#FFE7C4"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 195.714L131.026 193.526V190.221L127.237 192.409V195.714Z",
    fill: "#FFE7C4"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 214.993L21.0155 217.181V213.876L17.2275 211.689V214.993Z",
    fill: "#FFE7C4"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 184.102L21.0155 186.289V182.984L17.2275 180.797V184.102Z",
    fill: "#FFE7C4"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 171.911L21.0155 174.099V170.794L17.2275 168.607V171.911Z",
    fill: "#FFE7C4"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 190.196L21.0155 192.383V189.078L17.2275 186.891V190.196Z",
    fill: "#FFE7C4"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 178.008L21.0155 180.195V176.89L17.2275 174.703V178.008Z",
    fill: "#FFE7C4"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 227.184L21.0155 229.371V226.066L17.2275 223.879V227.184Z",
    fill: "#FFE7C4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 221.089L21.0155 223.277V219.972L17.2275 217.785V221.089Z",
    fill: "#FFE7C4"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 263.746L21.0155 265.934V262.629L17.2275 260.441V263.746Z",
    fill: "#FFE7C4"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 165.819L21.0155 168.007V164.702L17.2275 162.514V165.819Z",
    fill: "#FFE7C4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 276.36L21.0155 278.547V275.242L17.2275 273.055V276.36Z",
    fill: "#FFE7C4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 282.453L21.0155 284.64V281.335L17.2275 279.148V282.453Z",
    fill: "#FFE7C4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 233.278L21.0155 235.465V232.16L17.2275 229.973V233.278Z",
    fill: "#FFE7C4"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 288.547L21.0155 290.734V287.43L17.2275 285.242V288.547Z",
    fill: "#FFE7C4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 239.371L21.0155 241.558V238.253L17.2275 236.066V239.371Z",
    fill: "#FFE7C4"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 245.465L21.0155 247.652V244.348L17.2275 242.16V245.465Z",
    fill: "#FFE7C4"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 251.559L21.0155 253.746V250.442L17.2275 248.254V251.559Z",
    fill: "#FFE7C4"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 257.653L21.0155 259.841V256.536L17.2275 254.348V257.653Z",
    fill: "#FFE7C4"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 269.841L21.0155 272.029V268.724L17.2275 266.537V269.841Z",
    fill: "#FFE7C4"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 144.986L123.172 142.799V139.494L119.383 141.681V144.986Z",
    fill: "#FFE7C4"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 138.89L123.172 136.702V133.398L119.383 135.585V138.89Z",
    fill: "#FFE7C4"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 151.08L123.172 148.893V145.588L119.383 147.775V151.08Z",
    fill: "#FFE7C4"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 157.174L123.172 154.987V151.682L119.383 153.869V157.174Z",
    fill: "#FFE7C4"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 163.267L123.172 161.08V157.775L119.383 159.963V163.267Z",
    fill: "#FFE7C4"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 108.42L123.172 106.233V102.928L119.383 105.116V108.42Z",
    fill: "#FFE7C4"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 201.807L131.026 199.619V196.314L127.237 198.502V201.807Z",
    fill: "#FFE7C4"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 132.798L123.172 130.611V127.305L119.383 129.493V132.798Z",
    fill: "#FFE7C4"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 169.362L123.172 167.174V163.869L119.383 166.057V169.362Z",
    fill: "#FFE7C4"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 126.704L123.172 124.516V121.211L119.383 123.399V126.704Z",
    fill: "#FFE7C4"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 120.61L123.172 118.422V115.117L119.383 117.305V120.61Z",
    fill: "#FFE7C4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 218.538L123.172 216.35V213.045L119.383 215.233V218.538Z",
    fill: "#FFE7C4"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 206.349L123.172 204.162V200.857L119.383 203.045V206.349Z",
    fill: "#FFE7C4"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 212.444L123.172 210.256V206.951L119.383 209.139V212.444Z",
    fill: "#FFE7C4"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 102.326L123.172 100.139V96.834L119.383 99.021V102.326Z",
    fill: "#FFE7C4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 224.633L123.172 222.445V219.141L119.383 221.328V224.633Z",
    fill: "#FFE7C4"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 230.726L123.172 228.538V225.234L119.383 227.421V230.726Z",
    fill: "#FFE7C4"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 181.551L123.172 179.363V176.059L119.383 178.246V181.551Z",
    fill: "#FFE7C4"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 175.456L123.172 173.268V169.963L119.383 172.151V175.456Z",
    fill: "#FFE7C4"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 187.644L123.172 185.456V182.152L119.383 184.339V187.644Z",
    fill: "#FFE7C4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 200.256L123.172 198.069V194.764L119.383 196.952V200.256Z",
    fill: "#FFE7C4"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 193.738L123.172 191.551V188.246L119.383 190.433V193.738Z",
    fill: "#FFE7C4"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 114.514L123.172 112.326V109.021L119.383 111.209V114.514Z",
    fill: "#FFE7C4"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 263.172L131.026 260.985V257.68L127.237 259.867V263.172Z",
    fill: "#FFE7C4"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 250.561L131.026 248.373V245.068L127.237 247.256V250.561Z",
    fill: "#FFE7C4"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 232.279L131.026 230.092V226.787L127.237 228.975V232.279Z",
    fill: "#FFE7C4"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 257.078L131.026 254.89V251.586L127.237 253.773V257.078Z",
    fill: "#FFE7C4"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 244.468L131.026 242.28V238.975L127.237 241.163V244.468Z",
    fill: "#FFE7C4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 213.996L131.026 211.808V208.504L127.237 210.691V213.996Z",
    fill: "#FFE7C4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 207.902L131.026 205.714V202.41L127.237 204.597V207.902Z",
    fill: "#FFE7C4"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 220.09L131.026 217.903V214.598L127.237 216.785V220.09Z",
    fill: "#FFE7C4"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 226.183L131.026 223.996V220.691L127.237 222.878V226.183Z",
    fill: "#FFE7C4"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 238.373L131.026 236.186V232.881L127.237 235.069V238.373Z",
    fill: "#FFE7C4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 311.926L131.026 309.739V306.434L127.237 308.621V311.926Z",
    fill: "#FFE7C4"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 305.832L131.026 303.645V300.34L127.237 302.527V305.832Z",
    fill: "#FFE7C4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 299.738L131.026 297.55V294.246L127.237 296.433V299.738Z",
    fill: "#FFE7C4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 275.361L131.026 273.174V269.869L127.237 272.056V275.361Z",
    fill: "#FFE7C4"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 269.265L131.026 267.078V263.773L127.237 265.96V269.265Z",
    fill: "#FFE7C4"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 281.456L131.026 279.268V275.963L127.237 278.151V281.456Z",
    fill: "#FFE7C4"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 287.55L131.026 285.362V282.057L127.237 284.245V287.55Z",
    fill: "#FFE7C4"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 293.643L131.026 291.455V288.15L127.237 290.338V293.643Z",
    fill: "#FFE7C4"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 266.736L36.7275 268.924V265.619L32.9385 263.432V266.736Z",
    fill: "#FFE7C4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 260.642L36.7275 262.83V259.525L32.9385 257.338V260.642Z",
    fill: "#FFE7C4"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 254.549L36.7275 256.737V253.432L32.9385 251.244V254.549Z",
    fill: "#FFE7C4"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 272.832L36.7275 275.019V271.714L32.9385 269.527V272.832Z",
    fill: "#FFE7C4"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 285.442L36.7275 287.629V284.325L32.9385 282.137V285.442Z",
    fill: "#FFE7C4"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 224.078L36.7275 226.265V222.96L32.9385 220.773V224.078Z",
    fill: "#FFE7C4"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 291.535L36.7275 293.722V290.418L32.9385 288.23V291.535Z",
    fill: "#FFE7C4"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 248.453L36.7275 250.641V247.336L32.9385 245.148V248.453Z",
    fill: "#FFE7C4"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 230.172L36.7275 232.359V229.054L32.9385 226.867V230.172Z",
    fill: "#FFE7C4"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 236.266L36.7275 238.453V235.148L32.9385 232.961V236.266Z",
    fill: "#FFE7C4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 242.36L36.7275 244.548V241.243L32.9385 239.055V242.36Z",
    fill: "#FFE7C4"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 272.345L205.556 270.157V266.852L201.768 269.04V272.345Z",
    fill: "#FFE7C4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 297.631L36.7275 299.819V296.514L32.9385 294.326V297.631Z",
    fill: "#FFE7C4"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 236.82L123.172 234.633V231.328L119.383 233.515V236.82Z",
    fill: "#FFE7C4"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 303.724L36.7275 305.912V302.607L32.9385 300.42V303.724Z",
    fill: "#FFE7C4"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 309.819L36.7275 312.006V308.701L32.9385 306.514V309.819Z",
    fill: "#FFE7C4"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 217.56L36.7275 219.748V216.443L32.9385 214.256V217.56Z",
    fill: "#FFE7C4"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 211.467L36.7275 213.655V210.35L32.9385 208.162V211.467Z",
    fill: "#FFE7C4"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 143.944L36.7275 146.132V142.827L32.9385 140.639V143.944Z",
    fill: "#FFE7C4"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 137.85L36.7275 140.037V136.733L32.9385 134.545V137.85Z",
    fill: "#FFE7C4"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 187.09L36.7275 189.277V185.972L32.9385 183.785V187.09Z",
    fill: "#FFE7C4"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 193.184L36.7275 195.371V192.067L32.9385 189.879V193.184Z",
    fill: "#FFE7C4"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 180.996L36.7275 183.183V179.878L32.9385 177.691V180.996Z",
    fill: "#FFE7C4"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 199.278L36.7275 201.465V198.161L32.9385 195.973V199.278Z",
    fill: "#FFE7C4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 205.371L36.7275 207.559V204.254L32.9385 202.066V205.371Z",
    fill: "#FFE7C4"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 168.809L36.7275 170.996V167.691L32.9385 165.504V168.809Z",
    fill: "#FFE7C4"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 156.132L36.7275 158.32V155.015L32.9385 152.828V156.132Z",
    fill: "#FFE7C4"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 162.714L36.7275 164.902V161.597L32.9385 159.41V162.714Z",
    fill: "#FFE7C4"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 150.036L36.7275 152.224V148.919L32.9385 146.732V150.036Z",
    fill: "#FFE7C4"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 174.903L36.7275 177.09V173.785L32.9385 171.598V174.903Z",
    fill: "#FFE7C4"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 225.63L28.873 227.818V224.513L25.084 222.326V225.63Z",
    fill: "#FFE7C4"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 293.09L28.873 295.277V291.972L25.084 289.785V293.09Z",
    fill: "#FFE7C4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 305.278L28.873 307.465V304.16L25.084 301.973V305.278Z",
    fill: "#FFE7C4"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 311.371L28.873 313.558V310.253L25.084 308.066V311.371Z",
    fill: "#FFE7C4"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 286.994L28.873 289.181V285.876L25.084 283.689V286.994Z",
    fill: "#FFE7C4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 268.289L28.873 270.476V267.171L25.084 264.984V268.289Z",
    fill: "#FFE7C4"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 274.383L28.873 276.571V273.266L25.084 271.078V274.383Z",
    fill: "#FFE7C4"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 280.901L28.873 283.089V279.784L25.084 277.596V280.901Z",
    fill: "#FFE7C4"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 140.953L21.0155 143.14V139.836L17.2275 137.648V140.953Z",
    fill: "#FFE7C4"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 134.86L21.0155 137.047V133.742L17.2275 131.555V134.86Z",
    fill: "#FFE7C4"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 147.049L21.0155 149.236V145.932L17.2275 143.744V147.049Z",
    fill: "#FFE7C4"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 153.631L21.0155 155.818V152.514L17.2275 150.326V153.631Z",
    fill: "#FFE7C4"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 128.766L21.0155 130.953V127.648L17.2275 125.461V128.766Z",
    fill: "#FFE7C4"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 262.196L28.873 264.383V261.078L25.084 258.891V262.196Z",
    fill: "#FFE7C4"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 299.184L28.873 301.371V298.066L25.084 295.879V299.184Z",
    fill: "#FFE7C4"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 170.36L28.873 172.547V169.242L25.084 167.055V170.36Z",
    fill: "#FFE7C4"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 164.266L28.873 166.453V163.148L25.084 160.961V164.266Z",
    fill: "#FFE7C4"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 176.453L28.873 178.64V175.336L25.084 173.148V176.453Z",
    fill: "#FFE7C4"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 182.549L28.873 184.736V181.432L25.084 179.244V182.549Z",
    fill: "#FFE7C4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 158.172L28.873 160.359V157.054L25.084 154.867V158.172Z",
    fill: "#FFE7C4"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 188.642L28.873 190.83V187.525L25.084 185.338V188.642Z",
    fill: "#FFE7C4"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 256.102L28.873 258.289V254.984L25.084 252.797V256.102Z",
    fill: "#FFE7C4"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 151.59L28.873 153.777V150.472L25.084 148.285V151.59Z",
    fill: "#FFE7C4"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 133.308L28.873 135.496V132.191L25.084 130.004V133.308Z",
    fill: "#FFE7C4"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 145.496L28.873 147.683V144.378L25.084 142.191V145.496Z",
    fill: "#FFE7C4"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 139.402L28.873 141.59V138.285L25.084 136.098V139.402Z",
    fill: "#FFE7C4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 231.725L28.873 233.913V230.608L25.084 228.42V231.725Z",
    fill: "#FFE7C4"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 159.725L21.0155 161.913V158.608L17.2275 156.42V159.725Z",
    fill: "#FFE7C4"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 237.819L28.873 240.007V236.702L25.084 234.514V237.819Z",
    fill: "#FFE7C4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 243.912L28.873 246.099V242.794L25.084 240.607V243.912Z",
    fill: "#FFE7C4"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 194.737L28.873 196.925V193.62L25.084 191.432V194.737Z",
    fill: "#FFE7C4"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 250.008L28.873 252.195V248.89L25.084 246.703V250.008Z",
    fill: "#FFE7C4"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 200.832L28.873 203.019V199.714L25.084 197.527V200.832Z",
    fill: "#FFE7C4"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 219.535L28.873 221.723V218.417L25.084 216.23V219.535Z",
    fill: "#FFE7C4"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 206.926L28.873 209.113V205.808L25.084 203.621V206.926Z",
    fill: "#FFE7C4"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 213.02L28.873 215.207V211.902L25.084 209.715V213.02Z",
    fill: "#FFE7C4"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 175.545L213.411 173.358V170.053L209.622 172.24V175.545Z",
    fill: "#FFE7C4"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 181.638L213.411 179.451V176.146L209.622 178.333V181.638Z",
    fill: "#FFE7C4"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 187.732L213.411 185.545V182.24L209.622 184.427V187.732Z",
    fill: "#FFE7C4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 199.92L213.411 197.733V194.428L209.622 196.616V199.92Z",
    fill: "#FFE7C4"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 193.826L213.411 191.639V188.334L209.622 190.522V193.826Z",
    fill: "#FFE7C4"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 151.169L213.411 148.981V145.676L209.622 147.864V151.169Z",
    fill: "#FFE7C4"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 206.439L213.411 204.251V200.947L209.622 203.134V206.439Z",
    fill: "#FFE7C4"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 145.074L213.411 142.887V139.582L209.622 141.77V145.074Z",
    fill: "#FFE7C4"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 163.357L213.411 161.169V157.865L209.622 160.052V163.357Z",
    fill: "#FFE7C4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 157.263L213.411 155.075V151.77L209.622 153.958V157.263Z",
    fill: "#FFE7C4"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 169.451L213.411 167.264V163.959L209.622 166.146V169.451Z",
    fill: "#FFE7C4"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 212.533L213.411 210.345V207.041L209.622 209.228V212.533Z",
    fill: "#FFE7C4"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 255.191L213.411 253.003V249.699L209.622 251.886V255.191Z",
    fill: "#FFE7C4"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 249.097L213.411 246.909V243.604L209.622 245.792V249.097Z",
    fill: "#FFE7C4"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 261.285L213.411 259.097V255.793L209.622 257.98V261.285Z",
    fill: "#FFE7C4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 138.492L213.411 136.305V133L209.622 135.188V138.492Z",
    fill: "#FFE7C4"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 243.002L213.411 240.815V237.51L209.622 239.698V243.002Z",
    fill: "#FFE7C4"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 267.803L213.411 265.616V262.311L209.622 264.498V267.803Z",
    fill: "#FFE7C4"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 224.721L213.411 222.534V219.229L209.622 221.416V224.721Z",
    fill: "#FFE7C4"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 218.627L213.411 216.44V213.135L209.622 215.322V218.627Z",
    fill: "#FFE7C4"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 230.814L213.411 228.627V225.322L209.622 227.509V230.814Z",
    fill: "#FFE7C4"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 236.908L213.411 234.721V231.416L209.622 233.603V236.908Z",
    fill: "#FFE7C4"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 299.826L221.268 297.639V294.334L217.479 296.521V299.826Z",
    fill: "#FFE7C4"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 312.013L221.268 309.826V306.521L217.479 308.709V312.013Z",
    fill: "#FFE7C4"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 59.2693L213.411 57.0823V53.7773L209.622 55.9643V59.2693Z",
    fill: "#FFE7C4"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 305.92L221.268 303.733V300.428L217.479 302.616V305.92Z",
    fill: "#FFE7C4"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 65.3631L213.411 63.1761V59.8711L209.622 62.0581V65.3631Z",
    fill: "#FFE7C4"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 281.543L221.268 279.356V276.051L217.479 278.238V281.543Z",
    fill: "#FFE7C4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 287.637L221.268 285.45V282.145L217.479 284.332V287.637Z",
    fill: "#FFE7C4"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 132.398L213.411 130.211V126.906L209.622 129.094V132.398Z",
    fill: "#FFE7C4"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 273.896L213.411 271.709V268.404L209.622 270.591V273.896Z",
    fill: "#FFE7C4"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 293.732L221.268 291.545V288.24L217.479 290.427V293.732Z",
    fill: "#FFE7C4"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 71.4568L213.411 69.2698V65.9648L209.622 68.1518V71.4568Z",
    fill: "#FFE7C4"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 101.928L213.411 99.7405V96.4355L209.622 98.6226V101.928Z",
    fill: "#FFE7C4"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 108.021L213.411 105.834V102.529L209.622 104.716V108.021Z",
    fill: "#FFE7C4"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 126.303L213.411 124.116V120.811L209.622 122.998V126.303Z",
    fill: "#FFE7C4"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 120.209L213.411 118.022V114.717L209.622 116.904V120.209Z",
    fill: "#FFE7C4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 114.115L213.411 111.928V108.623L209.622 110.81V114.115Z",
    fill: "#FFE7C4"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 83.6443L213.411 81.4573V78.1523L209.622 80.3403V83.6443Z",
    fill: "#FFE7C4"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 95.8328L213.411 93.6448V90.3398L209.622 92.5278V95.8328Z",
    fill: "#FFE7C4"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 77.5506L213.411 75.3636V72.0586L209.622 74.2456V77.5506Z",
    fill: "#FFE7C4"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 89.7391L213.411 87.5511V84.2461L209.622 86.4341V89.7391Z",
    fill: "#FFE7C4"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 310.461L213.411 308.274V304.969L209.622 307.156V310.461Z",
    fill: "#FFE7C4"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 279.99L213.411 277.803V274.498L209.622 276.685V279.99Z",
    fill: "#FFE7C4"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 180.087L205.556 177.899V174.594L201.768 176.782V180.087Z",
    fill: "#FFE7C4"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 173.992L205.556 171.805V168.5L201.768 170.688V173.992Z",
    fill: "#FFE7C4"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 242.914L123.172 240.727V237.422L119.383 239.609V242.914Z",
    fill: "#FFE7C4"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 192.275L205.556 190.087V186.783L201.768 188.97V192.275Z",
    fill: "#FFE7C4"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 167.898L205.556 165.711V162.406L201.768 164.594V167.898Z",
    fill: "#FFE7C4"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 149.615L205.556 147.428V144.123L201.768 146.31V149.615Z",
    fill: "#FFE7C4"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 155.709L205.556 153.522V150.217L201.768 152.404V155.709Z",
    fill: "#FFE7C4"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 161.803L205.556 159.616V156.311L201.768 158.498V161.803Z",
    fill: "#FFE7C4"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 204.463L205.556 202.276V198.971L201.768 201.158V204.463Z",
    fill: "#FFE7C4"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 198.369L205.556 196.182V192.877L201.768 195.064V198.369Z",
    fill: "#FFE7C4"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 241.451L205.556 239.264V235.959L201.768 238.146V241.451Z",
    fill: "#FFE7C4"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 253.638L205.556 251.451V248.146L201.768 250.333V253.638Z",
    fill: "#FFE7C4"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 247.545L205.556 245.358V242.053L201.768 244.24V247.545Z",
    fill: "#FFE7C4"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 259.732L205.556 257.545V254.24L201.768 256.427V259.732Z",
    fill: "#FFE7C4"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 265.827L205.556 263.639V260.334L201.768 262.522V265.827Z",
    fill: "#FFE7C4"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 217.075L205.556 214.887V211.582L201.768 213.77V217.075Z",
    fill: "#FFE7C4"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 223.169L205.556 220.981V217.676L201.768 219.864V223.169Z",
    fill: "#FFE7C4"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 210.98L205.556 208.793V205.488L201.768 207.676V210.98Z",
    fill: "#FFE7C4"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 235.357L205.556 233.169V229.865L201.768 232.052V235.357Z",
    fill: "#FFE7C4"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 229.262L205.556 227.074V223.77L201.768 225.957V229.262Z",
    fill: "#FFE7C4"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 186.18L205.556 183.992V180.688L201.768 182.875V186.18Z",
    fill: "#FFE7C4"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 275.45L221.268 273.262V269.957L217.479 272.145V275.45Z",
    fill: "#FFE7C4"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 69.9041L205.556 67.7161V64.4121L201.768 66.5991V69.9041Z",
    fill: "#FFE7C4"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 63.8094L205.556 61.6214V58.3164L201.768 60.5044V63.8094Z",
    fill: "#FFE7C4"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 286.084L213.411 283.897V280.592L209.622 282.78V286.084Z",
    fill: "#FFE7C4"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 292.179L213.411 289.991V286.686L209.622 288.874V292.179Z",
    fill: "#FFE7C4"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 298.274L213.411 296.086V292.781L209.622 294.969V298.274Z",
    fill: "#FFE7C4"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M209.622 304.367L213.411 302.179V298.875L209.622 301.062V304.367Z",
    fill: "#FFE7C4"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 106.469L205.556 104.282V100.977L201.768 103.165V106.469Z",
    fill: "#FFE7C4"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 112.563L205.556 110.376V107.072L201.768 109.259V112.563Z",
    fill: "#FFE7C4"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 118.657L205.556 116.469V113.164L201.768 115.352V118.657Z",
    fill: "#FFE7C4"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 136.939L205.556 134.752V131.447L201.768 133.634V136.939Z",
    fill: "#FFE7C4"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 130.846L205.556 128.659V125.354L201.768 127.541V130.846Z",
    fill: "#FFE7C4"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 124.752L205.556 122.565V119.26L201.768 121.447V124.752Z",
    fill: "#FFE7C4"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 100.375L205.556 98.1878V94.8828L201.768 97.0708V100.375Z",
    fill: "#FFE7C4"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 82.0916L205.556 79.9046V76.5996L201.768 78.7866V82.0916Z",
    fill: "#FFE7C4"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 88.1873L205.556 86.0003V82.6953L201.768 84.8823V88.1873Z",
    fill: "#FFE7C4"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 75.9979L205.556 73.8109V70.5059L201.768 72.6929V75.9979Z",
    fill: "#FFE7C4"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 94.2811L205.556 92.0941V88.7891L201.768 90.9771V94.2811Z",
    fill: "#FFE7C4"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M201.768 143.033L205.556 140.846V137.541L201.768 139.728V143.033Z",
    fill: "#FFE7C4"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 173.904L115.315 171.717V168.412L111.526 170.599V173.904Z",
    fill: "#FFE7C4"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 179.998L115.315 177.811V174.506L111.526 176.693V179.998Z",
    fill: "#FFE7C4"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 186.092L115.315 183.905V180.6L111.526 182.788V186.092Z",
    fill: "#FFE7C4"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 192.186L115.315 189.998V186.693L111.526 188.881V192.186Z",
    fill: "#FFE7C4"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 198.28L115.315 196.092V192.787L111.526 194.975V198.28Z",
    fill: "#FFE7C4"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 143.432L115.315 141.244V137.939L111.526 140.127V143.432Z",
    fill: "#FFE7C4"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 149.527L115.315 147.339V144.035L111.526 146.222V149.527Z",
    fill: "#FFE7C4"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 204.797L115.315 202.61V199.305L111.526 201.492V204.797Z",
    fill: "#FFE7C4"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 167.808L115.315 165.621V162.316L111.526 164.503V167.808Z",
    fill: "#FFE7C4"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 155.621L115.315 153.433V150.129L111.526 152.316V155.621Z",
    fill: "#FFE7C4"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 269.355L221.268 267.168V263.863L217.479 266.051V269.355Z",
    fill: "#FFE7C4"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 253.551L115.315 251.363V248.059L111.526 250.246V253.551Z",
    fill: "#FFE7C4"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 210.89L115.315 208.703V205.398L111.526 207.585V210.89Z",
    fill: "#FFE7C4"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 247.457L115.315 245.269V241.965L111.526 244.152V247.457Z",
    fill: "#FFE7C4"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 266.162L115.315 263.975V260.67L111.526 262.857V266.162Z",
    fill: "#FFE7C4"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 259.644L115.315 257.457V254.152L111.526 256.339V259.644Z",
    fill: "#FFE7C4"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 241.362L115.315 239.174V235.869L111.526 238.057V241.362Z",
    fill: "#FFE7C4"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 137.339L115.315 135.151V131.846L111.526 134.034V137.339Z",
    fill: "#FFE7C4"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 223.08L115.315 220.893V217.588L111.526 219.775V223.08Z",
    fill: "#FFE7C4"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 216.986L115.315 214.799V211.494L111.526 213.681V216.986Z",
    fill: "#FFE7C4"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 229.174L115.315 226.987V223.682L111.526 225.87V229.174Z",
    fill: "#FFE7C4"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 235.267L115.315 233.08V229.775L111.526 231.963V235.267Z",
    fill: "#FFE7C4"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 298.183L123.172 295.996V292.691L119.383 294.878V298.183Z",
    fill: "#FFE7C4"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 131.244L115.315 129.057V125.752L111.526 127.94V131.244Z",
    fill: "#FFE7C4"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 285.996L123.172 283.809V280.504L119.383 282.691V285.996Z",
    fill: "#FFE7C4"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 279.902L123.172 277.715V274.41L119.383 276.597V279.902Z",
    fill: "#FFE7C4"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 272.256L115.315 270.069V266.764L111.526 268.952V272.256Z",
    fill: "#FFE7C4"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 292.09L123.172 289.903V286.598L119.383 288.785V292.09Z",
    fill: "#FFE7C4"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 255.103L123.172 252.916V249.611L119.383 251.798V255.103Z",
    fill: "#FFE7C4"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 304.28L123.172 302.092V298.787L119.383 300.975V304.28Z",
    fill: "#FFE7C4"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 249.008L123.172 246.821V243.516L119.383 245.703V249.008Z",
    fill: "#FFE7C4"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 267.714L123.172 265.526V262.221L119.383 264.409V267.714Z",
    fill: "#FFE7C4"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 261.62L123.172 259.432V256.127L119.383 258.315V261.62Z",
    fill: "#FFE7C4"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 273.808L123.172 271.62V268.316L119.383 270.503V273.808Z",
    fill: "#FFE7C4"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 106.869L115.315 104.682V101.377L111.526 103.564V106.869Z",
    fill: "#FFE7C4"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M119.383 310.374L123.172 308.186V304.881L119.383 307.069V310.374Z",
    fill: "#FFE7C4"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 112.963L115.315 110.776V107.471L111.526 109.658V112.963Z",
    fill: "#FFE7C4"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 119.056L115.315 116.869V113.564L111.526 115.751V119.056Z",
    fill: "#FFE7C4"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 125.15L115.315 122.963V119.658L111.526 121.845V125.15Z",
    fill: "#FFE7C4"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 161.715L115.315 159.528V156.223L111.526 158.41V161.715Z",
    fill: "#FFE7C4"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 183.192L221.268 181.004V177.699L217.479 179.887V183.192Z",
    fill: "#FFE7C4"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 171.002L221.268 168.815V165.51L217.479 167.698V171.002Z",
    fill: "#FFE7C4"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 177.096L221.268 174.909V171.604L217.479 173.792V177.096Z",
    fill: "#FFE7C4"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 195.379L221.268 193.191V189.887L217.479 192.074V195.379Z",
    fill: "#FFE7C4"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 140.532L221.268 138.344V135.039L217.479 137.227V140.532Z",
    fill: "#FFE7C4"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 189.286L221.268 187.098V183.793L217.479 185.981V189.286Z",
    fill: "#FFE7C4"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 146.627L221.268 144.44V141.135L217.479 143.322V146.627Z",
    fill: "#FFE7C4"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 164.908L221.268 162.721V159.416L217.479 161.604V164.908Z",
    fill: "#FFE7C4"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 152.721L221.268 150.534V147.229L217.479 149.416V152.721Z",
    fill: "#FFE7C4"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 158.814L221.268 156.627V153.322L217.479 155.509V158.814Z",
    fill: "#FFE7C4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 278.349L115.315 276.162V272.857L111.526 275.045V278.349Z",
    fill: "#FFE7C4"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 250.65L221.268 248.463V245.158L217.479 247.345V250.65Z",
    fill: "#FFE7C4"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 238.461L221.268 236.273V232.969L217.479 235.156V238.461Z",
    fill: "#FFE7C4"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 244.555L221.268 242.367V239.062L217.479 241.25V244.555Z",
    fill: "#FFE7C4"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 256.744L221.268 254.557V251.252L217.479 253.439V256.744Z",
    fill: "#FFE7C4"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 263.26L221.268 261.073V257.768L217.479 259.956V263.26Z",
    fill: "#FFE7C4"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 214.084L221.268 211.897V208.592L217.479 210.779V214.084Z",
    fill: "#FFE7C4"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 220.179L221.268 217.991V214.686L217.479 216.873V220.179Z",
    fill: "#FFE7C4"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 207.99L221.268 205.803V202.498L217.479 204.685V207.99Z",
    fill: "#FFE7C4"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 232.367L221.268 230.179V226.875L217.479 229.062V232.367Z",
    fill: "#FFE7C4"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 226.274L221.268 224.086V220.781L217.479 222.969V226.274Z",
    fill: "#FFE7C4"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 201.896L221.268 199.709V196.404L217.479 198.591V201.896Z",
    fill: "#FFE7C4"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 133.951L221.268 131.763V128.459L217.479 130.646V133.951Z",
    fill: "#FFE7C4"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 314.914L115.315 312.727V309.422L111.526 311.61V314.914Z",
    fill: "#FFE7C4"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 66.9149L221.268 64.7269V61.4219L217.479 63.6099V66.9149Z",
    fill: "#FFE7C4"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 60.8201L221.268 58.6331V55.3281L217.479 57.5161V60.8201Z",
    fill: "#FFE7C4"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 54.7264L221.268 52.5394V49.2344L217.479 51.4214V54.7264Z",
    fill: "#FFE7C4"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 284.444L115.315 282.256V278.951L111.526 281.139V284.444Z",
    fill: "#FFE7C4"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 290.538L115.315 288.35V285.045L111.526 287.233V290.538Z",
    fill: "#FFE7C4"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 296.633L115.315 294.445V291.141L111.526 293.328V296.633Z",
    fill: "#FFE7C4"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 302.726L115.315 300.539V297.234L111.526 299.421V302.726Z",
    fill: "#FFE7C4"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 308.82L115.315 306.633V303.328L111.526 305.515V308.82Z",
    fill: "#FFE7C4"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 115.669L221.268 113.481V110.176L217.479 112.364V115.669Z",
    fill: "#FFE7C4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 103.48L221.268 101.293V97.9883L217.479 100.176V103.48Z",
    fill: "#FFE7C4"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 109.574L221.268 107.387V104.082L217.479 106.27V109.574Z",
    fill: "#FFE7C4"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 121.763L221.268 119.575V116.27L217.479 118.458V121.763Z",
    fill: "#FFE7C4"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 127.857L221.268 125.669V122.365L217.479 124.552V127.857Z",
    fill: "#FFE7C4"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 79.1033L221.268 76.9153V73.6113L217.479 75.7983V79.1033Z",
    fill: "#FFE7C4"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 73.0086L221.268 70.8206V67.5156L217.479 69.7036V73.0086Z",
    fill: "#FFE7C4"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 85.1981L221.268 83.0111V79.7051L217.479 81.8931V85.1981Z",
    fill: "#FFE7C4"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 91.2908L221.268 89.1038V85.7988L217.479 87.9858V91.2908Z",
    fill: "#FFE7C4"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M217.479 97.3846L221.268 95.1976V91.8926L217.479 94.0796V97.3846Z",
    fill: "#FFE7C4"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 115.565L358.438 117.753V114.448L354.65 112.26V115.565Z",
    fill: "#EEDBBF"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 109.471L358.438 111.659V108.354L354.65 106.166V109.471Z",
    fill: "#EEDBBF"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 121.659L358.438 123.847V120.542L354.65 118.354V121.659Z",
    fill: "#EEDBBF"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 128.381L358.438 130.569V127.264L354.65 125.076V128.381Z",
    fill: "#EEDBBF"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 134.475L358.438 136.663V133.358L354.65 131.17V134.475Z",
    fill: "#EEDBBF"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 208.094L358.438 210.281V206.976L354.65 204.789V208.094Z",
    fill: "#EEDBBF"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 140.57L358.438 142.758V139.453L354.65 137.266V140.57Z",
    fill: "#EEDBBF"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 96.9749L358.438 99.1619V95.8579L354.65 93.6699V96.9749Z",
    fill: "#EEDBBF"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 201.999L358.438 204.187V200.882L354.65 198.695V201.999Z",
    fill: "#EEDBBF"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 218.729L366.295 220.917V217.612L362.507 215.424V218.729Z",
    fill: "#EEDBBF"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 177.621L358.438 179.808V176.503L354.65 174.316V177.621Z",
    fill: "#EEDBBF"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 183.717L358.438 185.904V182.6L354.65 180.412V183.717Z",
    fill: "#EEDBBF"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 195.905L358.438 198.093V194.788L354.65 192.6V195.905Z",
    fill: "#EEDBBF"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 146.663L358.438 148.85V145.545L354.65 143.357V146.663Z",
    fill: "#EEDBBF"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 152.758L358.438 154.945V151.64L354.65 149.453V152.758Z",
    fill: "#EEDBBF"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 158.852L358.438 161.039V157.734L354.65 155.547V158.852Z",
    fill: "#EEDBBF"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 165.434L358.438 167.621V164.316L354.65 162.129V165.434Z",
    fill: "#EEDBBF"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 171.528L358.438 173.715V170.41L354.65 168.223V171.528Z",
    fill: "#EEDBBF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 103.315L358.438 105.502V102.197L354.65 100.01V103.315Z",
    fill: "#EEDBBF"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 255.717L366.295 257.905V254.6L362.507 252.412V255.717Z",
    fill: "#EEDBBF"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 261.81L366.295 263.998V260.693L362.507 258.506V261.81Z",
    fill: "#EEDBBF"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 267.905L366.295 270.093V266.788L362.507 264.6V267.905Z",
    fill: "#EEDBBF"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 249.621L366.295 251.808V248.503L362.507 246.316V249.621Z",
    fill: "#EEDBBF"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 273.999L366.295 276.187V272.882L362.507 270.695V273.999Z",
    fill: "#EEDBBF"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 224.824L366.295 227.011V223.706L362.507 221.518V224.824Z",
    fill: "#EEDBBF"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 280.094L366.295 282.281V278.976L362.507 276.789V280.094Z",
    fill: "#EEDBBF"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 231.34L366.295 233.527V230.222L362.507 228.035V231.34Z",
    fill: "#EEDBBF"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 237.434L366.295 239.621V236.316L362.507 234.129V237.434Z",
    fill: "#EEDBBF"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 243.528L366.295 245.715V242.41L362.507 240.223V243.528Z",
    fill: "#EEDBBF"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 298.799L366.295 300.986V297.682L362.507 295.494V298.799Z",
    fill: "#EEDBBF"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 286.188L366.295 288.375V285.07L362.507 282.883V286.188Z",
    fill: "#EEDBBF"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 310.987L366.295 313.175V309.87L362.507 307.682V310.987Z",
    fill: "#EEDBBF"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 292.703L366.295 294.89V291.586L362.507 289.398V292.703Z",
    fill: "#EEDBBF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 304.893L366.295 307.081V303.776L362.507 301.588V304.893Z",
    fill: "#EEDBBF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 189.81L358.438 191.998V188.693L354.65 186.506V189.81Z",
    fill: "#EEDBBF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 104.928L350.584 107.116V103.811L346.795 101.623V104.928Z",
    fill: "#EEDBBF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 111.023L350.584 113.211V109.906L346.795 107.719V111.023Z",
    fill: "#EEDBBF"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 117.117L350.584 119.304V115.999L346.795 113.812V117.117Z",
    fill: "#EEDBBF"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 136.028L350.584 138.215V134.91L346.795 132.723V136.028Z",
    fill: "#EEDBBF"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 123.84L350.584 126.028V122.723L346.795 120.535V123.84Z",
    fill: "#EEDBBF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 92.4339L350.584 94.6219V91.3169L346.795 89.1289V92.4339Z",
    fill: "#EEDBBF"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 98.7738L350.584 100.961V97.6567L346.795 95.4688V98.7738Z",
    fill: "#EEDBBF"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 129.934L350.584 132.121V128.816L346.795 126.629V129.934Z",
    fill: "#EEDBBF"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 185.268L350.584 187.456V184.151L346.795 181.963V185.268Z",
    fill: "#EEDBBF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 173.08L350.584 175.268V171.963L346.795 169.775V173.08Z",
    fill: "#EEDBBF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 179.174L350.584 181.362V178.057L346.795 175.869V179.174Z",
    fill: "#EEDBBF"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 191.364L350.584 193.551V190.246L346.795 188.059V191.364Z",
    fill: "#EEDBBF"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 142.121L350.584 144.308V141.003L346.795 138.816V142.121Z",
    fill: "#EEDBBF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 197.457L350.584 199.644V196.339L346.795 194.152V197.457Z",
    fill: "#EEDBBF"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 154.311L350.584 156.498V153.194L346.795 151.006V154.311Z",
    fill: "#EEDBBF"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 148.217L350.584 150.404V147.1L346.795 144.912V148.217Z",
    fill: "#EEDBBF"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 166.987L350.584 169.174V165.87L346.795 163.682V166.987Z",
    fill: "#EEDBBF"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 160.893L350.584 163.08V159.775L346.795 157.588V160.893Z",
    fill: "#EEDBBF"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 257.27L358.438 259.457V256.152L354.65 253.965V257.27Z",
    fill: "#EEDBBF"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 251.175L358.438 253.363V250.058L354.65 247.871V251.175Z",
    fill: "#EEDBBF"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 245.081L358.438 247.269V243.964L354.65 241.777V245.081Z",
    fill: "#EEDBBF"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 263.364L358.438 265.551V262.246L354.65 260.059V263.364Z",
    fill: "#EEDBBF"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 275.551L358.438 277.738V274.433L354.65 272.246V275.551Z",
    fill: "#EEDBBF"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 269.457L358.438 271.644V268.339L354.65 266.152V269.457Z",
    fill: "#EEDBBF"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 220.282L358.438 222.469V219.164L354.65 216.977V220.282Z",
    fill: "#EEDBBF"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 238.987L358.438 241.175V237.87L354.65 235.682V238.987Z",
    fill: "#EEDBBF"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 226.799L358.438 228.986V225.681L354.65 223.494V226.799Z",
    fill: "#EEDBBF"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 232.893L358.438 235.081V231.776L354.65 229.588V232.893Z",
    fill: "#EEDBBF"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 300.352L358.438 302.539V299.234L354.65 297.047V300.352Z",
    fill: "#EEDBBF"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 312.539L358.438 314.726V311.421L354.65 309.234V312.539Z",
    fill: "#EEDBBF"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 214.188L358.438 216.375V213.07L354.65 210.883V214.188Z",
    fill: "#EEDBBF"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 294.257L358.438 296.445V293.14L354.65 290.953V294.257Z",
    fill: "#EEDBBF"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 306.446L358.438 308.633V305.328L354.65 303.141V306.446Z",
    fill: "#EEDBBF"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 281.645L358.438 283.832V280.528L354.65 278.34V281.645Z",
    fill: "#EEDBBF"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M354.65 288.162L358.438 290.35V287.045L354.65 284.857V288.162Z",
    fill: "#EEDBBF"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 309.434L374.15 311.621V308.316L370.361 306.129V309.434Z",
    fill: "#EEDBBF"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 130.742L374.15 132.929V129.624L370.361 127.438V130.742Z",
    fill: "#EEDBBF"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 137.464L374.15 139.652V136.347L370.361 134.16V137.464Z",
    fill: "#EEDBBF"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 143.558L374.15 145.746V142.441L370.361 140.254V143.558Z",
    fill: "#EEDBBF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 149.653L374.15 151.84V148.535L370.361 146.348V149.653Z",
    fill: "#EEDBBF"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 124.648L374.15 126.836V123.531L370.361 121.344V124.648Z",
    fill: "#EEDBBF"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 106.059L374.15 108.247V104.942L370.361 102.754V106.059Z",
    fill: "#EEDBBF"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 118.553L374.15 120.741V117.436L370.361 115.248V118.553Z",
    fill: "#EEDBBF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 155.746L374.15 157.933V154.628L370.361 152.441V155.746Z",
    fill: "#EEDBBF"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 112.399L374.15 114.586V111.282L370.361 109.094V112.399Z",
    fill: "#EEDBBF"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 161.842L374.15 164.029V160.724L370.361 158.537V161.842Z",
    fill: "#EEDBBF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 198.894L374.15 201.082V197.777L370.361 195.59V198.894Z",
    fill: "#EEDBBF"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 217.176L374.15 219.363V216.058L370.361 213.871V217.176Z",
    fill: "#EEDBBF"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 192.799L374.15 194.987V191.682L370.361 189.494V192.799Z",
    fill: "#EEDBBF"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 211.082L374.15 213.269V209.964L370.361 207.777V211.082Z",
    fill: "#EEDBBF"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 204.989L374.15 207.176V203.871L370.361 201.684V204.989Z",
    fill: "#EEDBBF"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 186.705L374.15 188.893V185.588L370.361 183.4V186.705Z",
    fill: "#EEDBBF"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 167.936L374.15 170.123V166.819L370.361 164.631V167.936Z",
    fill: "#EEDBBF"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 174.518L374.15 176.706V173.4L370.361 171.213V174.518Z",
    fill: "#EEDBBF"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 180.612L374.15 182.799V179.495L370.361 177.307V180.612Z",
    fill: "#EEDBBF"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 256.466L252.782 258.654V255.349L248.993 253.162V256.466Z",
    fill: "#EEDBBF"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 262.983L252.782 265.17V261.865L248.993 259.678V262.983Z",
    fill: "#EEDBBF"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 250.37L252.782 252.558V249.253L248.993 247.066V250.37Z",
    fill: "#EEDBBF"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 269.076L252.782 271.263V267.958L248.993 265.771V269.076Z",
    fill: "#EEDBBF"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 275.172L252.782 277.359V274.055L248.993 271.867V275.172Z",
    fill: "#EEDBBF"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 244.278L252.782 246.466V243.161L248.993 240.973V244.278Z",
    fill: "#EEDBBF"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 225.994L252.782 228.181V224.876L248.993 222.689V225.994Z",
    fill: "#EEDBBF"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 232.09L252.782 234.277V230.973L248.993 228.785V232.09Z",
    fill: "#EEDBBF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 287.36L252.782 289.548V286.243L248.993 284.055V287.36Z",
    fill: "#EEDBBF"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 238.184L252.782 240.372V237.067L248.993 234.879V238.184Z",
    fill: "#EEDBBF"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 223.27L374.15 225.457V222.152L370.361 219.965V223.27Z",
    fill: "#EEDBBF"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 212.635L366.295 214.822V211.518L362.507 209.33V212.635Z",
    fill: "#EEDBBF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 299.547L252.782 301.735V298.43L248.993 296.242V299.547Z",
    fill: "#EEDBBF"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 293.452L252.782 295.64V292.335L248.993 290.148V293.452Z",
    fill: "#EEDBBF"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 305.643L252.782 307.83V304.525L248.993 302.338V305.643Z",
    fill: "#EEDBBF"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 311.737L252.782 313.924V310.619L248.993 308.432V311.737Z",
    fill: "#EEDBBF"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 126.2L366.295 128.387V125.083L362.507 122.895V126.2Z",
    fill: "#EEDBBF"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 120.106L366.295 122.293V118.988L362.507 116.801V120.106Z",
    fill: "#EEDBBF"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 139.018L366.295 141.205V137.9L362.507 135.713V139.018Z",
    fill: "#EEDBBF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 132.924L366.295 135.111V131.807L362.507 129.619V132.924Z",
    fill: "#EEDBBF"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 145.112L366.295 147.299V143.995L362.507 141.807V145.112Z",
    fill: "#EEDBBF"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 114.012L366.295 116.199V112.894L362.507 110.707V114.012Z",
    fill: "#EEDBBF"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 107.856L366.295 110.044V106.739L362.507 104.551V107.856Z",
    fill: "#EEDBBF"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 101.518L366.295 103.705V100.4L362.507 98.2129V101.518Z",
    fill: "#EEDBBF"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 176.07L366.295 178.258V174.953L362.507 172.766V176.07Z",
    fill: "#EEDBBF"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 151.205L366.295 153.393V150.088L362.507 147.9V151.205Z",
    fill: "#EEDBBF"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 188.258L366.295 190.445V187.14L362.507 184.953V188.258Z",
    fill: "#EEDBBF"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 200.446L366.295 202.633V199.328L362.507 197.141V200.446Z",
    fill: "#EEDBBF"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 182.164L366.295 184.351V181.046L362.507 178.859V182.164Z",
    fill: "#EEDBBF"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 206.541L366.295 208.728V205.424L362.507 203.236V206.541Z",
    fill: "#EEDBBF"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 194.352L366.295 196.539V193.235L362.507 191.047V194.352Z",
    fill: "#EEDBBF"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 163.394L366.295 165.581V162.276L362.507 160.088V163.394Z",
    fill: "#EEDBBF"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 229.364L374.15 231.551V228.247L370.361 226.059V229.364Z",
    fill: "#EEDBBF"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 219.901L252.782 222.088V218.783L248.993 216.596V219.901Z",
    fill: "#EEDBBF"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 157.299L366.295 159.487V156.182L362.507 153.994V157.299Z",
    fill: "#EEDBBF"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 272.446L374.15 274.633V271.329L370.361 269.141V272.446Z",
    fill: "#EEDBBF"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 266.352L374.15 268.539V265.234L370.361 263.047V266.352Z",
    fill: "#EEDBBF"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 284.634L374.15 286.822V283.517L370.361 281.33V284.634Z",
    fill: "#EEDBBF"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 278.541L374.15 280.728V277.424L370.361 275.236V278.541Z",
    fill: "#EEDBBF"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 290.729L374.15 292.917V289.612L370.361 287.424V290.729Z",
    fill: "#EEDBBF"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 260.258L374.15 262.445V259.14L370.361 256.953V260.258Z",
    fill: "#EEDBBF"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 235.881L374.15 238.069V234.764L370.361 232.576V235.881Z",
    fill: "#EEDBBF"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 254.164L374.15 256.351V253.046L370.361 250.859V254.164Z",
    fill: "#EEDBBF"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 248.07L374.15 250.258V246.953L370.361 244.766V248.07Z",
    fill: "#EEDBBF"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 241.975L374.15 244.163V240.858L370.361 238.67V241.975Z",
    fill: "#EEDBBF"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 303.34L374.15 305.527V302.222L370.361 300.035V303.34Z",
    fill: "#EEDBBF"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 203.551L350.584 205.738V202.433L346.795 200.246V203.551Z",
    fill: "#EEDBBF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M370.361 297.246L374.15 299.433V296.128L370.361 293.941V297.246Z",
    fill: "#EEDBBF"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M362.507 169.975L366.295 172.163V168.858L362.507 166.67V169.975Z",
    fill: "#EEDBBF"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 204.081L440 206.269V202.964L436.211 200.777V204.081Z",
    fill: "#EEDBBF"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 210.176L440 212.363V209.058L436.211 206.871V210.176Z",
    fill: "#EEDBBF"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 216.694L440 218.881V215.577L436.211 213.389V216.694Z",
    fill: "#EEDBBF"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 222.787L440 224.974V221.67L436.211 219.482V222.787Z",
    fill: "#EEDBBF"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 228.881L440 231.068V227.764L436.211 225.576V228.881Z",
    fill: "#EEDBBF"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 234.975L440 237.163V233.858L436.211 231.67V234.975Z",
    fill: "#EEDBBF"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 173.612L440 175.799V172.494L436.211 170.307V173.612Z",
    fill: "#EEDBBF"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 179.705L440 181.893V178.588L436.211 176.4V179.705Z",
    fill: "#EEDBBF"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 185.799L440 187.987V184.682L436.211 182.494V185.799Z",
    fill: "#EEDBBF"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 191.893L440 194.081V190.776L436.211 188.588V191.893Z",
    fill: "#EEDBBF"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 197.987L440 200.175V196.87L436.211 194.682V197.987Z",
    fill: "#EEDBBF"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 247.164L440 249.351V246.046L436.211 243.859V247.164Z",
    fill: "#EEDBBF"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 241.07L440 243.258V239.953L436.211 237.766V241.07Z",
    fill: "#EEDBBF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 284.152L440 286.34V283.035L436.211 280.848V284.152Z",
    fill: "#EEDBBF"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 278.057L440 280.245V276.94L436.211 274.752V278.057Z",
    fill: "#EEDBBF"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 296.34L440 298.527V295.222L436.211 293.035V296.34Z",
    fill: "#EEDBBF"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 290.245L440 292.433V289.128L436.211 286.941V290.245Z",
    fill: "#EEDBBF"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 271.541L440 273.728V270.424L436.211 268.236V271.541Z",
    fill: "#EEDBBF"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 167.518L440 169.705V166.4L436.211 164.213V167.518Z",
    fill: "#EEDBBF"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 253.258L440 255.445V252.14L436.211 249.953V253.258Z",
    fill: "#EEDBBF"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 259.352L440 261.539V258.234L436.211 256.047V259.352Z",
    fill: "#EEDBBF"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 265.446L440 267.633V264.328L436.211 262.141V265.446Z",
    fill: "#EEDBBF"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 313.07L447.855 315.258V311.953L444.066 309.766V313.07Z",
    fill: "#EEDBBF"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 302.434L440 304.621V301.316L436.211 299.129V302.434Z",
    fill: "#EEDBBF"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 276.082L447.855 278.269V274.964L444.066 272.777V276.082Z",
    fill: "#EEDBBF"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 209.645L350.584 211.832V208.527L346.795 206.34V209.645Z",
    fill: "#EEDBBF"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 282.6L447.855 284.787V281.483L444.066 279.295V282.6Z",
    fill: "#EEDBBF"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 300.881L447.855 303.069V299.764L444.066 297.576V300.881Z",
    fill: "#EEDBBF"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 288.694L447.855 290.881V287.577L444.066 285.389V288.694Z",
    fill: "#EEDBBF"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 294.787L447.855 296.975V293.67L444.066 291.482V294.787Z",
    fill: "#EEDBBF"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 142.305L440 144.492V141.187L436.211 139V142.305Z",
    fill: "#EEDBBF"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 136.813L440 139V135.695L436.211 133.508V136.813Z",
    fill: "#EEDBBF"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 161.424L440 163.611V160.306L436.211 158.119V161.424Z",
    fill: "#EEDBBF"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 155.328L440 157.515V154.21L436.211 152.023V155.328Z",
    fill: "#EEDBBF"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 148.399L440 150.586V147.282L436.211 145.094V148.399Z",
    fill: "#EEDBBF"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 306.976L447.855 309.164V305.859L444.066 303.672V306.976Z",
    fill: "#EEDBBF"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 236.528L432.143 238.715V235.41L428.355 233.223V236.528Z",
    fill: "#EEDBBF"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 242.621L432.143 244.808V241.503L428.355 239.316V242.621Z",
    fill: "#EEDBBF"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 248.717L432.143 250.904V247.6L428.355 245.412V248.717Z",
    fill: "#EEDBBF"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 260.905L432.143 263.092V259.788L428.355 257.6V260.905Z",
    fill: "#EEDBBF"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 254.811L432.143 256.999V253.694L428.355 251.506V254.811Z",
    fill: "#EEDBBF"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 224.339L432.143 226.527V223.222L428.355 221.035V224.339Z",
    fill: "#EEDBBF"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 212.151L432.143 214.339V211.034L428.355 208.846V212.151Z",
    fill: "#EEDBBF"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 230.433L432.143 232.621V229.316L428.355 227.129V230.433Z",
    fill: "#EEDBBF"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 218.244L432.143 220.432V217.127L428.355 214.939V218.244Z",
    fill: "#EEDBBF"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 266.998L432.143 269.186V265.881L428.355 263.693V266.998Z",
    fill: "#EEDBBF"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 310.08L432.143 312.268V308.963L428.355 306.775V310.08Z",
    fill: "#EEDBBF"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 205.635L432.143 207.822V204.518L428.355 202.33V205.635Z",
    fill: "#EEDBBF"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 303.987L432.143 306.175V302.87L428.355 300.682V303.987Z",
    fill: "#EEDBBF"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 285.703L432.143 287.89V284.585L428.355 282.398V285.703Z",
    fill: "#EEDBBF"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 297.893L432.143 300.081V296.776L428.355 294.588V297.893Z",
    fill: "#EEDBBF"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 279.61L432.143 281.797V278.492L428.355 276.305V279.61Z",
    fill: "#EEDBBF"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 273.515L432.143 275.703V272.398L428.355 270.211V273.515Z",
    fill: "#EEDBBF"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 291.799L432.143 293.986V290.681L428.355 288.494V291.799Z",
    fill: "#EEDBBF"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 132.272L432.143 134.459V131.154L428.355 128.967V132.272Z",
    fill: "#EEDBBF"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M436.211 308.528L440 310.715V307.41L436.211 305.223V308.528Z",
    fill: "#EEDBBF"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 199.541L432.143 201.728V198.423L428.355 196.236V199.541Z",
    fill: "#EEDBBF"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 175.163L432.143 177.35V174.045L428.355 171.857V175.163Z",
    fill: "#EEDBBF"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 181.258L432.143 183.445V180.14L428.355 177.953V181.258Z",
    fill: "#EEDBBF"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 187.352L432.143 189.539V186.234L428.355 184.047V187.352Z",
    fill: "#EEDBBF"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 169.069L432.143 171.257V167.952L428.355 165.764V169.069Z",
    fill: "#EEDBBF"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 193.446L432.143 195.633V192.328L428.355 190.141V193.446Z",
    fill: "#EEDBBF"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 156.881L432.143 159.069V155.763L428.355 153.576V156.881Z",
    fill: "#EEDBBF"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 162.975L432.143 165.163V161.858L428.355 159.67V162.975Z",
    fill: "#EEDBBF"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 150.787L432.143 152.974V149.669L428.355 147.482V150.787Z",
    fill: "#EEDBBF"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 143.859L432.143 146.046V142.741L428.355 140.553V143.859Z",
    fill: "#EEDBBF"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M428.355 137.764L432.143 139.952V136.647L428.355 134.459V137.764Z",
    fill: "#EEDBBF"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 182.694L455.711 184.882V181.577L451.922 179.389V182.694Z",
    fill: "#EEDBBF"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 151.389L455.711 153.577V150.272L451.922 148.084V151.389Z",
    fill: "#EEDBBF"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 157.483L455.711 159.671V156.366L451.922 154.178V157.483Z",
    fill: "#EEDBBF"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 170.506L455.711 172.693V169.388L451.922 167.201V170.506Z",
    fill: "#EEDBBF"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 176.6L455.711 178.788V175.483L451.922 173.295V176.6Z",
    fill: "#EEDBBF"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 164.412L455.711 166.599V163.295L451.922 161.107V164.412Z",
    fill: "#EEDBBF"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 250.153L455.711 252.34V249.035L451.922 246.848V250.153Z",
    fill: "#EEDBBF"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 145.897L455.711 148.084V144.779L451.922 142.592V145.897Z",
    fill: "#EEDBBF"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 225.776L455.711 227.964V224.659L451.922 222.471V225.776Z",
    fill: "#EEDBBF"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 231.869L455.711 234.057V230.752L451.922 228.564V231.869Z",
    fill: "#EEDBBF"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 237.964L455.711 240.152V236.847L451.922 234.66V237.964Z",
    fill: "#EEDBBF"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 219.26L455.711 221.447V218.143L451.922 215.955V219.26Z",
    fill: "#EEDBBF"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 244.058L455.711 246.246V242.941L451.922 240.754V244.058Z",
    fill: "#EEDBBF"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 194.882L455.711 197.07V193.765L451.922 191.578V194.882Z",
    fill: "#EEDBBF"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 188.787L455.711 190.975V187.67L451.922 185.482V188.787Z",
    fill: "#EEDBBF"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 200.976L455.711 203.164V199.859L451.922 197.672V200.976Z",
    fill: "#EEDBBF"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 213.166L455.711 215.353V212.048L451.922 209.861V213.166Z",
    fill: "#EEDBBF"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 207.071L455.711 209.258V205.953L451.922 203.766V207.071Z",
    fill: "#EEDBBF"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 246.633L350.584 248.82V245.515L346.795 243.328V246.633Z",
    fill: "#EEDBBF"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 252.727L350.584 254.914V251.609L346.795 249.422V252.727Z",
    fill: "#EEDBBF"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 264.916L350.584 267.104V263.799L346.795 261.611V264.916Z",
    fill: "#EEDBBF"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 258.821L350.584 261.008V257.703L346.795 255.516V258.821Z",
    fill: "#EEDBBF"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 271.009L350.584 273.197V269.892L346.795 267.705V271.009Z",
    fill: "#EEDBBF"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 222.257L350.584 224.445V221.14L346.795 218.953V222.257Z",
    fill: "#EEDBBF"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 215.739L350.584 217.926V214.622L346.795 212.434V215.739Z",
    fill: "#EEDBBF"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 228.351L350.584 230.539V227.234L346.795 225.047V228.351Z",
    fill: "#EEDBBF"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 234.445L350.584 236.633V233.328L346.795 231.141V234.445Z",
    fill: "#EEDBBF"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 240.539L350.584 242.726V239.421L346.795 237.234V240.539Z",
    fill: "#EEDBBF"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 269.988L447.855 272.176V268.871L444.066 266.684V269.988Z",
    fill: "#EEDBBF"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 307.996L350.584 310.183V306.878L346.795 304.691V307.996Z",
    fill: "#EEDBBF"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 277.104L350.584 279.292V275.987L346.795 273.799V277.104Z",
    fill: "#EEDBBF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 283.621L350.584 285.808V282.503L346.795 280.316V283.621Z",
    fill: "#EEDBBF"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 289.715L350.584 291.902V288.597L346.795 286.41V289.715Z",
    fill: "#EEDBBF"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 295.809L350.584 297.996V294.691L346.795 292.504V295.809Z",
    fill: "#EEDBBF"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M346.795 301.903L350.584 304.09V300.785L346.795 298.598V301.903Z",
    fill: "#EEDBBF"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 178.152L447.855 180.34V177.035L444.066 174.848V178.152Z",
    fill: "#EEDBBF"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 184.246L447.855 186.433V183.128L444.066 180.941V184.246Z",
    fill: "#EEDBBF"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 196.436L447.855 198.624V195.319L444.066 193.131V196.436Z",
    fill: "#EEDBBF"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 172.058L447.855 174.246V170.941L444.066 168.754V172.058Z",
    fill: "#EEDBBF"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 190.342L447.855 192.529V189.224L444.066 187.037V190.342Z",
    fill: "#EEDBBF"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 146.848L447.855 149.035V145.73L444.066 143.543V146.848Z",
    fill: "#EEDBBF"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 202.53L447.855 204.717V201.413L444.066 199.225V202.53Z",
    fill: "#EEDBBF"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 152.942L447.855 155.129V151.824L444.066 149.637V152.942Z",
    fill: "#EEDBBF"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 165.964L447.855 168.152V164.847L444.066 162.66V165.964Z",
    fill: "#EEDBBF"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 159.869L447.855 162.057V158.752L444.066 156.564V159.869Z",
    fill: "#EEDBBF"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 227.328L447.855 229.515V226.21L444.066 224.023V227.328Z",
    fill: "#EEDBBF"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 245.612L447.855 247.799V244.495L444.066 242.307V245.612Z",
    fill: "#EEDBBF"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 251.705L447.855 253.893V250.588L444.066 248.4V251.705Z",
    fill: "#EEDBBF"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 239.518L447.855 241.705V238.401L444.066 236.213V239.518Z",
    fill: "#EEDBBF"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 257.799L447.855 259.987V256.682L444.066 254.494V257.799Z",
    fill: "#EEDBBF"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 263.894L447.855 266.082V262.777L444.066 260.59V263.894Z",
    fill: "#EEDBBF"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 208.623L447.855 210.811V207.506L444.066 205.318V208.623Z",
    fill: "#EEDBBF"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 233.424L447.855 235.611V232.306L444.066 230.119V233.424Z",
    fill: "#EEDBBF"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 214.717L447.855 216.905V213.6L444.066 211.412V214.717Z",
    fill: "#EEDBBF"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 221.235L447.855 223.422V220.117L444.066 217.93V221.235Z",
    fill: "#EEDBBF"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M444.066 141.355L447.855 143.543V140.238L444.066 138.051V141.355Z",
    fill: "#EEDBBF"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 299.328L455.711 301.515V298.21L451.922 296.023V299.328Z",
    fill: "#EEDBBF"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 293.235L455.711 295.422V292.117L451.922 289.93V293.235Z",
    fill: "#EEDBBF"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 256.246L455.711 258.433V255.128L451.922 252.941V256.246Z",
    fill: "#EEDBBF"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 287.141L455.711 289.328V286.023L451.922 283.836V287.141Z",
    fill: "#EEDBBF"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 311.518L455.711 313.705V310.401L451.922 308.213V311.518Z",
    fill: "#EEDBBF"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 305.424L455.711 307.612V304.306L451.922 302.119V305.424Z",
    fill: "#EEDBBF"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 262.342L455.711 264.53V261.225L451.922 259.037V262.342Z",
    fill: "#EEDBBF"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 268.436L455.711 270.623V267.319L451.922 265.131V268.436Z",
    fill: "#EEDBBF"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 280.625L455.711 282.812V279.507L451.922 277.32V280.625Z",
    fill: "#EEDBBF"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M451.922 274.53L455.711 276.718V273.413L451.922 271.225V274.53Z",
    fill: "#EEDBBF"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 281.266L252.782 283.454V280.149L248.993 277.961V281.266Z",
    fill: "#EEDBBF"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 312.727L102.862 314.914V311.61L99.0742 309.422V312.727Z",
    fill: "#EEDBBF"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 282.256L102.862 284.444V281.139L99.0742 278.951V282.256Z",
    fill: "#EEDBBF"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 288.35L102.862 290.538V287.233L99.0742 285.045V288.35Z",
    fill: "#EEDBBF"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 276.162L102.862 278.349V275.045L99.0742 272.857V276.162Z",
    fill: "#EEDBBF"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 300.539L102.862 302.726V299.421L99.0742 297.234V300.539Z",
    fill: "#EEDBBF"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 306.633L102.862 308.82V305.515L99.0742 303.328V306.633Z",
    fill: "#EEDBBF"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 294.445L102.862 296.633V293.328L99.0742 291.141V294.445Z",
    fill: "#EEDBBF"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 142.799L95.0078 144.986V141.681L91.2188 139.494V142.799Z",
    fill: "#EEDBBF"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 136.702L95.0078 138.89V135.585L91.2188 133.398V136.702Z",
    fill: "#EEDBBF"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 148.893L95.0078 151.08V147.775L91.2188 145.588V148.893Z",
    fill: "#EEDBBF"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 130.611L95.0078 132.798V129.493L91.2188 127.305V130.611Z",
    fill: "#EEDBBF"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 154.987L95.0078 157.174V153.869L91.2188 151.682V154.987Z",
    fill: "#EEDBBF"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 124.516L95.0078 126.704V123.399L91.2188 121.211V124.516Z",
    fill: "#EEDBBF"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 106.233L95.0078 108.42V105.116L91.2188 102.928V106.233Z",
    fill: "#EEDBBF"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 100.139L95.0078 102.326V99.021L91.2188 96.834V100.139Z",
    fill: "#EEDBBF"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 112.326L95.0078 114.514V111.209L91.2188 109.021V112.326Z",
    fill: "#EEDBBF"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 118.422L95.0078 120.61V117.305L91.2188 115.117V118.422Z",
    fill: "#EEDBBF"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 171.717L102.862 173.904V170.599L99.0742 168.412V171.717Z",
    fill: "#EEDBBF"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 177.811L102.862 179.998V176.693L99.0742 174.506V177.811Z",
    fill: "#EEDBBF"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 183.905L102.862 186.092V182.788L99.0742 180.6V183.905Z",
    fill: "#EEDBBF"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 161.08L95.0078 163.267V159.963L91.2188 157.775V161.08Z",
    fill: "#EEDBBF"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 189.998L102.862 192.186V188.881L99.0742 186.693V189.998Z",
    fill: "#EEDBBF"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 270.069L102.862 272.256V268.952L99.0742 266.764V270.069Z",
    fill: "#EEDBBF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 202.61L102.862 204.797V201.492L99.0742 199.305V202.61Z",
    fill: "#EEDBBF"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 165.621L102.862 167.808V164.503L99.0742 162.316V165.621Z",
    fill: "#EEDBBF"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 147.339L102.862 149.527V146.222L99.0742 144.035V147.339Z",
    fill: "#EEDBBF"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 153.433L102.862 155.621V152.316L99.0742 150.129V153.433Z",
    fill: "#EEDBBF"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 159.528L102.862 161.715V158.41L99.0742 156.223V159.528Z",
    fill: "#EEDBBF"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 196.092L102.862 198.28V194.975L99.0742 192.787V196.092Z",
    fill: "#EEDBBF"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 251.363L102.862 253.551V250.246L99.0742 248.059V251.363Z",
    fill: "#EEDBBF"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 245.269L102.862 247.457V244.152L99.0742 241.965V245.269Z",
    fill: "#EEDBBF"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 257.457L102.862 259.644V256.339L99.0742 254.152V257.457Z",
    fill: "#EEDBBF"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 208.703L102.862 210.89V207.585L99.0742 205.398V208.703Z",
    fill: "#EEDBBF"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 239.174L102.862 241.362V238.057L99.0742 235.869V239.174Z",
    fill: "#EEDBBF"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 263.975L102.862 266.162V262.857L99.0742 260.67V263.975Z",
    fill: "#EEDBBF"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 220.893L102.862 223.08V219.775L99.0742 217.588V220.893Z",
    fill: "#EEDBBF"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 214.799L102.862 216.986V213.681L99.0742 211.494V214.799Z",
    fill: "#EEDBBF"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 233.08L102.862 235.267V231.963L99.0742 229.775V233.08Z",
    fill: "#EEDBBF"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 226.987L102.862 229.174V225.87L99.0742 223.682V226.987Z",
    fill: "#EEDBBF"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 144.495L188.615 146.683V143.378L184.826 141.191V144.495Z",
    fill: "#EEDBBF"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 77.4613L188.615 79.6483V76.3433L184.826 74.1562V77.4613Z",
    fill: "#EEDBBF"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 71.3675L188.615 73.5545V70.2495L184.826 68.0625V71.3675Z",
    fill: "#EEDBBF"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 83.555L188.615 85.743V82.438L184.826 80.25V83.555Z",
    fill: "#EEDBBF"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 95.7425L188.615 97.9305V94.6255L184.826 92.4375V95.7425Z",
    fill: "#EEDBBF"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 89.6488L188.615 91.8367V88.5317L184.826 86.3438V89.6488Z",
    fill: "#EEDBBF"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 65.2738L188.615 67.4607V64.1557L184.826 61.9688V65.2738Z",
    fill: "#EEDBBF"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 308.186L95.0078 310.374V307.069L91.2188 304.881V308.186Z",
    fill: "#EEDBBF"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 302.092L95.0078 304.28V300.975L91.2188 298.787V302.092Z",
    fill: "#EEDBBF"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 138.403L188.615 140.591V137.286L184.826 135.098V138.403Z",
    fill: "#EEDBBF"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 141.244L102.862 143.432V140.127L99.0742 137.939V141.244Z",
    fill: "#EEDBBF"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 157.172L188.615 159.36V156.055L184.826 153.867V157.172Z",
    fill: "#EEDBBF"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 167.174L95.0078 169.362V166.057L91.2188 163.869V167.174Z",
    fill: "#EEDBBF"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 101.838L188.615 104.025V100.72L184.826 98.5332V101.838Z",
    fill: "#EEDBBF"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 151.078L188.615 153.266V149.961L184.826 147.773V151.078Z",
    fill: "#EEDBBF"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 126.215L188.615 128.402V125.098L184.826 122.91V126.215Z",
    fill: "#EEDBBF"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 114.026L188.615 116.213V112.908L184.826 110.721V114.026Z",
    fill: "#EEDBBF"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 107.931L188.615 110.119V106.814L184.826 104.627V107.931Z",
    fill: "#EEDBBF"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 120.119L188.615 122.306V119.001L184.826 116.814V120.119Z",
    fill: "#EEDBBF"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 132.309L188.615 134.496V131.192L184.826 129.004V132.309Z",
    fill: "#EEDBBF"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 198.069L95.0078 200.256V196.952L91.2188 194.764V198.069Z",
    fill: "#EEDBBF"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 210.256L95.0078 212.444V209.139L91.2188 206.951V210.256Z",
    fill: "#EEDBBF"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 204.162L95.0078 206.349V203.045L91.2188 200.857V204.162Z",
    fill: "#EEDBBF"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 216.35L95.0078 218.538V215.233L91.2188 213.045V216.35Z",
    fill: "#EEDBBF"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 222.445L95.0078 224.633V221.328L91.2188 219.141V222.445Z",
    fill: "#EEDBBF"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 191.551L95.0078 193.738V190.433L91.2188 188.246V191.551Z",
    fill: "#EEDBBF"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 173.268L95.0078 175.456V172.151L91.2188 169.963V173.268Z",
    fill: "#EEDBBF"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 179.363L95.0078 181.551V178.246L91.2188 176.059V179.363Z",
    fill: "#EEDBBF"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 185.456L95.0078 187.644V184.339L91.2188 182.152V185.456Z",
    fill: "#EEDBBF"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 228.538L95.0078 230.726V227.421L91.2188 225.234V228.538Z",
    fill: "#EEDBBF"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 289.903L95.0078 292.09V288.785L91.2188 286.598V289.903Z",
    fill: "#EEDBBF"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 271.62L95.0078 273.808V270.503L91.2188 268.316V271.62Z",
    fill: "#EEDBBF"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 277.715L95.0078 279.902V276.597L91.2188 274.41V277.715Z",
    fill: "#EEDBBF"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 265.526L95.0078 267.714V264.409L91.2188 262.221V265.526Z",
    fill: "#EEDBBF"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 295.996L95.0078 298.183V294.878L91.2188 292.691V295.996Z",
    fill: "#EEDBBF"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 283.809L95.0078 285.996V282.691L91.2188 280.504V283.809Z",
    fill: "#EEDBBF"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 252.916L95.0078 255.103V251.798L91.2188 249.611V252.916Z",
    fill: "#EEDBBF"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 259.432L95.0078 261.62V258.315L91.2188 256.127V259.432Z",
    fill: "#EEDBBF"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 246.821L95.0078 249.008V245.703L91.2188 243.516V246.821Z",
    fill: "#EEDBBF"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 240.727L95.0078 242.914V239.609L91.2188 237.422V240.727Z",
    fill: "#EEDBBF"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2188 234.633L95.0078 236.82V233.515L91.2188 231.328V234.633Z",
    fill: "#EEDBBF"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 269.945L45.1689 267.758V264.453L41.3799 266.641V269.945Z",
    fill: "#EEDBBF"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 290.616L52.288 288.428V285.123L48.5 287.311V290.616Z",
    fill: "#EEDBBF"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 265.816L52.288 263.629V260.324L48.5 262.511V265.816Z",
    fill: "#EEDBBF"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 284.522L52.288 282.334V279.029L48.5 281.217V284.522Z",
    fill: "#EEDBBF"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 278.004L52.288 275.817V272.512L48.5 274.699V278.004Z",
    fill: "#EEDBBF"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 223.156L52.288 220.969V217.664L48.5 219.851V223.156Z",
    fill: "#EEDBBF"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 229.25L52.288 227.063V223.758L48.5 225.946V229.25Z",
    fill: "#EEDBBF"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 235.344L52.288 233.157V229.852L48.5 232.04V235.344Z",
    fill: "#EEDBBF"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 247.534L52.288 245.346V242.041L48.5 244.229V247.534Z",
    fill: "#EEDBBF"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 241.44L52.288 239.252V235.947L48.5 238.135V241.44Z",
    fill: "#EEDBBF"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 253.627L52.288 251.439V248.135L48.5 250.322V253.627Z",
    fill: "#EEDBBF"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 271.91L52.288 269.723V266.418L48.5 268.605V271.91Z",
    fill: "#EEDBBF"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 296.71L52.288 294.522V291.217L48.5 293.405V296.71Z",
    fill: "#EEDBBF"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 308.898L52.288 306.711V303.406L48.5 305.593V308.898Z",
    fill: "#EEDBBF"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 302.803L52.288 300.616V297.311L48.5 299.498V302.803Z",
    fill: "#EEDBBF"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 314.992L52.288 312.805V309.5L48.5 311.687V314.992Z",
    fill: "#EEDBBF"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 259.721L52.288 257.534V254.229L48.5 256.416V259.721Z",
    fill: "#EEDBBF"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 143.023L52.288 140.835V137.531L48.5 139.718V143.023Z",
    fill: "#EEDBBF"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 149.117L52.288 146.93V143.625L48.5 145.812V149.117Z",
    fill: "#EEDBBF"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 136.928L52.288 134.741V131.436L48.5 133.624V136.928Z",
    fill: "#EEDBBF"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 173.98L52.288 171.793V168.488L48.5 170.675V173.98Z",
    fill: "#EEDBBF"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 198.357L52.288 196.17V192.865L48.5 195.053V198.357Z",
    fill: "#EEDBBF"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 192.262L52.288 190.075V186.77L48.5 188.958V192.262Z",
    fill: "#EEDBBF"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 210.545L52.288 208.358V205.053L48.5 207.24V210.545Z",
    fill: "#EEDBBF"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 186.168L52.288 183.981V180.676L48.5 182.864V186.168Z",
    fill: "#EEDBBF"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 204.451L52.288 202.263V198.959L48.5 201.146V204.451Z",
    fill: "#EEDBBF"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 161.793L52.288 159.606V156.301L48.5 158.488V161.793Z",
    fill: "#EEDBBF"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 167.887L52.288 165.7V162.395L48.5 164.582V167.887Z",
    fill: "#EEDBBF"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 155.211L52.288 153.023V149.719L48.5 151.906V155.211Z",
    fill: "#EEDBBF"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 216.638L52.288 214.45V211.146L48.5 213.333V216.638Z",
    fill: "#EEDBBF"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 180.074L52.288 177.887V174.582L48.5 176.769V180.074Z",
    fill: "#EEDBBF"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 202.486L45.1689 200.298V196.994L41.3799 199.181V202.486Z",
    fill: "#EEDBBF"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 306.931L45.1689 304.744V301.439L41.3799 303.626V306.931Z",
    fill: "#EEDBBF"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 300.838L45.1689 298.651V295.346L41.3799 297.533V300.838Z",
    fill: "#EEDBBF"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 313.028L45.1689 310.84V307.535L41.3799 309.723V313.028Z",
    fill: "#EEDBBF"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 294.744L45.1689 292.557V289.252L41.3799 291.439V294.744Z",
    fill: "#EEDBBF"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 288.65L45.1689 286.463V283.158L41.3799 285.345V288.65Z",
    fill: "#EEDBBF"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 163.266L188.615 165.454V162.149L184.826 159.961V163.266Z",
    fill: "#EEDBBF"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 276.04L45.1689 273.852V270.547L41.3799 272.735V276.04Z",
    fill: "#EEDBBF"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 282.134L45.1689 279.946V276.641L41.3799 278.829V282.134Z",
    fill: "#EEDBBF"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 129.057L102.862 131.244V127.94L99.0742 125.752V129.057Z",
    fill: "#EEDBBF"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 116.869L102.862 119.056V115.751L99.0742 113.564V116.869Z",
    fill: "#EEDBBF"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 122.963L102.862 125.15V121.845L99.0742 119.658V122.963Z",
    fill: "#EEDBBF"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 263.849L45.1689 261.662V258.357L41.3799 260.545V263.849Z",
    fill: "#EEDBBF"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 104.682L102.862 106.869V103.564L99.0742 101.377V104.682Z",
    fill: "#EEDBBF"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 110.776L102.862 112.963V109.658L99.0742 107.471V110.776Z",
    fill: "#EEDBBF"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 245.568L45.1689 243.381V240.076L41.3799 242.263V245.568Z",
    fill: "#EEDBBF"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 159.34L45.1689 157.153V153.848L41.3799 156.036V159.34Z",
    fill: "#EEDBBF"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 165.922L45.1689 163.735V160.43L41.3799 162.617V165.922Z",
    fill: "#EEDBBF"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 172.015L45.1689 169.828V166.523L41.3799 168.711V172.015Z",
    fill: "#EEDBBF"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 184.204L45.1689 182.016V178.711L41.3799 180.899V184.204Z",
    fill: "#EEDBBF"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 178.11L45.1689 175.922V172.617L41.3799 174.805V178.11Z",
    fill: "#EEDBBF"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 190.299L45.1689 188.111V184.807L41.3799 186.994V190.299Z",
    fill: "#EEDBBF"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 141.056L45.1689 138.868V135.564L41.3799 137.751V141.056Z",
    fill: "#EEDBBF"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 131.776L36.7275 133.963V130.659L32.9385 128.471V131.776Z",
    fill: "#FFE7C4"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 122.693L21.0155 124.881V121.576L17.2275 119.389V122.693Z",
    fill: "#FFE7C4"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 127.235L28.873 129.423V126.118L25.084 123.93V127.235Z",
    fill: "#FFE7C4"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 130.855L52.288 128.668V125.363L48.5 127.551V130.855Z",
    fill: "#EEDBBF"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 134.984L45.1689 132.796V129.492L41.3799 131.679V134.984Z",
    fill: "#EEDBBF"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 125.703L36.7275 127.89V124.585L32.9385 122.398V125.703Z",
    fill: "#FFE7C4"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 116.619L21.0155 118.807V115.502L17.2275 113.314V116.619Z",
    fill: "#FFE7C4"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 121.16L28.873 123.347V120.043L25.084 117.855V121.16Z",
    fill: "#FFE7C4"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 124.781L52.288 122.594V119.289L48.5 121.476V124.781Z",
    fill: "#EEDBBF"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 128.91L45.1689 126.723V123.418L41.3799 125.606V128.91Z",
    fill: "#EEDBBF"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 153.246L45.1689 151.059V147.754L41.3799 149.941V153.246Z",
    fill: "#EEDBBF"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 147.152L45.1689 144.965V141.66L41.3799 143.847V147.152Z",
    fill: "#EEDBBF"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 220.769L45.1689 218.582V215.277L41.3799 217.465V220.769Z",
    fill: "#EEDBBF"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 227.285L45.1689 225.098V221.793L41.3799 223.981V227.285Z",
    fill: "#EEDBBF"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 239.474L45.1689 237.287V233.982L41.3799 236.169V239.474Z",
    fill: "#EEDBBF"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 233.38L45.1689 231.193V227.889L41.3799 230.076V233.38Z",
    fill: "#EEDBBF"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 196.392L45.1689 194.205V190.9L41.3799 193.087V196.392Z",
    fill: "#EEDBBF"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 251.662L45.1689 249.475V246.17L41.3799 248.357V251.662Z",
    fill: "#EEDBBF"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0742 135.151L102.862 137.339V134.034L99.0742 131.846V135.151Z",
    fill: "#EEDBBF"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 208.58L45.1689 206.393V203.088L41.3799 205.275V208.58Z",
    fill: "#EEDBBF"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 214.674L45.1689 212.487V209.182L41.3799 211.369V214.674Z",
    fill: "#EEDBBF"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 257.756L45.1689 255.569V252.264L41.3799 254.451V257.756Z",
    fill: "#EEDBBF"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 176.819L252.782 179.006V175.701L248.993 173.514V176.819Z",
    fill: "#EEDBBF"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 283.006L172.904 285.193V281.888L169.115 279.701V283.006Z",
    fill: "#EEDBBF"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 301.287L172.904 303.475V300.17L169.115 297.982V301.287Z",
    fill: "#EEDBBF"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 289.1L172.904 291.287V287.982L169.115 285.795V289.1Z",
    fill: "#EEDBBF"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 295.194L172.904 297.382V294.077L169.115 291.889V295.194Z",
    fill: "#EEDBBF"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 307.383L172.904 309.571V306.266L169.115 304.078V307.383Z",
    fill: "#EEDBBF"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 156.985L260.639 159.172V155.867L256.85 153.68V156.985Z",
    fill: "#EEDBBF"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 163.078L260.639 165.266V161.961L256.85 159.773V163.078Z",
    fill: "#EEDBBF"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 150.891L260.639 153.078V149.773L256.85 147.586V150.891Z",
    fill: "#EEDBBF"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 175.267L260.639 177.454V174.149L256.85 171.961V175.267Z",
    fill: "#EEDBBF"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 169.361L188.615 171.549V168.244L184.826 166.057V169.361Z",
    fill: "#EEDBBF"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 138.7L260.639 140.888V137.583L256.85 135.396V138.7Z",
    fill: "#EEDBBF"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 144.797L260.639 146.984V143.679L256.85 141.492V144.797Z",
    fill: "#EEDBBF"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 209.453L172.904 211.641V208.336L169.115 206.148V209.453Z",
    fill: "#EEDBBF"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 184.655L172.904 186.842V183.537L169.115 181.35V184.655Z",
    fill: "#EEDBBF"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 190.748L172.904 192.935V189.63L169.115 187.443V190.748Z",
    fill: "#EEDBBF"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 196.842L172.904 199.029V195.724L169.115 193.537V196.842Z",
    fill: "#EEDBBF"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 203.36L172.904 205.548V202.243L169.115 200.055V203.36Z",
    fill: "#EEDBBF"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 148.09L172.904 150.277V146.973L169.115 144.785V148.09Z",
    fill: "#EEDBBF"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 178.561L172.904 180.748V177.443L169.115 175.256V178.561Z",
    fill: "#EEDBBF"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 160.278L172.904 162.466V159.161L169.115 156.973V160.278Z",
    fill: "#EEDBBF"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 276.912L172.904 279.099V275.794L169.115 273.607V276.912Z",
    fill: "#EEDBBF"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 166.37L172.904 168.558V165.253L169.115 163.066V166.37Z",
    fill: "#EEDBBF"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 172.467L172.904 174.654V171.349L169.115 169.162V172.467Z",
    fill: "#EEDBBF"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 154.184L172.904 156.371V153.067L169.115 150.879V154.184Z",
    fill: "#EEDBBF"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 258.207L172.904 260.395V257.09L169.115 254.902V258.207Z",
    fill: "#EEDBBF"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 252.112L172.904 254.3V250.995L169.115 248.807V252.112Z",
    fill: "#EEDBBF"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 270.819L172.904 273.006V269.701L169.115 267.514V270.819Z",
    fill: "#EEDBBF"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 264.724L172.904 266.912V263.607L169.115 261.42V264.724Z",
    fill: "#EEDBBF"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 246.018L172.904 248.205V244.901L169.115 242.713V246.018Z",
    fill: "#EEDBBF"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 227.737L172.904 229.924V226.619L169.115 224.432V227.737Z",
    fill: "#EEDBBF"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 239.924L172.904 242.111V238.806L169.115 236.619V239.924Z",
    fill: "#EEDBBF"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 221.643L172.904 223.83V220.525L169.115 218.338V221.643Z",
    fill: "#EEDBBF"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 215.548L172.904 217.736V214.431L169.115 212.244V215.548Z",
    fill: "#EEDBBF"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 233.83L172.904 236.017V232.712L169.115 230.525V233.83Z",
    fill: "#EEDBBF"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 181.361L260.639 183.549V180.244L256.85 178.057V181.361Z",
    fill: "#EEDBBF"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 146.348L252.782 148.536V145.231L248.993 143.043V146.348Z",
    fill: "#EEDBBF"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 140.254L252.782 142.442V139.136L248.993 136.949V140.254Z",
    fill: "#EEDBBF"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 134.16L252.782 136.347V133.042L248.993 130.855V134.16Z",
    fill: "#EEDBBF"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 182.912L252.782 185.099V181.794L248.993 179.607V182.912Z",
    fill: "#EEDBBF"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 152.442L252.782 154.63V151.325L248.993 149.137V152.442Z",
    fill: "#EEDBBF"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 195.102L252.782 197.29V193.985L248.993 191.797V195.102Z",
    fill: "#EEDBBF"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 201.618L252.782 203.806V200.501L248.993 198.314V201.618Z",
    fill: "#EEDBBF"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 207.713L252.782 209.9V206.595L248.993 204.408V207.713Z",
    fill: "#EEDBBF"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 189.008L252.782 191.195V187.891L248.993 185.703V189.008Z",
    fill: "#EEDBBF"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 213.807L252.782 215.994V212.689L248.993 210.502V213.807Z",
    fill: "#EEDBBF"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 164.631L252.782 166.818V163.513L248.993 161.326V164.631Z",
    fill: "#EEDBBF"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 158.535L252.782 160.723V157.418L248.993 155.23V158.535Z",
    fill: "#EEDBBF"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 126.387L260.639 128.574V125.269L256.85 123.082V126.387Z",
    fill: "#EEDBBF"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 132.481L260.639 134.668V131.363L256.85 129.176V132.481Z",
    fill: "#EEDBBF"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 120.293L260.639 122.48V119.175L256.85 116.988V120.293Z",
    fill: "#EEDBBF"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 108.104L260.639 110.292V106.987L256.85 104.799V108.104Z",
    fill: "#EEDBBF"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 114.198L260.639 116.386V113.081L256.85 110.893V114.198Z",
    fill: "#EEDBBF"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 115.752L252.782 117.939V114.634L248.993 112.447V115.752Z",
    fill: "#EEDBBF"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 109.657L252.782 111.844V108.539L248.993 106.352V109.657Z",
    fill: "#EEDBBF"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 103.563L252.782 105.75V102.445L248.993 100.258V103.563Z",
    fill: "#EEDBBF"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 121.846L252.782 124.034V120.729L248.993 118.541V121.846Z",
    fill: "#EEDBBF"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 101.953L260.639 104.14V100.835L256.85 98.6484V101.953Z",
    fill: "#EEDBBF"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 95.8587L260.639 98.0467V94.7417L256.85 92.5547V95.8587Z",
    fill: "#EEDBBF"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 89.764L260.639 91.952V88.647L256.85 86.459V89.764Z",
    fill: "#EEDBBF"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 91.3167L252.782 93.5037V90.1987L248.993 88.0117V91.3167Z",
    fill: "#EEDBBF"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 85.223L252.782 87.41V84.105L248.993 81.918V85.223Z",
    fill: "#EEDBBF"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 97.4105L252.782 99.5975V96.2935L248.993 94.1055V97.4105Z",
    fill: "#EEDBBF"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 127.94L252.782 130.128V126.823L248.993 124.635V127.94Z",
    fill: "#EEDBBF"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M248.993 170.725L252.782 172.912V169.607L248.993 167.42V170.725Z",
    fill: "#EEDBBF"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 304.09L260.639 306.278V302.973L256.85 300.785V304.09Z",
    fill: "#EEDBBF"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 230.537L260.639 232.724V229.419L256.85 227.232V230.537Z",
    fill: "#EEDBBF"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 224.443L260.639 226.631V223.326L256.85 221.139V224.443Z",
    fill: "#EEDBBF"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 242.725L260.639 244.912V241.607L256.85 239.42V242.725Z",
    fill: "#EEDBBF"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 218.348L260.639 220.536V217.231L256.85 215.043V218.348Z",
    fill: "#EEDBBF"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 236.631L260.639 238.818V235.513L256.85 233.326V236.631Z",
    fill: "#EEDBBF"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 193.549L260.639 195.736V192.431L256.85 190.244V193.549Z",
    fill: "#EEDBBF"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 199.643L260.639 201.83V198.525L256.85 196.338V199.643Z",
    fill: "#EEDBBF"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 248.819L260.639 251.006V247.701L256.85 245.514V248.819Z",
    fill: "#EEDBBF"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 206.16L260.639 208.347V205.043L256.85 202.855V206.16Z",
    fill: "#EEDBBF"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 212.254L260.639 214.442V211.137L256.85 208.949V212.254Z",
    fill: "#EEDBBF"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 187.455L260.639 189.642V186.337L256.85 184.15V187.455Z",
    fill: "#EEDBBF"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 291.901L260.639 294.088V290.783L256.85 288.596V291.901Z",
    fill: "#EEDBBF"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 297.994L260.639 300.182V296.877L256.85 294.689V297.994Z",
    fill: "#EEDBBF"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 254.912L260.639 257.1V253.794L256.85 251.607V254.912Z",
    fill: "#EEDBBF"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 310.184L260.639 312.372V309.067L256.85 306.879V310.184Z",
    fill: "#EEDBBF"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 285.807L260.639 287.994V284.689L256.85 282.502V285.807Z",
    fill: "#EEDBBF"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 267.524L260.639 269.712V266.407L256.85 264.219V267.524Z",
    fill: "#EEDBBF"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 279.713L260.639 281.9V278.595L256.85 276.408V279.713Z",
    fill: "#EEDBBF"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 261.008L260.639 263.196V259.891L256.85 257.703V261.008Z",
    fill: "#EEDBBF"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 273.619L260.639 275.806V272.501L256.85 270.314V273.619Z",
    fill: "#EEDBBF"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85 169.172L260.639 171.36V168.055L256.85 165.867V169.172Z",
    fill: "#EEDBBF"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 85.1067L180.76 87.2947V83.9897L176.972 81.8027V85.1067Z",
    fill: "#EEDBBF"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 60.7308L180.76 62.9178V59.6138L176.972 57.4258V60.7308Z",
    fill: "#EEDBBF"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 66.8245L180.76 69.0125V65.7075L176.972 63.5195V66.8245Z",
    fill: "#EEDBBF"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 79.013L180.76 81.201V77.896L176.972 75.709V79.013Z",
    fill: "#EEDBBF"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 72.9202L180.76 75.1082V71.8032L176.972 69.6152V72.9202Z",
    fill: "#EEDBBF"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 304.278L188.615 306.465V303.16L184.826 300.973V304.278Z",
    fill: "#EEDBBF"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 310.371L188.615 312.558V309.253L184.826 307.066V310.371Z",
    fill: "#EEDBBF"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 121.672L180.76 123.86V120.555L176.972 118.367V121.672Z",
    fill: "#EEDBBF"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 133.861L180.76 136.049V132.744L176.972 130.557V133.861Z",
    fill: "#EEDBBF"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 127.766L180.76 129.954V126.649L176.972 124.461V127.766Z",
    fill: "#EEDBBF"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 146.537L180.76 148.724V145.419L176.972 143.232V146.537Z",
    fill: "#EEDBBF"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 139.955L180.76 142.142V138.837L176.972 136.65V139.955Z",
    fill: "#EEDBBF"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 103.391L180.76 105.578V102.273L176.972 100.086V103.391Z",
    fill: "#EEDBBF"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 97.2972L180.76 99.4842V96.1792L176.972 93.9922V97.2972Z",
    fill: "#EEDBBF"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 91.2015L180.76 93.3885V90.0835L176.972 87.8965V91.2015Z",
    fill: "#EEDBBF"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 109.485L180.76 111.672V108.368L176.972 106.18V109.485Z",
    fill: "#EEDBBF"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 115.578L180.76 117.766V114.461L176.972 112.273V115.578Z",
    fill: "#EEDBBF"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 218.537L188.615 220.724V217.419L184.826 215.232V218.537Z",
    fill: "#EEDBBF"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 199.832L188.615 202.02V198.715L184.826 196.527V199.832Z",
    fill: "#EEDBBF"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 230.725L188.615 232.912V229.607L184.826 227.42V230.725Z",
    fill: "#EEDBBF"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 205.926L188.615 208.114V204.809L184.826 202.621V205.926Z",
    fill: "#EEDBBF"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 152.631L180.76 154.818V151.513L176.972 149.326V152.631Z",
    fill: "#EEDBBF"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 224.631L188.615 226.818V223.513L184.826 221.326V224.631Z",
    fill: "#EEDBBF"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 212.443L188.615 214.631V211.326L184.826 209.139V212.443Z",
    fill: "#EEDBBF"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 175.455L188.615 177.642V174.337L184.826 172.15V175.455Z",
    fill: "#EEDBBF"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 193.737L188.615 195.924V192.619L184.826 190.432V193.737Z",
    fill: "#EEDBBF"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 181.549L188.615 183.736V180.431L184.826 178.244V181.549Z",
    fill: "#EEDBBF"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 187.643L188.615 189.83V186.525L184.826 184.338V187.643Z",
    fill: "#EEDBBF"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 267.29L188.615 269.478V266.173L184.826 263.986V267.29Z",
    fill: "#EEDBBF"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 273.807L188.615 275.994V272.689L184.826 270.502V273.807Z",
    fill: "#EEDBBF"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 298.184L188.615 300.372V297.067L184.826 294.879V298.184Z",
    fill: "#EEDBBF"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 236.819L188.615 239.006V235.701L184.826 233.514V236.819Z",
    fill: "#EEDBBF"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 285.994L188.615 288.182V284.877L184.826 282.689V285.994Z",
    fill: "#EEDBBF"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 292.09L188.615 294.277V290.973L184.826 288.785V292.09Z",
    fill: "#EEDBBF"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 279.901L188.615 282.088V278.783L184.826 276.596V279.901Z",
    fill: "#EEDBBF"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 261.195L188.615 263.383V260.078L184.826 257.891V261.195Z",
    fill: "#EEDBBF"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 242.912L188.615 245.099V241.795L184.826 239.607V242.912Z",
    fill: "#EEDBBF"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 249.008L188.615 251.196V247.891L184.826 245.703V249.008Z",
    fill: "#EEDBBF"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M184.826 255.101L188.615 257.289V253.984L184.826 251.797V255.101Z",
    fill: "#EEDBBF"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 183.102L180.76 185.29V181.985L176.972 179.797V183.102Z",
    fill: "#EEDBBF"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 56.1888L172.904 58.3768V55.0718L169.115 52.8848V56.1888Z",
    fill: "#EEDBBF"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 62.2835L172.904 64.4705V61.1655L169.115 58.9785V62.2835Z",
    fill: "#EEDBBF"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 68.3792L172.904 70.5662V67.2612L169.115 65.0742V68.3792Z",
    fill: "#EEDBBF"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 74.473L172.904 76.66V73.355L169.115 71.168V74.473Z",
    fill: "#EEDBBF"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 299.737L180.76 301.924V298.619L176.972 296.432V299.737Z",
    fill: "#EEDBBF"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 305.83L180.76 308.017V304.713L176.972 302.525V305.83Z",
    fill: "#EEDBBF"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 311.924L180.76 314.111V310.806L176.972 308.619V311.924Z",
    fill: "#EEDBBF"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 117.131L172.904 119.318V116.013L169.115 113.826V117.131Z",
    fill: "#EEDBBF"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 111.036L172.904 113.224V109.919L169.115 107.732V111.036Z",
    fill: "#EEDBBF"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 123.225L172.904 125.412V122.107L169.115 119.92V123.225Z",
    fill: "#EEDBBF"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 293.643L180.76 295.83V292.525L176.972 290.338V293.643Z",
    fill: "#EEDBBF"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 135.412L172.904 137.599V134.294L169.115 132.107V135.412Z",
    fill: "#EEDBBF"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 129.319L172.904 131.506V128.201L169.115 126.014V129.319Z",
    fill: "#EEDBBF"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 80.5667L172.904 82.7537V79.4487L169.115 77.2617V80.5667Z",
    fill: "#EEDBBF"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 86.6605L172.904 88.8475V85.5435L169.115 83.3555V86.6605Z",
    fill: "#EEDBBF"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 92.7542L172.904 94.9412V91.6372L169.115 89.4492V92.7542Z",
    fill: "#EEDBBF"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 98.848L172.904 101.036V97.731L169.115 95.543V98.848Z",
    fill: "#EEDBBF"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 104.942L172.904 107.13V103.825L169.115 101.637V104.942Z",
    fill: "#EEDBBF"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 177.008L180.76 179.195V175.891L176.972 173.703V177.008Z",
    fill: "#EEDBBF"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 195.29L180.76 197.478V194.173L176.972 191.986V195.29Z",
    fill: "#EEDBBF"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 220.09L180.76 222.277V218.973L176.972 216.785V220.09Z",
    fill: "#EEDBBF"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 207.901L180.76 210.088V206.783L176.972 204.596V207.901Z",
    fill: "#EEDBBF"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 189.196L180.76 191.384V188.079L176.972 185.891V189.196Z",
    fill: "#EEDBBF"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 213.994L180.76 216.181V212.877L176.972 210.689V213.994Z",
    fill: "#EEDBBF"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 201.385L180.76 203.572V200.267L176.972 198.08V201.385Z",
    fill: "#EEDBBF"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 164.819L180.76 167.006V163.701L176.972 161.514V164.819Z",
    fill: "#EEDBBF"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M169.115 141.994L172.904 144.181V140.876L169.115 138.689V141.994Z",
    fill: "#EEDBBF"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 170.912L180.76 173.099V169.794L176.972 167.607V170.912Z",
    fill: "#EEDBBF"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 158.725L180.76 160.912V157.607L176.972 155.42V158.725Z",
    fill: "#EEDBBF"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 256.655L180.76 258.842V255.537L176.972 253.35V256.655Z",
    fill: "#EEDBBF"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 287.548L180.76 289.736V286.431L176.972 284.244V287.548Z",
    fill: "#EEDBBF"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 262.748L180.76 264.935V261.631L176.972 259.443V262.748Z",
    fill: "#EEDBBF"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 269.266L180.76 271.454V268.149L176.972 265.961V269.266Z",
    fill: "#EEDBBF"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 275.36L180.76 277.548V274.243L176.972 272.055V275.36Z",
    fill: "#EEDBBF"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 281.452L180.76 283.64V280.335L176.972 278.148V281.452Z",
    fill: "#EEDBBF"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 238.37L180.76 240.558V237.253L176.972 235.066V238.37Z",
    fill: "#EEDBBF"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 226.184L180.76 228.372V225.067L176.972 222.879V226.184Z",
    fill: "#EEDBBF"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 250.561L180.76 252.748V249.443L176.972 247.256V250.561Z",
    fill: "#EEDBBF"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 232.278L180.76 234.466V231.161L176.972 228.973V232.278Z",
    fill: "#EEDBBF"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M176.972 244.466L180.76 246.654V243.349L176.972 241.162V244.466Z",
    fill: "#EEDBBF"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7232 115.652L26.9562 100.178L13.5742 107.905L40.3392 123.358L53.7232 115.652Z",
    fill: "#F9E9D1"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M134.027 84.8223L111.704 71.9473L84.9395 87.4003L107.261 100.275L134.027 84.8223Z",
    fill: "#F9E9D1"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9484 109.391V124.832L71.5664 117.116L84.9484 109.391Z",
    fill: "#F9E9D1"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M223.239 44.5975L196.473 29.1465L165.248 47.1745L192.014 62.6265L223.239 44.5975Z",
    fill: "#F9E9D1"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M397.22 94.015L357.07 70.834L339.229 81.139L379.378 104.32L397.22 94.015Z",
    fill: "#F9E9D1"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M486.426 128.68L450.759 108.068L423.962 123.536L459.629 144.148L486.426 128.68Z",
    fill: "#F9E9D1"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M285.698 72.8695L267.851 62.5625L245.537 75.4435L263.384 85.7505L285.698 72.8695Z",
    fill: "#F9E9D1"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M339.228 110.847L321.381 100.539L303.532 110.841L321.379 121.148L339.228 110.847Z",
    fill: "#F9E9D1"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M165.243 114.043V129.484L151.861 121.769L165.243 114.043Z",
    fill: "#F9E9D1"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M397.219 156.361V140.92L410.601 148.635L397.219 156.361Z",
    fill: "#F9E9D1"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6607 247.205C-17.5163 302.156 -17.5143 391.249 77.6657 446.2C172.846 501.151 327.162 501.151 422.34 446.2C517.518 391.249 517.515 302.156 422.335 247.205C327.154 192.254 172.838 192.254 77.6607 247.205Z",
    fill: "#002F3F"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8381 364.373L100.277 377.905L107.245 373.882L83.8061 360.35L76.8381 364.373ZM37.1701 341.471L60.6091 355.003L67.5771 350.98L44.1381 337.448L37.1701 341.471ZM116.506 387.275L139.945 400.807L146.913 396.784L123.474 383.252L116.506 387.275ZM9.12109 325.276L20.9411 332.101L27.9091 328.078L11.2321 318.449C10.4311 320.716 9.72709 322.993 9.12109 325.276ZM156.173 410.177L179.612 423.709L186.58 419.686L163.141 406.154L156.173 410.177ZM235.509 455.982L258.948 469.514L265.916 465.491L242.477 451.959L235.509 455.982ZM282.145 474.861L275.177 478.884L287.11 485.774C291.065 485.424 295.008 485.018 298.935 484.555L282.145 474.861ZM195.841 433.08L219.28 446.612L226.248 442.589L202.809 429.057L195.841 433.08Z",
    fill: "#FAFAFA",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M171.586 220.711L61.3403 284.087C45.7853 293.031 47.6373 308.623 65.4773 318.913L274.902 439.771C364.127 491.421 513.054 384.155 441.727 344.163L223.991 218.076C206.151 207.785 187.143 211.767 171.586 220.711Z",
    fill: "#08181E"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M378.224 250.533L247.781 325.847L78.4551 228.087L167.464 169.702C170.034 163.612 174.434 160.892 178.624 159.352C182.094 158.082 186.084 157.092 193.364 156.442C203.384 155.542 217.264 156.592 232.494 165.152C234.824 166.462 238.044 168.302 241.974 170.572C244.974 173.052 248.994 175.922 248.994 175.922L378.224 250.533Z",
    fill: "#F78C3A"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M378.171 250.564L378.22 250.531L248.993 175.923C248.993 175.923 248.686 175.704 248.19 175.342L247.78 175.841V325.846L378.171 250.564Z",
    fill: "#002F3F"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M240.809 176.182C240.809 176.182 182.983 159.823 178.049 162.723C176.28 163.763 184.112 167.27 194.269 172.044C212.441 180.585 223.632 186.018 223.632 186.018L240.809 176.182Z",
    fill: "black"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M239.121 171.134C247.267 173.64 243.707 175.265 241.445 174.764C233.74 173.059 207.691 165.844 197.488 163.964C194.286 163.374 190.328 162.64 187.259 162.196C180.549 161.225 176.474 160.892 185.17 158.955C196.485 156.434 210.755 157.848 217.491 160.197C224.228 162.547 236.485 168.695 236.485 168.695C236.485 168.695 203.813 160.642 202.586 160.484C201.358 160.327 198.274 160.445 205.95 162.654C213.627 164.863 230.975 168.627 239.121 171.134Z",
    fill: "#FFE7C4"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M133.697 225.24L237.45 165.338C244.929 169.048 250.073 175.884 251.173 183.577L256.203 214.414L152.45 274.316L136.505 266.407L133.697 225.24Z",
    fill: "#08181E"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M134.504 237.072L246.617 172.862C244.268 169.774 241.147 167.172 237.45 165.338L133.696 225.24L134.504 237.072Z",
    fill: "#002F3F"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M136.505 266.407L133.697 225.24C141.176 228.95 146.319 235.786 147.421 243.479L152.45 274.316L136.505 266.407Z",
    fill: "#002F3F"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M147.413 243.472L152.444 274.316L178.911 287.44L260.44 240.378L251.174 183.576L147.413 243.472Z",
    fill: "#08181E"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M254.399 240.73L360.371 301.916L278.85 348.982L172.872 287.791L254.399 240.73Z",
    fill: "black"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M248.863 283.097L261.003 282.859L279.472 272.279C282.486 270.553 287.495 270.311 290.661 271.739L313.051 281.839L328.397 281.539V290.496L328.39 290.499C328.394 291.506 327.679 292.541 326.222 293.382L286.025 316.59C283.017 318.327 278.393 317.96 275.696 315.771L250.728 295.503C249.479 294.489 248.891 293.265 248.89 292.07C248.884 292.066 248.862 292.05 248.862 292.05L248.863 283.097Z",
    fill: "#08181E"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M326.223 284.422L286.026 307.63C283.018 309.366 278.394 309 275.697 306.811L250.729 286.543C248.032 284.354 248.29 281.18 251.303 279.454L279.472 263.317C282.486 261.59 287.495 261.349 290.661 262.777L325.936 278.691C329.103 280.12 329.231 282.685 326.223 284.422Z",
    fill: "#002F3F"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M248.857 283.107V292.05C248.857 292.05 248.883 292.075 248.895 292.075C248.895 293.27 249.473 294.49 250.731 295.509L275.697 315.771C277.005 316.84 278.766 317.457 280.577 317.632V308.677C278.766 308.513 277.005 307.872 275.697 306.816L250.731 286.541C249.473 285.522 248.857 284.302 248.857 283.107Z",
    fill: "#002F3F"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M244.984 280.454C244.933 281.498 245.273 282.228 245.839 282.579L256.077 288.49V288.477C255.486 288.162 255.146 287.421 255.196 286.351L257.422 236.332C257.51 234.244 259.057 231.716 260.856 230.672L284.979 216.749C285.91 216.208 286.815 216.17 287.519 216.548V216.536L277.357 210.675V210.688C276.64 210.285 275.722 210.298 274.753 210.852L250.643 224.775C248.832 225.819 247.298 228.347 247.209 230.435L244.984 280.454Z",
    fill: "#002F3F"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M284.976 216.748L260.858 230.673C259.053 231.715 257.515 234.247 257.423 236.329L255.202 286.358C255.11 288.44 256.498 289.283 258.303 288.241L292.639 268.417C294.444 267.375 295.659 264.859 295.353 262.798L288.798 218.594C288.492 216.532 286.781 215.706 284.976 216.748Z",
    fill: "#08181E"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M248.267 227.228L258.48 233.127C259.109 232.095 259.951 231.203 260.857 230.674L284.98 216.751C285.911 216.21 286.816 216.172 287.52 216.55V216.538L277.358 210.677V210.69C276.641 210.287 275.723 210.3 274.754 210.854L250.644 224.777C249.739 225.303 248.896 226.197 248.267 227.228Z",
    fill: "#002F3F"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M252.481 219.953C252.481 216.977 252.481 212.504 252.481 207.502C252.481 198.542 258.199 187.978 265.253 183.905C268.49 182.036 271.436 181.877 273.687 183.098L273.696 183.081L281.478 187.606L278.025 194.216V205.204C278.025 207.288 276.562 209.822 274.757 210.864L266.984 215.352L261.136 226.547L253.438 222.069L253.436 222.068L253.428 222.063L253.429 222.062C252.844 221.718 252.481 220.989 252.481 219.953Z",
    fill: "#002F3F"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M265.253 201.638L255.239 195.857C257.578 190.752 261.19 186.25 265.253 183.905C268.49 182.036 271.436 181.877 273.687 183.098L273.696 183.081L281.478 187.606L278.025 194.216V196.375L265.253 201.638Z",
    fill: "#002F3F"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M260.145 224.412C260.145 221.436 260.145 216.963 260.145 211.961C260.145 203.001 265.864 192.436 272.917 188.364C279.971 184.291 285.689 188.253 285.689 197.213V209.663C285.689 211.747 284.226 214.281 282.421 215.323L263.412 226.298C261.608 227.34 260.145 226.496 260.145 224.412Z",
    fill: "#08181E"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M284.248 227.346C287.184 238.194 288.608 249.476 288.473 261.206C288.449 263.29 287.07 266.048 285.399 267.292C279.624 271.592 273.229 275.294 266.179 278.362C264.268 279.194 262.609 278.118 262.516 276.037C261.912 262.48 261.702 249.841 262.401 239.319C262.539 237.24 264.009 234.491 265.692 233.262C270.277 229.914 274.959 227.261 279.718 225.158C281.624 224.316 283.704 225.335 284.248 227.346Z",
    fill: "#002F3F"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M262.779 277.186C262.636 276.848 262.535 276.471 262.516 276.038C261.912 262.481 261.702 249.842 262.401 239.32C262.469 238.287 262.868 237.09 263.456 235.995C264.792 234.096 265.261 250.111 265.252 259.877C265.243 269.509 265.121 279.297 263.521 278.171C263.457 278.122 263.397 278.072 263.338 278.016C263.178 277.835 262.989 277.552 262.779 277.186Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.236 260.385C286.236 260.385 285.946 260.557 285.459 260.881C284.977 261.216 284.269 261.65 283.437 262.194C281.772 263.281 279.544 264.682 277.261 265.986C274.983 267.297 272.646 268.51 270.868 269.399C269.979 269.842 269.243 270.239 268.715 270.484C268.191 270.742 267.895 270.906 267.895 270.906C267.895 270.906 268.226 270.847 268.798 270.714C269.365 270.569 270.187 270.385 271.142 270.067C272.105 269.77 273.202 269.348 274.36 268.85C274.93 268.583 275.534 268.335 276.117 268.021C276.709 267.725 277.297 267.399 277.887 267.077C279.044 266.392 280.182 265.673 281.199 264.928C282.214 264.182 283.132 263.447 283.875 262.766C284.63 262.103 285.208 261.482 285.616 261.068C286.017 260.642 286.236 260.385 286.236 260.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 254.062C286.236 254.062 285.946 254.235 285.459 254.559C284.977 254.894 284.269 255.327 283.437 255.871C281.772 256.958 279.544 258.36 277.261 259.663C274.983 260.974 272.646 262.188 270.868 263.077C269.979 263.519 269.243 263.915 268.715 264.161C268.191 264.419 267.895 264.583 267.895 264.583C267.895 264.583 268.226 264.525 268.798 264.392C269.365 264.248 270.187 264.062 271.142 263.745C272.105 263.448 273.202 263.027 274.36 262.529C274.93 262.261 275.534 262.013 276.117 261.699C276.709 261.403 277.297 261.077 277.887 260.755C279.044 260.07 280.182 259.352 281.199 258.607C282.214 257.861 283.132 257.124 283.875 256.444C284.63 255.781 285.208 255.16 285.616 254.746C286.017 254.318 286.236 254.062 286.236 254.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.929 248.832C284.929 248.832 284.659 248.988 284.207 249.282C283.762 249.591 283.101 249.98 282.335 250.479C280.795 251.471 278.739 252.742 276.611 253.883C274.49 255.036 272.298 256.077 270.645 256.877C269.819 257.286 269.131 257.626 268.649 257.864C268.166 258.104 267.895 258.258 267.895 258.258C267.895 258.258 268.202 258.21 268.731 258.095C269.256 257.97 270.016 257.816 270.905 257.551C271.797 257.3 272.824 256.953 273.904 256.525C274.438 256.298 275.004 256.09 275.55 255.815C276.104 255.557 276.657 255.273 277.21 254.989C277.749 254.679 278.291 254.375 278.809 254.049C279.337 253.739 279.821 253.376 280.302 253.05C281.244 252.365 282.091 251.684 282.772 251.051C283.463 250.431 283.993 249.856 284.364 249.469C284.731 249.072 284.929 248.832 284.929 248.832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.402 242.934C284.402 242.934 284.14 243.082 283.701 243.366C283.271 243.663 282.629 244.038 281.888 244.518C280.398 245.473 278.411 246.694 276.348 247.772C274.291 248.861 272.158 249.836 270.555 250.603C269.756 250.996 269.089 251.324 268.623 251.554C268.156 251.787 267.895 251.937 267.895 251.937C267.895 251.937 268.193 251.892 268.704 251.785C269.211 251.666 269.948 251.525 270.808 251.279C271.672 251.044 272.669 250.727 273.718 250.327C274.238 250.116 274.786 249.921 275.319 249.664C275.858 249.421 276.397 249.154 276.934 248.884C277.459 248.59 277.986 248.299 278.49 247.987C279.003 247.691 279.473 247.34 279.939 247.026C280.854 246.367 281.668 245.702 282.326 245.089C282.993 244.486 283.501 243.928 283.858 243.552C284.211 243.167 284.402 242.934 284.402 242.934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.501 237.309C283.501 237.309 283.259 237.454 282.836 237.708C282.423 237.968 281.834 238.34 281.126 238.787C279.719 239.68 277.855 240.823 275.901 241.795C273.953 242.778 271.918 243.642 270.403 244.356C268.883 245.055 267.895 245.614 267.895 245.614C267.895 245.614 269.018 245.457 270.646 245.036C272.274 244.621 274.428 243.937 276.466 242.918C276.967 242.65 277.468 242.382 277.948 242.092C278.436 241.818 278.881 241.489 279.32 241.191C280.189 240.576 280.946 239.935 281.564 239.358C282.81 238.202 283.501 237.309 283.501 237.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.409 231.891C281.409 231.891 280.543 232.384 279.32 233.156C278.091 233.927 276.462 234.902 274.773 235.774C273.087 236.654 271.352 237.476 270.051 238.133C268.748 238.781 267.895 239.291 267.895 239.291C267.895 239.291 268.882 239.183 270.305 238.81C271.73 238.448 273.594 237.799 275.355 236.889C275.788 236.648 276.221 236.408 276.637 236.152C277.058 235.906 277.446 235.619 277.825 235.352C278.579 234.81 279.231 234.237 279.762 233.723C280.829 232.695 281.409 231.891 281.409 231.891Z",
    fill: "black"
  }))), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M294.544 272.85C300.883 273.986 307.154 277.221 313.379 281.894C315.045 283.145 315.034 285.297 313.365 286.545C306.407 291.749 298.325 296.373 289.156 300.437C287.251 301.281 284.152 301.221 282.305 300.255C276.83 297.389 271.955 293.992 267.834 289.927C266.351 288.464 266.6 286.158 268.292 284.942C274.68 280.351 281.021 276.489 287.286 273.809C289.203 272.988 292.493 272.483 294.544 272.85Z",
    fill: "#08181E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.987 284.227C309.987 284.227 309.591 284.331 308.91 284.542C308.235 284.762 307.253 285.061 306.11 285.499C303.816 286.352 300.83 287.697 297.984 289.308C295.139 290.921 292.447 292.793 290.556 294.352C288.661 295.91 287.521 297.083 287.521 297.083C287.521 297.083 288.903 296.226 290.975 294.94C293.036 293.654 295.795 291.985 298.604 290.402C301.405 288.806 304.257 287.292 306.406 286.155C307.481 285.581 308.377 285.103 309.004 284.768C309.633 284.434 309.987 284.227 309.987 284.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.945 280.748C303.945 280.748 303.549 280.853 302.868 281.063C302.193 281.283 301.211 281.582 300.069 282.02C297.775 282.873 294.789 284.218 291.942 285.829C289.097 287.442 286.405 289.315 284.514 290.874C282.619 292.432 281.479 293.605 281.479 293.605C281.479 293.605 282.862 292.748 284.934 291.462C286.995 290.175 289.753 288.507 292.561 286.924C295.362 285.328 298.214 283.814 300.363 282.677C301.438 282.103 302.333 281.625 302.96 281.29C303.591 280.954 303.945 280.748 303.945 280.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.753 277.799C298.753 277.799 298.357 277.903 297.675 278.114C297 278.334 296.018 278.633 294.876 279.071C292.581 279.924 289.595 281.269 286.749 282.88C283.904 284.493 281.212 286.365 279.321 287.925C277.426 289.483 276.286 290.656 276.286 290.656C276.286 290.656 277.668 289.799 279.74 288.513C281.801 287.226 284.56 285.558 287.368 283.974C290.169 282.378 293.021 280.864 295.17 279.727C296.245 279.153 297.14 278.675 297.768 278.34C298.399 278.005 298.753 277.799 298.753 277.799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.093 275.379C293.093 275.379 292.729 275.471 292.102 275.659C291.481 275.857 290.575 276.123 289.524 276.519C287.413 277.29 284.667 278.517 282.054 279.996C279.442 281.477 276.974 283.204 275.246 284.646C273.515 286.087 272.479 287.176 272.479 287.176C272.479 287.176 272.808 286.991 273.362 286.645C273.918 286.304 274.712 285.818 275.666 285.234C277.564 284.065 280.099 282.542 282.674 281.09C285.243 279.626 287.854 278.23 289.82 277.175C290.803 276.641 291.622 276.196 292.195 275.884C292.77 275.573 293.093 275.379 293.093 275.379Z",
    fill: "black"
  }))), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M193.439 315.597L205.579 315.359L224.048 304.779C227.062 303.053 232.07 302.811 235.236 304.239L257.626 314.34L272.972 314.04V322.997L272.964 323C272.968 324.007 272.254 325.042 270.796 325.883L230.601 349.092C227.593 350.828 222.968 350.462 220.271 348.273L195.303 328.005C194.054 326.991 193.467 325.767 193.465 324.572C193.46 324.568 193.438 324.552 193.438 324.552L193.439 315.597Z",
    fill: "#08181E"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M270.799 316.921L230.601 340.129C227.593 341.866 222.969 341.499 220.272 339.31L195.304 319.043C192.607 316.854 192.865 313.68 195.878 311.954L224.047 295.817C227.061 294.09 232.07 293.849 235.236 295.277L270.512 311.191C273.678 312.619 273.806 315.185 270.799 316.921Z",
    fill: "#002F3F"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M193.433 315.607V324.549C193.433 324.549 193.458 324.574 193.471 324.574C193.471 325.769 194.049 326.989 195.307 328.008L220.272 348.27C221.58 349.339 223.341 349.955 225.152 350.131V341.176C223.341 341.013 221.58 340.371 220.272 339.315L195.307 319.041C194.05 318.022 193.433 316.802 193.433 315.607Z",
    fill: "#002F3F"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M189.56 312.954C189.509 313.998 189.849 314.727 190.415 315.079L200.653 320.99V320.978C200.061 320.663 199.722 319.922 199.772 318.852L201.998 268.832C202.086 266.744 203.633 264.216 205.432 263.172L229.555 249.249C230.486 248.708 231.391 248.67 232.095 249.047V249.035L221.933 243.174V243.186C221.216 242.784 220.298 242.796 219.329 243.35L195.219 257.273C193.408 258.317 191.873 260.845 191.785 262.933L189.56 312.954Z",
    fill: "#002F3F"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M229.552 249.247L205.434 263.172C203.629 264.214 202.091 266.746 201.999 268.828L199.778 318.857C199.686 320.939 201.074 321.782 202.878 320.74L237.214 300.916C239.019 299.874 240.234 297.359 239.928 295.297L233.373 251.093C233.067 249.032 231.356 248.206 229.552 249.247Z",
    fill: "#08181E"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M192.843 259.726L203.055 265.625C203.684 264.594 204.527 263.701 205.432 263.172L229.555 249.249C230.486 248.708 231.391 248.67 232.095 249.047V249.035L221.933 243.174V243.186C221.216 242.784 220.298 242.796 219.329 243.35L195.219 257.273C194.314 257.802 193.472 258.695 192.843 259.726Z",
    fill: "#002F3F"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M197.057 252.451C197.057 249.475 197.057 245.002 197.057 240C197.057 231.04 202.775 220.475 209.829 216.403C213.066 214.534 216.012 214.375 218.263 215.596L218.272 215.579L226.054 220.105L222.601 226.716V237.703C222.601 239.787 221.138 242.321 219.333 243.363L211.56 247.85L205.712 259.045L198.014 254.567L198.012 254.566L198.004 254.562L198.005 254.56C197.42 254.216 197.057 253.488 197.057 252.451Z",
    fill: "black"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M209.829 234.136L199.816 228.355C202.155 223.25 205.767 218.748 209.829 216.403C213.066 214.534 216.012 214.375 218.263 215.596L218.272 215.579L226.054 220.105L222.601 226.716V228.875L209.829 234.136Z",
    fill: "black"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M204.72 256.911C204.72 253.935 204.72 249.462 204.72 244.461C204.72 235.501 210.438 224.937 217.493 220.864C224.547 216.791 230.265 220.753 230.265 229.713V242.163C230.265 244.247 228.802 246.781 226.997 247.823L207.988 258.798C206.183 259.84 204.72 258.995 204.72 256.911Z",
    fill: "#08181E"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M228.823 259.846C231.759 270.694 233.184 281.976 233.049 293.706C233.025 295.79 231.646 298.547 229.974 299.792C224.198 304.091 217.804 307.794 210.753 310.862C208.842 311.694 207.184 310.619 207.091 308.537C206.486 294.98 206.277 282.341 206.976 271.819C207.114 269.74 208.584 266.991 210.267 265.762C214.852 262.414 219.534 259.76 224.293 257.658C226.2 256.816 228.279 257.834 228.823 259.846Z",
    fill: "#002F3F"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M207.355 309.684C207.212 309.346 207.111 308.969 207.092 308.536C206.487 294.979 206.278 282.34 206.977 271.818C207.046 270.785 207.444 269.587 208.033 268.493C209.368 266.594 209.838 282.609 209.829 292.375C209.82 302.007 209.698 311.795 208.098 310.669C208.034 310.62 207.974 310.569 207.915 310.514C207.754 310.333 207.565 310.05 207.355 309.684Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.811 292.881C230.811 292.881 230.522 293.053 230.034 293.377C229.552 293.712 228.845 294.147 228.012 294.69C226.348 295.777 224.119 297.178 221.837 298.482C219.558 299.793 217.222 301.006 215.444 301.895C214.555 302.337 213.819 302.734 213.29 302.98C212.766 303.237 212.47 303.402 212.47 303.402C212.47 303.402 212.801 303.343 213.373 303.211C213.94 303.066 214.762 302.882 215.717 302.564C216.68 302.267 217.777 301.845 218.935 301.346C219.504 301.079 220.109 300.831 220.692 300.517C221.284 300.221 221.872 299.895 222.462 299.573C223.62 298.888 224.757 298.169 225.774 297.424C226.789 296.678 227.707 295.942 228.45 295.261C229.205 294.598 229.783 293.977 230.191 293.564C230.593 293.138 230.811 292.881 230.811 292.881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.811 286.559C230.811 286.559 230.522 286.731 230.034 287.055C229.552 287.39 228.845 287.824 228.012 288.368C226.348 289.455 224.119 290.857 221.837 292.16C219.558 293.471 217.222 294.683 215.444 295.573C214.555 296.015 213.819 296.412 213.29 296.658C212.766 296.915 212.47 297.08 212.47 297.08C212.47 297.08 212.801 297.021 213.373 296.888C213.94 296.743 214.762 296.559 215.717 296.241C216.68 295.944 217.777 295.522 218.935 295.024C219.504 294.757 220.109 294.509 220.692 294.195C221.284 293.898 221.872 293.573 222.462 293.251C223.62 292.566 224.757 291.847 225.774 291.102C226.789 290.356 227.707 289.62 228.45 288.939C229.205 288.276 229.783 287.655 230.191 287.241C230.593 286.816 230.811 286.559 230.811 286.559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.505 281.33C229.505 281.33 229.235 281.485 228.782 281.78C228.337 282.089 227.676 282.478 226.91 282.977C225.37 283.969 223.313 285.24 221.186 286.381C219.065 287.533 216.873 288.575 215.22 289.375C214.394 289.783 213.706 290.124 213.224 290.363C212.74 290.603 212.469 290.757 212.469 290.757C212.469 290.757 212.776 290.709 213.305 290.594C213.83 290.469 214.591 290.314 215.478 290.05C216.37 289.798 217.397 289.451 218.477 289.024C219.011 288.796 219.577 288.589 220.123 288.314C220.677 288.056 221.23 287.772 221.783 287.488C222.322 287.178 222.864 286.874 223.382 286.548C223.91 286.238 224.394 285.875 224.875 285.55C225.817 284.864 226.664 284.183 227.345 283.55C228.037 282.93 228.566 282.355 228.937 281.968C229.306 281.57 229.505 281.33 229.505 281.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.978 275.43C228.978 275.43 228.716 275.579 228.277 275.862C227.847 276.159 227.205 276.533 226.464 277.014C224.974 277.968 222.987 279.19 220.924 280.268C218.867 281.358 216.734 282.332 215.131 283.099C214.332 283.492 213.665 283.82 213.199 284.05C212.732 284.283 212.471 284.433 212.471 284.433C212.471 284.433 212.769 284.388 213.28 284.281C213.787 284.163 214.524 284.021 215.384 283.775C216.248 283.54 217.245 283.223 218.294 282.823C218.814 282.612 219.362 282.417 219.895 282.16C220.434 281.918 220.973 281.65 221.51 281.38C222.035 281.086 222.562 280.795 223.066 280.483C223.579 280.187 224.048 279.837 224.515 279.522C225.43 278.863 226.244 278.198 226.902 277.585C227.568 276.982 228.077 276.424 228.434 276.049C228.787 275.663 228.978 275.43 228.978 275.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.077 269.805C228.077 269.805 227.835 269.95 227.412 270.204C226.999 270.464 226.41 270.836 225.702 271.283C224.295 272.176 222.431 273.319 220.477 274.291C218.529 275.274 216.494 276.138 214.979 276.852C213.459 277.551 212.471 278.109 212.471 278.109C212.471 278.109 213.594 277.952 215.223 277.531C216.851 277.116 219.005 276.432 221.043 275.413C221.545 275.145 222.046 274.877 222.525 274.587C223.013 274.313 223.458 273.984 223.897 273.685C224.766 273.07 225.523 272.429 226.141 271.852C227.385 270.698 228.077 269.805 228.077 269.805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.984 264.389C225.984 264.389 225.118 264.882 223.895 265.654C222.666 266.425 221.038 267.4 219.349 268.272C217.663 269.151 215.927 269.973 214.626 270.63C213.323 271.278 212.47 271.787 212.47 271.787C212.47 271.787 213.458 271.679 214.881 271.306C216.306 270.944 218.17 270.295 219.931 269.385C220.364 269.144 220.797 268.905 221.212 268.648C221.633 268.402 222.021 268.115 222.4 267.848C223.155 267.306 223.806 266.733 224.337 266.219C225.404 265.192 225.984 264.389 225.984 264.389Z",
    fill: "black"
  }))), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M239.12 305.35C245.458 306.485 251.73 309.721 257.954 314.394C259.62 315.645 259.609 317.797 257.94 319.045C250.982 324.249 242.901 328.873 233.731 332.937C231.826 333.781 228.726 333.721 226.88 332.755C221.405 329.889 216.531 326.492 212.409 322.427C210.926 320.964 211.175 318.658 212.867 317.442C219.255 312.851 225.596 308.99 231.862 306.309C233.778 305.488 237.068 304.983 239.12 305.35Z",
    fill: "#08181E"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.562 316.727C254.562 316.727 254.166 316.831 253.485 317.042C252.81 317.262 251.828 317.561 250.685 317.999C248.391 318.852 245.405 320.196 242.559 321.808C239.714 323.421 237.022 325.293 235.131 326.852C233.237 328.41 232.096 329.583 232.096 329.583C232.096 329.583 233.478 328.725 235.55 327.44C237.611 326.153 240.37 324.484 243.178 322.901C245.979 321.305 248.831 319.791 250.981 318.654C252.055 318.08 252.951 317.602 253.578 317.267C254.209 316.934 254.562 316.727 254.562 316.727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.522 313.248C248.522 313.248 248.126 313.353 247.444 313.563C246.769 313.783 245.787 314.082 244.645 314.52C242.35 315.373 239.365 316.718 236.518 318.329C233.673 319.942 230.981 321.815 229.09 323.373C227.195 324.931 226.055 326.104 226.055 326.104C226.055 326.104 227.437 325.246 229.509 323.961C231.57 322.675 234.329 321.006 237.138 319.422C239.939 317.826 242.791 316.312 244.94 315.175C246.015 314.601 246.91 314.123 247.537 313.787C248.168 313.454 248.522 313.248 248.522 313.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.328 310.299C243.328 310.299 242.932 310.404 242.25 310.614C241.575 310.834 240.593 311.133 239.451 311.571C237.156 312.424 234.171 313.769 231.324 315.379C228.479 316.992 225.787 318.864 223.896 320.424C222.002 321.982 220.861 323.155 220.861 323.155C220.861 323.155 222.243 322.298 224.315 321.012C226.376 319.725 229.135 318.057 231.943 316.474C234.744 314.878 237.595 313.364 239.746 312.227C240.82 311.653 241.716 311.175 242.343 310.84C242.974 310.506 243.328 310.299 243.328 310.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.669 307.879C237.669 307.879 237.304 307.971 236.677 308.159C236.056 308.357 235.151 308.623 234.1 309.019C231.988 309.79 229.243 311.017 226.629 312.496C224.017 313.977 221.549 315.704 219.821 317.146C218.09 318.587 217.054 319.676 217.054 319.676C217.054 319.676 217.383 319.491 217.937 319.145C218.493 318.804 219.287 318.318 220.24 317.734C222.138 316.565 224.673 315.042 227.248 313.59C229.817 312.126 232.428 310.73 234.394 309.675C235.377 309.141 236.196 308.696 236.769 308.384C237.347 308.073 237.669 307.879 237.669 307.879Z",
    fill: "black"
  }))), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M295.16 252.348C299.712 255.123 303.28 257.481 309.169 261.441C315.569 265.745 320.865 269.345 322.846 273.127C324.614 276.502 324.531 281.047 322.386 286.566C320.241 292.085 308.838 311.043 308.838 311.043L301.274 303.808C301.274 303.808 303.398 291.518 304.818 288.123C305.931 285.462 306.986 284.615 306.986 284.615L286.359 276.759L281.606 265.75C282.704 259.711 289.256 253.999 295.16 252.348Z",
    fill: "#002F3F"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M260.692 258.096C260.692 260.339 260.669 266.216 261.322 270.189C262.043 274.573 263.168 278.627 270.12 283.668C276.791 288.505 293.889 295.899 294.663 297.335C295.118 302.926 296.125 305.902 297.818 309.242C300.96 315.441 304.615 322.666 304.615 322.666C308.651 323.341 313.789 322.087 315.979 320.042C315.979 320.042 314.135 310.142 312.709 303.54C310.27 292.241 310.074 286.782 307.676 284.09C305.248 281.364 292.111 270.621 292.111 270.621C292.111 270.621 294.306 269.305 295.718 261.712C296.393 258.078 295.718 252.182 295.718 252.182C295.718 252.182 273.083 260.867 260.692 258.096Z",
    fill: "#002F3F"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M284.438 215.469C289.113 216.22 291.434 218.558 296.622 225.469C302.479 233.27 305.121 236.993 305.121 236.993L327.92 245.981L323.364 251.271C323.364 251.271 309.718 248.812 304.484 247.373C300.636 246.315 299.422 246.326 295.717 242.494C292.473 239.139 285.65 230.959 285.65 230.959L284.438 215.469Z",
    fill: "#FFA8A7"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M284.404 214.852C288.116 215.437 289.988 216.832 290.975 217.82C291.962 218.807 297.696 226.371 300.658 230.524C300.658 230.524 300.132 232.525 297.069 235.318C294.22 237.917 291.52 237.905 291.52 237.905L285.29 230.518L284.404 214.852Z",
    fill: "#F78C3A"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M275.182 215.269C271.213 215.564 265.094 218.793 260.671 221.219C257.691 223.563 257.76 231.774 258.309 238.018C259.227 248.448 259.251 250.679 260.146 260.378C260.637 266.187 260.787 267.725 260.787 267.725C272.796 269.658 289.764 265.393 295.717 252.181C295.717 252.181 293.356 245.9 291.502 227.868C290.558 218.683 286.408 216.406 284.403 215.261C281.951 214.889 278.217 215.044 275.182 215.269Z",
    fill: "#FAFAFA"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M268.143 212.002C267.648 209.441 265.028 206.816 263.824 204.601C262.663 202.465 261.963 200.803 262.043 198.768C262.09 197.563 262.811 195.914 263.696 195.551C262.561 191.101 265.87 188.948 267.643 188.483C268.323 188.305 269.446 188.027 270.093 187.738C271.053 187.311 271.254 186.526 272.02 185.845C273.258 184.744 275.664 184.548 276.45 186.298C277.309 185.629 278.402 185.264 279.492 185.285C280.205 185.298 280.937 185.484 281.489 185.937C282.041 186.39 282.376 187.141 282.212 187.835C283.578 187.507 285.129 187.954 286.03 189.032C286.931 190.11 287.075 191.789 286.284 192.95C287.101 193.586 287.472 194.74 287.179 195.733C286.886 196.726 285.948 197.493 284.917 197.584C285.18 197.561 284.685 199.262 284.605 199.398C284.274 199.96 283.723 200.48 283.141 200.773C281.264 201.721 279.171 202.063 277.137 202.533C276.332 202.719 275.527 202.905 274.722 203.091C274.581 203.124 273.85 203.185 273.765 203.312L268.143 212.002Z",
    fill: "#97382B"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M264.952 208.749C266.784 209.787 267.982 208.59 267.982 208.59L268.249 217.643C270.437 220.734 275.163 220.961 277.607 220.282C280.765 219.405 279.992 216.987 278.486 215.744L278.515 214.261C278.515 214.261 280.004 214.258 281.208 214.061C283.217 213.739 285.126 211.569 285.584 209.866C286.197 207.587 286.192 203.932 285.633 201.209C285.49 200.513 285.418 199.802 285.475 199.094C285.626 197.214 285.264 196.131 284.743 194.567C282.484 192.831 276.66 192.544 271.942 195.562C272.56 198.396 272.184 200.473 270.138 201.606C270.252 202.372 270.392 204.312 269.128 204.305C268.217 204.3 268.13 203.159 267.173 202.175C266.196 201.17 264.028 200.97 263.217 202.473C262.086 204.575 262.945 207.612 264.952 208.749Z",
    fill: "#FFA8A7"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M278.515 214.261C275.309 213.957 272.871 213.664 271.152 211.385C270.074 209.956 269.399 207.76 269.399 207.76C269.399 207.76 269.531 210.463 270.618 212.358C271.456 213.818 273.494 215.006 278.517 215.324L278.515 214.261Z",
    fill: "#F28F8F"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M277.111 201.748C277.115 202.29 276.695 202.732 276.173 202.734C275.651 202.737 275.225 202.299 275.221 201.756C275.217 201.213 275.637 200.772 276.159 200.77C276.681 200.768 277.107 201.206 277.111 201.748Z",
    fill: "#002F3F"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M276.19 198.887L274.317 200.04C274.007 199.501 274.175 198.806 274.692 198.488C275.209 198.169 275.88 198.348 276.19 198.887Z",
    fill: "#002F3F"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M284.141 199.041L282.054 198.296C282.24 197.707 282.857 197.397 283.434 197.603C284.01 197.808 284.326 198.452 284.141 199.041Z",
    fill: "#002F3F"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M284.179 201.177C284.183 201.719 283.763 202.161 283.241 202.163C282.719 202.165 282.293 201.728 282.289 201.185C282.285 200.643 282.705 200.201 283.227 200.199C283.749 200.197 284.175 200.635 284.179 201.177Z",
    fill: "#002F3F"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M283.503 205.247L280.402 206.703L279.306 200.585C280.46 200.144 282.017 202.934 283.503 205.247Z",
    fill: "#F28F8F"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M276.448 207.633L280.228 208.358C280.051 209.436 279.061 210.148 278.017 209.948C276.973 209.748 276.271 208.712 276.448 207.633Z",
    fill: "#B16668"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M276.916 208.237C276.756 208.223 276.601 208.233 276.45 208.253C276.568 209.083 277.178 209.787 278.017 209.948C278.228 209.988 278.434 209.983 278.634 209.953C278.673 209.086 277.92 208.323 276.916 208.237Z",
    fill: "#F28F8F"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M250.799 274.729C249.959 271.714 249.139 271.882 251.931 270.469C255.644 268.589 259.485 266.744 260.129 267.59C260.773 268.436 261.993 272.107 262.273 273.672C262.553 275.238 256.937 276.477 254.534 276.911C251.092 277.533 251.315 276.58 250.799 274.729Z",
    fill: "#002F3F"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M283.717 214.949C285.701 224.686 287.151 255.183 258.681 268.664L260.691 273.655C260.691 273.655 278.375 270.806 287.915 265.279C297.455 259.752 298.25 253.073 298.25 253.073L295.717 250.524C295.717 250.524 292.221 262.066 267.244 268.168C280.826 260.327 292.411 240.665 287.21 215.512L283.717 214.949Z",
    fill: "black"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M328.914 252.592C328.439 249.074 326.846 246.39 324.304 244.926C322.994 244.168 321.531 243.783 319.964 243.783C317.871 243.783 315.598 244.451 313.287 245.786C305.711 250.165 299.779 260.45 299.779 269.195V269.336L304.555 266.601C304.774 265.201 305.159 263.763 305.685 262.338C305.968 261.606 306.276 260.874 306.635 260.142C308.69 255.802 311.964 251.834 315.572 249.754C317.151 248.829 318.654 248.38 319.963 248.38C320.734 248.38 321.427 248.547 322.018 248.881C322.339 249.074 322.634 249.305 322.904 249.6C323.418 250.152 323.816 250.897 324.073 251.783C324.355 252.682 324.497 253.748 324.497 254.916V255.134L328.914 252.592Z",
    fill: "#002F3F"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M318.641 258.499L311.103 262.826L310.204 263.353C310.23 263.16 310.281 262.955 310.332 262.762C310.512 262.017 310.807 261.259 311.192 260.54C311.976 259.05 313.131 257.728 314.428 256.983C315.532 256.354 316.534 256.251 317.291 256.585C317.973 256.894 318.461 257.549 318.641 258.499Z",
    fill: "#002F3F"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M326.011 249.368L324.072 251.782L318.718 258.446L318.654 258.536C318.654 258.523 318.654 258.51 318.641 258.497L311.103 262.824L310.332 262.76L305.684 262.336L303.617 262.156L303.81 259.883L306.635 260.14L311.193 260.538L313.915 260.782L317.292 256.583L322.903 249.597L324.239 247.941L326.011 249.368Z",
    fill: "#002F3F"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M327.672 248.503C328.189 249.663 328.299 250.241 327.23 251.383C326.161 252.525 324.346 252.946 324.346 252.946L324.074 251.784C324.074 251.784 322.731 252.82 322.647 253.561C322.585 254.103 322.95 254.451 322.881 254.746C322.811 255.042 322.655 255.302 322.724 255.789L331.504 251.217C331.504 251.217 331.017 249.722 330.687 248.974C330.357 248.226 328.844 246.291 327.923 245.981C327.002 245.671 325.716 245.948 325.716 245.948C325.716 245.948 327.035 247.114 327.672 248.503Z",
    fill: "#FFA8A7"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M307.132 262.326C306.589 261.833 306.09 261.337 306.09 261.337L305.554 262.704C305.554 262.704 304.32 264.251 302.741 264.053C301.162 263.856 300.576 263.353 300.576 263.353L301.361 260.845C301.361 260.845 300.372 261.091 298.892 261.437C297.38 261.79 296.326 262.546 294.745 262.779C290.851 263.352 274.381 254.453 271.923 253.004L267.858 234.497C267.858 234.497 266.448 224.053 260.7 221.617C254.049 225.533 254.368 229.139 256.143 238.03C257.942 247.044 260.836 257.38 261.718 259.875C262.161 261.129 262.638 263.401 266.735 264.592C273.228 266.48 287.316 271.165 293.802 271.424C299.334 268.089 307.822 264 307.822 264C307.822 264 307.675 262.819 307.132 262.326Z",
    fill: "#FFA8A7"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M260.671 221.219C255.977 223.654 253.745 227.007 255.047 233.936C256.349 240.865 258.013 247.273 258.013 247.273C258.013 247.273 260.583 248.242 264.725 247.273C268.867 246.304 270.282 243.994 270.282 243.994C270.282 243.994 267.898 232.168 267.153 229.14C266.408 226.113 264.099 221.988 260.671 221.219Z",
    fill: "#F78C3A"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6503 280.845L112.131 256.893L89.0863 243.588L66.6562 257.754L70.6503 280.845Z",
    fill: "#002F3F"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1377 275.159L82.1807 263.326L96.3547 255.121L96.3557 255.123C100.864 252.53 106.868 252.824 113.46 256.631C127.458 264.714 138.808 285.562 138.81 303.196C138.811 312.431 135.695 318.946 130.72 321.903L130.723 321.91L130.523 322.025C130.513 322.031 130.503 322.037 130.493 322.042L115.962 330.432L109.678 317.95C97.7857 308.842 88.5987 290.889 88.1377 275.159Z",
    fill: "#08181E"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1377 275.159L82.1807 263.326L96.3547 255.121L96.3557 255.123C100.864 252.53 106.868 252.824 113.46 256.631C127.458 264.714 138.808 285.562 138.81 303.196C138.811 312.431 135.695 318.946 130.72 321.903L130.723 321.91L130.523 322.025C130.513 322.031 130.503 322.037 130.493 322.042L115.962 330.432L109.678 317.95C97.7857 308.842 88.5987 290.889 88.1377 275.159Z",
    fill: "#002F3F"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3623 282.438C73.3623 297.642 81.8043 315.241 93.1053 324.976C93.1283 324.988 93.1393 325.01 93.1513 325.022C94.9433 326.554 96.8053 327.904 98.7113 329.004C112.712 337.094 124.07 329.344 124.059 311.712C124.059 298.391 117.58 283.221 108.378 273.123C108.355 273.101 108.321 273.078 108.299 273.044C105.337 269.81 102.104 267.099 98.7113 265.147C84.7093 257.068 73.3623 264.806 73.3623 282.438Z",
    fill: "#08181E"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7101 275.788C89.8011 270.644 82.5791 276.004 82.5791 287.761C82.5791 299.518 89.8011 313.218 98.7101 318.362C107.619 323.506 114.841 318.145 114.841 306.389C114.841 294.633 107.619 280.932 98.7101 275.788Z",
    fill: "#002F3F"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4473 293.766C92.0153 299.616 95.7313 305.844 99.7383 307.667C101.503 308.465 103.024 308.283 104.128 307.332C105.551 306.134 106.292 303.668 105.973 300.381C105.405 294.531 101.7 288.302 97.6823 286.48C96.5963 285.981 95.5933 285.862 94.7353 286.071C94.7353 286.071 94.7233 286.061 94.7243 286.072C92.4073 286.628 91.0333 289.509 91.4473 293.766Z",
    fill: "#FAFAFA"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8914 293.022C93.4594 298.872 97.1754 305.1 101.183 306.923C102.268 307.41 103.261 307.542 104.129 307.332C105.552 306.134 106.293 303.668 105.974 300.381C105.406 294.531 101.701 288.302 97.6834 286.48C96.5974 285.981 95.5944 285.862 94.7364 286.071C94.7364 286.071 94.7244 286.061 94.7254 286.072C93.3144 287.281 92.5734 289.747 92.8914 293.022Z",
    fill: "#E0E0E0"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3623 282.438C73.3623 297.642 81.8043 315.241 93.1053 324.976C86.4113 317.692 79.4783 305.495 77.0273 293.864C74.8833 283.698 75.6883 269.106 84.4143 265.419C93.0713 261.754 104.656 269.504 108.298 273.044C105.336 269.81 102.103 267.099 98.7103 265.147C84.7093 257.068 73.3623 264.806 73.3623 282.438Z",
    fill: "#002F3F"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4814 223.34C71.6214 211.199 93.0503 198.59 102.193 203.168C105.044 204.587 113.139 209.491 123.338 215.367C123.338 215.367 133.908 225.36 133.697 225.238L135.483 251.418C139.118 257.982 157.514 271.072 170.174 278.382C182.834 285.692 237.547 317.28 237.547 317.28L237.546 377.367L132.131 316.506C132.131 314.9 132.051 313.267 131.877 311.607C130.003 292.212 115.779 269.707 100.533 260.913C83.9893 251.356 70.5763 260.284 70.5763 280.857L67.8984 279.31C58.3704 273.56 61.3544 235.467 66.4814 223.34Z",
    fill: "#F78C3A"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M147.438 268.929C158.288 276.373 166.852 282.139 169.159 283.591C169.159 283.591 166.855 285.772 166.274 288.283C166.274 288.283 107.622 254.429 93.3094 241.751C78.9964 229.072 71.1414 217.265 82.1814 211.122C85.5464 209.25 88.6884 206.743 92.7384 208.256C93.0304 208.365 93.3224 208.496 93.5494 208.709C93.9464 209.082 94.0864 209.646 94.2224 210.174C97.4744 222.779 107.791 232.221 116.121 241.753C124.289 251.099 136.885 261.689 147.438 268.929Z",
    fill: "#FFE7C4"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4121 202.676C96.8251 201.913 99.9311 201.967 102.246 203.131C105.097 204.55 113.195 209.462 123.395 215.338C123.395 215.338 129.204 218.684 137.129 223.249L210.315 181.09C210.315 181.09 181.929 166.603 171.85 162.707C161.771 158.799 96.2631 195.127 93.4121 202.676Z",
    fill: "#F78C3A"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.4121 202.676C96.8251 201.913 99.9311 201.967 102.246 203.131C105.097 204.55 113.195 209.462 123.395 215.338C123.395 215.338 129.204 218.684 137.129 223.249L210.315 181.09C210.315 181.09 181.929 166.603 171.85 162.707C161.771 158.799 96.2631 195.127 93.4121 202.676Z",
    fill: "#FFE7C4"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M235.622 321.119L179.123 288.756C179.123 288.756 177.388 289.824 177.422 292.511L235.622 321.119Z",
    fill: "#FFE7C4"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M187.488 301.645C187.717 301.778 188.005 301.612 188.005 301.347V299.733C188.005 298.512 186.178 296.467 183.923 295.166L180.599 293.247C178.345 291.945 176.517 291.88 176.517 293.101V294.419C176.517 294.971 176.812 295.482 177.29 295.758L187.488 301.645Z",
    fill: "#002F3F"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2547 206.892C93.6017 210.145 102.762 219.929 114.97 229.981L126.208 220.373C112.981 212.482 100.977 205.901 99.2547 206.892Z",
    fill: "black"
  }))), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M175.612 286.251C175.612 286.251 172.386 290.023 172.386 298.219C172.386 308.072 172.282 331.473 172.282 331.473C172.282 331.473 170.458 305.426 169.348 297.252C168.238 289.078 172.392 284.473 172.392 284.473L175.612 286.251Z",
    fill: "black"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M112.132 267.415C112.132 267.415 113.569 260.39 115.595 257.755C117.621 255.119 128.353 253.812 128.353 253.812C128.353 253.812 119.934 256.713 117.605 259.197C115.277 261.68 112.132 267.415 112.132 267.415Z",
    fill: "black"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M80.8236 257.754C80.8236 257.754 70.1216 251.632 67.8196 247.604C65.5186 243.576 64.5496 230.137 64.5496 230.137C64.5496 230.137 63.6266 245.533 66.2986 249.215C68.9706 252.898 80.8236 257.754 80.8236 257.754Z",
    fill: "black"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M311.431 273.006C362.596 242.909 378.225 250.595 378.225 250.595C377.355 253.874 374.718 257.804 367.743 263.467C362.804 267.496 355.648 272.265 349.209 276.589C334.003 287.204 316.713 297.025 311.492 300.144C285.35 314.319 259.537 326.105 255.146 320.885C255.146 320.885 260.266 303.103 311.431 273.006Z",
    fill: "#002F3F"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M311.43 273.006C260.265 303.103 255.146 320.884 255.146 320.884C275.077 301.171 340.058 254.818 377.833 250.444C375.161 249.526 358.052 245.581 311.43 273.006Z",
    fill: "#08181E"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M368.703 238.3L369.633 242.181C371.778 246.197 376.52 251.269 378.222 250.85C379.742 250.475 380.673 248.263 381.149 245.528V245.494C381.376 244.246 381.501 242.884 381.546 241.534C381.694 237.234 379.776 227.203 373.808 224.537C372.446 223.935 371.221 224.412 370.268 225.331C369.474 226.102 368.861 227.169 368.543 228.179C367.546 231.197 368.567 238.141 368.703 238.3Z",
    fill: "#002F3F"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M369.634 242.181C371.779 246.197 376.521 251.269 378.223 250.85C379.743 250.475 380.674 248.263 381.15 245.528V245.494C381.377 244.246 381.502 242.884 381.547 241.534C381.695 237.234 379.777 227.203 373.809 224.537C372.447 223.935 371.222 224.412 370.269 225.331L371.086 227.18C375.261 228.961 376.384 235.406 375.999 240.308C375.625 245.21 372.028 244.711 369.634 242.181Z",
    fill: "#002F3F"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M368.554 228.183C370.063 226.583 373.807 226.504 376.962 230.838C380.116 235.172 381.147 242.608 381.158 245.49C381.385 244.242 381.51 242.88 381.555 241.53C381.702 237.23 379.791 227.2 373.823 224.533C371.326 223.422 369.268 225.971 368.554 228.183Z",
    fill: "#08181E"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M237.547 377.368L279.027 353.416L255.982 340.111L237.547 350.796V377.368Z",
    fill: "#002F3F"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M254.7 370.978L248.743 359.145L262.917 350.94L262.918 350.942C267.426 348.349 273.429 348.643 280.021 352.45C294.02 360.533 305.369 381.381 305.37 399.015C305.371 408.25 302.255 414.765 297.28 417.722L297.284 417.729L297.084 417.844C297.075 417.849 297.065 417.855 297.055 417.861L282.524 426.251L276.241 413.77C264.348 404.662 255.161 386.709 254.7 370.978Z",
    fill: "#08181E"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M254.7 370.978L248.743 359.145L262.917 350.94L262.918 350.942C267.426 348.349 273.429 348.643 280.021 352.45C294.02 360.533 305.369 381.381 305.37 399.015C305.371 408.25 302.255 414.765 297.28 417.722L297.284 417.729L297.084 417.844C297.075 417.849 297.065 417.855 297.055 417.861L282.524 426.251L276.241 413.77C264.348 404.662 255.161 386.709 254.7 370.978Z",
    fill: "#002F3F"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M239.925 378.257C239.925 393.461 248.367 411.059 259.668 420.794C259.691 420.805 259.702 420.828 259.713 420.84C261.506 422.372 263.366 423.722 265.273 424.823C279.274 432.913 290.632 425.163 290.621 407.531C290.621 394.211 284.142 379.041 274.94 368.942C274.918 368.919 274.884 368.897 274.861 368.862C271.899 365.629 268.666 362.917 265.273 360.965C251.271 352.886 239.925 360.625 239.925 378.257Z",
    fill: "#08181E"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M265.272 371.607C256.363 366.462 249.141 371.823 249.141 383.58C249.141 395.337 256.363 409.038 265.272 414.181C274.181 419.324 281.403 413.964 281.403 402.208C281.404 390.453 274.181 376.752 265.272 371.607Z",
    fill: "#002F3F"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M257.984 389.643C258.597 395.488 262.36 401.688 266.381 403.48C268.152 404.264 269.672 404.071 270.769 403.111C272.183 401.902 272.905 399.431 272.561 396.147C271.948 390.302 268.195 384.1 264.163 382.31C263.073 381.82 262.069 381.708 261.213 381.923C261.213 381.923 261.201 381.913 261.201 381.924C258.889 382.497 257.538 385.388 257.984 389.643Z",
    fill: "#FAFAFA"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M259.421 388.888C260.034 394.733 263.798 400.933 267.819 402.725C268.907 403.204 269.902 403.328 270.769 403.111C272.183 401.902 272.905 399.431 272.561 396.147C271.948 390.302 268.195 384.1 264.163 382.31C263.073 381.82 262.069 381.708 261.213 381.923C261.213 381.923 261.201 381.913 261.201 381.924C259.8 383.143 259.078 385.615 259.421 388.888Z",
    fill: "#E0E0E0"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M239.925 378.257C239.925 393.461 248.367 411.059 259.668 420.794C252.973 413.51 246.041 401.312 243.59 389.683C241.446 379.517 242.251 364.925 250.977 361.238C259.634 357.573 271.219 365.323 274.861 368.862C271.899 365.629 268.666 362.917 265.273 360.965C251.271 352.886 239.925 360.625 239.925 378.257Z",
    fill: "#002F3F"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M237.547 317.282C237.547 317.282 239.953 316.824 239.393 314.73C239.393 314.73 253.516 321.2 256.482 322.178C262.956 324.313 287.283 315.659 313.422 301.469C318.646 298.358 333.044 291.036 348.247 280.418C354.69 276.096 360.256 271.981 365.204 267.958C370.423 263.715 374.3 259.544 376.672 256.632C377.505 255.61 379.226 252.814 378.209 250.529C430.05 287.405 458.47 302.67 452.38 344.727C452.38 344.727 452.181 347.811 451.059 354.029C449.348 363.517 444.281 379.649 431.242 388.853C419.271 397.303 418.442 397.92 402.211 406.674C385.98 415.429 364.103 421.826 342.794 421.144C318.781 420.368 297.765 411.212 297.11 405.657C296.829 403.194 296.387 400.718 295.771 398.228C294.258 392.031 291.822 385.846 288.677 380.131C283.885 371.404 277.473 363.748 270.339 358.795C269.402 358.139 268.451 357.537 267.501 356.988C252.067 348.073 239.352 355.248 237.719 372.943C237.598 374.228 237.545 375.976 237.545 377.368L237.547 317.282Z",
    fill: "#F78C3A"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M237.547 317.282C237.547 317.282 239.953 316.824 239.393 314.73C239.393 314.73 253.516 321.2 256.482 322.178C262.956 324.313 287.283 315.659 313.422 301.469C318.646 298.358 333.044 291.036 348.247 280.418C354.69 276.096 360.256 271.981 365.204 267.958C370.423 263.715 374.3 259.544 376.672 256.632C377.505 255.61 379.226 252.814 378.209 250.529C430.05 287.405 458.47 302.67 452.38 344.727C452.38 344.727 452.181 347.811 451.059 354.029C449.348 363.517 444.281 379.649 431.242 388.853C419.271 397.303 418.442 397.92 402.211 406.674C385.98 415.429 364.103 421.826 342.794 421.144C318.781 420.368 297.765 411.212 297.11 405.657C296.829 403.194 296.387 400.718 295.771 398.228C294.258 392.031 291.822 385.846 288.677 380.131C283.885 371.404 277.473 363.748 270.339 358.795C269.402 358.139 268.451 357.537 267.501 356.988C252.067 348.073 239.352 355.248 237.719 372.943C237.598 374.228 237.545 375.976 237.545 377.368L237.547 317.282Z",
    fill: "#FFE7C4"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M403.368 379.798C378.226 391.68 346.459 392.992 323.937 376.681C314.925 370.154 307.921 361.301 300.149 353.337C287.877 340.764 273.471 330.29 257.758 322.433C257.28 322.38 256.848 322.299 256.482 322.178C253.517 321.2 239.393 314.73 239.393 314.73C239.953 316.823 237.547 317.282 237.547 317.282L237.546 377.369C237.546 375.977 237.6 374.228 237.72 372.944C239.353 355.249 252.069 348.074 267.502 356.989C268.452 357.538 269.403 358.14 270.34 358.796C277.474 363.749 283.886 371.405 288.678 380.132C291.823 385.847 294.259 392.031 295.772 398.229C296.388 400.719 296.83 403.195 297.111 405.658C297.766 411.213 318.782 420.368 342.795 421.145C364.104 421.827 385.981 415.43 402.212 406.675C418.443 397.921 419.271 397.304 431.243 388.854C444.282 379.65 449.348 363.518 451.059 354.03C452.181 347.812 452.38 344.728 452.38 344.728C452.576 343.375 452.733 342.052 452.858 340.753C438.502 356.502 422.517 370.748 403.368 379.798Z",
    fill: "#F78C3A"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M379.432 409.403C394.382 405.675 405.238 399.792 415.844 393.542C426.46 387.282 433.357 381.441 437.307 376.479C441.038 371.792 443.307 365.706 440.952 366.559C437.037 369.934 428.573 377.098 423.177 380.365C407.028 390.157 389.887 402.29 363.514 402.741C361.229 402.732 359.323 402.866 358.44 403.131C352.004 405.053 369.266 411.937 379.432 409.403Z",
    fill: "#002F3F"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M325.079 397.4C326.553 397.194 330.22 398.179 336.45 399.97C342.681 401.761 344.191 401.925 346.497 403.518C348.453 404.869 353.675 409.119 356.195 410.42C360.188 412.483 356.155 413.967 345.017 413.978C333.879 413.989 330.063 410.64 327.493 407.213C324.923 403.787 321.73 397.867 325.079 397.4Z",
    fill: "#002F3F"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M452.092 347.424C451.896 348.964 451.576 351.158 451.059 354.029C450.372 357.838 449.129 362.722 447.061 367.795C446.235 368.556 445.493 369.063 444.999 369.029C443.094 368.902 444.727 365.618 446.088 360.719C447.448 355.822 450.85 351.059 452.092 347.424Z",
    fill: "#002F3F"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M374.642 373.425C377.014 376.677 380.428 379.616 383.61 381.352C385.983 382.648 390.287 382.243 392.821 381.283C407.055 375.879 418.916 369.098 428.417 360.939C430.465 359.18 432.872 355.581 432.953 352.873C433.08 349.008 432.502 343.824 431.182 340.421C430.187 337.898 426.322 338.28 424.146 339.889C410.618 349.83 394.88 358.937 376.746 367.153C374.283 368.275 373.044 371.238 374.642 373.425ZM376.898 371.007C377.025 370.533 377.442 370.07 377.963 369.838C395.969 361.668 412.09 352.399 425.884 342.261C426.463 341.833 428.013 340.641 428.476 341.601C429.506 344.32 430.142 348.891 430.015 352.78C429.969 354.319 428.256 357.201 426.497 358.705C417.308 366.597 405.632 373.263 391.769 378.528C390.635 378.956 389.061 379.222 387.638 379.222C386.527 379.222 385.555 379.06 385.023 378.759C382.107 377.174 379.04 374.466 377.015 371.688C376.91 371.551 376.806 371.354 376.898 371.007Z",
    fill: "#002F3F"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M377.014 371.69C379.039 374.467 382.106 377.175 385.022 378.761C385.554 379.062 386.526 379.224 387.637 379.224C389.06 379.224 390.634 378.958 391.768 378.53C405.632 373.265 417.308 366.599 426.496 358.707C428.255 357.203 429.968 354.321 430.014 352.782C430.142 348.894 429.505 344.323 428.475 341.603C428.012 340.642 426.462 341.834 425.883 342.263C412.089 352.4 395.968 361.669 377.962 369.84C377.441 370.071 377.025 370.534 376.897 371.009C376.806 371.355 376.91 371.552 377.014 371.69Z",
    fill: "black"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M376.05 372.293L375.893 371.829C378.461 370.959 394.195 363.932 405.283 357.336C404.541 355.843 404.028 354.932 404.013 354.906L406.571 353.45C406.631 353.555 407.113 354.407 407.811 355.798C418.729 349.026 429.181 341.511 429.289 341.432L429.576 341.831C429.467 341.909 418.977 349.453 408.03 356.24C408.228 356.641 408.437 357.071 408.66 357.543C419.583 350.777 429.393 343.63 429.494 343.556L429.783 343.953C429.682 344.026 419.828 351.205 408.869 357.991C409.063 358.409 409.263 358.852 409.468 359.313C420.427 352.536 429.604 345.749 429.698 345.679L429.991 346.074C429.897 346.143 420.67 352.966 409.668 359.766C409.856 360.197 410.046 360.644 410.238 361.107C421.264 354.302 429.816 347.867 429.903 347.803L430.198 348.194C430.111 348.26 421.508 354.734 410.427 361.567C410.607 362.009 410.787 362.463 410.965 362.928C422.105 356.073 430.026 349.988 430.106 349.927L430.404 350.316C430.325 350.378 422.346 356.506 411.141 363.397C411.311 363.849 411.479 364.309 411.645 364.779C422.948 357.845 430.237 352.11 430.309 352.052L430.614 352.437C430.541 352.494 423.207 358.267 411.841 365.234C411.831 365.24 411.82 365.246 411.81 365.252C411.969 365.713 412.123 366.18 412.274 366.654C412.376 366.592 412.481 366.532 412.583 366.469C423.92 359.52 430.448 354.228 430.512 354.176L430.823 354.556C430.758 354.61 424.208 359.92 412.839 366.887C412.704 366.97 412.564 367.05 412.428 367.133C412.773 368.247 413.093 369.388 413.37 370.545L410.507 371.229C410.301 370.369 410.066 369.517 409.816 368.674C399.11 374.831 387.193 379.789 384.85 380.583L384.693 380.119C387.034 379.326 398.977 374.356 409.675 368.19C409.53 367.717 409.379 367.251 409.225 366.789C398.096 373.246 385.456 378.499 383.383 379.202L383.226 378.739C385.295 378.037 397.949 372.776 409.063 366.317C408.902 365.851 408.739 365.391 408.573 364.94C397.212 371.579 383.939 377.136 381.917 377.821L381.761 377.357C383.779 376.674 397.056 371.113 408.398 364.474C408.222 364.009 408.047 363.556 407.869 363.112C396.704 369.673 382.928 375.601 380.451 376.439L380.294 375.975C382.766 375.136 396.54 369.208 407.685 362.65C407.497 362.189 407.309 361.74 407.123 361.307C395.933 367.91 381.314 374.268 378.984 375.056L378.827 374.592C381.151 373.805 395.76 367.448 406.925 360.854C406.723 360.391 406.525 359.952 406.331 359.531C394.878 366.319 379.605 372.969 377.517 373.676L377.361 373.212C379.443 372.505 394.699 365.862 406.124 359.083C405.906 358.615 405.698 358.179 405.502 357.778C394.384 364.385 378.627 371.421 376.05 372.293Z",
    fill: "#002F3F"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M452.461 338.994C449.33 347.984 438.29 361.67 421.907 371.288C405.524 380.906 384.296 394.157 360.204 394.943C336.112 395.729 311.657 385.211 311.657 385.211C311.657 385.211 331.905 397.634 360.206 398.257C388.507 398.88 405.929 386.35 422.741 376.149C440.217 365.546 450.476 350.454 452.461 338.994Z",
    fill: "#F78C3A"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M452.461 338.994C449.33 347.984 438.29 361.67 421.907 371.288C405.524 380.906 384.296 394.157 360.204 394.943C336.112 395.729 311.657 385.211 311.657 385.211C311.657 385.211 331.905 397.634 360.206 398.257C388.507 398.88 405.929 386.35 422.741 376.149C440.217 365.546 450.476 350.454 452.461 338.994Z",
    fill: "black"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.941 388.663C303.462 382.224 313.195 377.505 323.152 374.624C323.152 374.624 306.48 375.116 293.941 388.663ZM301.661 380.977C296.604 364.098 283.583 354.022 273.761 353.24C282.826 356.398 293.687 367.821 299.418 382.372C300.193 381.849 301.661 380.977 301.661 380.977ZM300.56 385.524C302.395 390.99 303.415 396.628 303.415 402.588C304.161 395.986 303.775 389.932 302.574 384.497L300.56 385.524Z",
    fill: "#FFE7C4"
  }))), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M232.503 260.806L251.847 323.09C257.448 332.811 316.964 302.677 352.502 277.623C369.629 265.553 381.19 254.664 378.481 249.977C367.758 229.855 355.919 211.289 337.82 195.701C335.992 197.564 247.535 255.124 232.503 260.806ZM239.414 268C238.245 265.443 239.599 262.723 242.087 261.427C267.546 248.212 329.205 207.626 334.783 204.085C336.873 202.745 339.464 202.332 341.327 203.998C357.1 218.139 366.307 236.784 374.906 251.759C374.559 253.009 371.828 259.2 350.246 274.417C316.86 297.943 270.513 321.042 256.684 321.042C255.862 321.042 255.388 320.949 255.145 320.88L239.414 268Z",
    fill: "#08181E"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.087 261.427C267.546 248.212 329.205 207.626 334.783 204.085C336.959 202.693 339.464 202.332 341.327 203.998C357.1 218.139 366.431 237.37 374.906 251.759C374.559 253.009 371.828 259.2 350.246 274.417C316.86 297.943 270.513 321.042 256.684 321.042C255.862 321.042 255.388 320.949 255.145 320.88L239.414 268C238.245 265.442 239.599 262.723 242.087 261.427Z",
    fill: "#FFE7C4"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M301.361 225.648C311.972 218.82 322.452 211.759 328.55 208.123C343.641 226.744 356.892 252.302 361.733 265.795C360.227 267.015 358.548 268.327 356.68 269.734C356.621 269.778 356.563 269.822 356.504 269.866C356.086 270.18 355.658 270.499 355.221 270.823C355.13 270.89 355.037 270.959 354.945 271.026C354.518 271.341 354.085 271.66 353.639 271.984C353.536 272.059 353.43 272.135 353.326 272.211C352.343 272.924 351.321 273.657 350.247 274.415C348.99 275.301 347.711 276.186 346.419 277.07C346.154 277.251 345.885 277.432 345.618 277.614C344.544 278.344 343.46 279.073 342.366 279.8C342.118 279.965 341.869 280.13 341.62 280.295C338.888 282.1 336.104 283.893 333.285 285.66C323.753 265.625 309.282 236.302 301.361 225.648Z",
    fill: "#FFE7C4"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M297.58 228C303.945 236.598 320.315 268.832 328.55 288.583C326.184 290.024 323.805 291.444 321.421 292.837C312.437 269.807 304.691 252.493 291.193 231.891C293.385 230.624 295.443 229.241 297.58 228Z",
    fill: "#FFE7C4"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M242.086 261.426C242.087 261.425 242.087 261.425 242.087 261.425C260.252 251.996 298.92 227.201 319.679 213.874C319.805 213.836 319.555 213.911 319.679 213.874C319.679 213.874 296.383 233.143 276.837 245.149C254.414 258.921 246.556 261.622 244.254 264.58C241.952 267.538 243.155 269.311 245.993 279.285C248.913 289.546 255.458 313.209 256.877 316.987C258.295 320.765 274.277 315.501 291.13 307.428C307.271 299.697 340.406 281.093 349.208 275.136C315.903 298.414 270.371 321.037 256.684 321.037C255.857 321.037 255.382 320.945 255.143 320.877L239.414 267.993C239.269 267.678 239.163 267.356 239.089 267.031C238.604 264.781 239.911 262.56 242.086 261.426Z",
    fill: "#FFE7C4"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M350.115 274.507C349.834 274.705 349.546 274.902 349.263 275.1C349.246 275.112 349.226 275.125 349.208 275.137C349.553 274.896 349.904 274.656 350.246 274.414C350.208 274.442 350.156 274.478 350.115 274.507Z",
    fill: "#FFE7C4"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M223.341 318.004C225.258 327.138 235.379 329.067 242.958 328.84C246.975 328.726 250.277 327.989 251.287 327.41C254.214 325.719 252.864 322.213 251.298 320.182C248.643 316.744 236.729 309.845 229.252 309.607C224.873 309.461 222.002 311.594 223.341 318.004Z",
    fill: "#002F3F"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M223.341 318.003C225.258 327.137 235.379 329.066 242.958 328.839C246.975 328.725 250.277 327.988 251.287 327.409C254.214 325.718 252.864 322.212 251.298 320.181C252.773 322.972 244.967 324.697 238.011 322.201C231.056 319.693 225.871 314.327 229.252 309.607C224.873 309.46 222.002 311.593 223.341 318.003Z",
    fill: "#002F3F"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M223.341 318.003C225.258 327.137 235.379 329.066 242.958 328.839C235.413 328.624 229.399 324.278 227.13 319.535C224.872 314.803 226.585 310.208 229.252 309.607C224.873 309.46 222.002 311.593 223.341 318.003Z",
    fill: "#08181E"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M374.684 381.643C367.931 376.082 360.187 365.367 351.416 357.633C342.646 349.899 300.56 319.376 300.56 319.376C300.56 319.376 293.816 322.067 288.629 322.763C297.767 325.213 298.352 322.642 307.999 329.044C317.646 335.446 342.94 354.412 351.332 363.04C358.878 370.798 365.591 382.533 370.561 388.662C375.531 394.792 385.738 390.294 393.347 386.688C387.103 389.238 381.437 387.204 374.684 381.643ZM346.316 298.27C366.288 313.305 388.301 328.176 403.358 348.405C391.86 327.262 367.075 309.772 346.316 298.27ZM430.822 323.339C424.442 314.51 399.051 290.523 388.287 280.998C377.523 271.474 380.649 261.312 380.649 261.312C380.649 261.312 378.472 265.194 377.978 269.97C377.484 274.745 383.854 280.708 395.885 291.82C407.916 302.932 429.058 323.338 434.51 333.677C440.205 344.476 441.159 354.476 435.821 361.167C446.948 350.445 437.202 332.167 430.822 323.339Z",
    fill: "#FFE7C4"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M354.916 376.089C357.592 375.869 360.165 377.121 361.64 379.364C364.025 382.99 367.384 388.192 367.767 389.837C368.344 392.312 364.746 393.498 357.53 393.539C350.314 393.58 334.916 391.635 327.12 389.13C317.749 386.119 321.762 379.222 334.08 377.982C342.298 377.155 350.214 376.476 354.916 376.089Z",
    fill: "#FAFAFA"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M334.081 377.983C334.782 377.912 335.48 377.843 336.175 377.775C339.344 381.008 341.421 385.325 341.829 389.84C341.898 390.602 341.892 391.403 341.798 392.183C336.318 391.397 330.849 390.33 327.121 389.132C317.751 386.12 321.764 379.223 334.081 377.983Z",
    fill: "#F78C3A"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M334.081 377.983C334.782 377.912 335.48 377.843 336.175 377.775C339.344 381.008 341.421 385.325 341.829 389.84C341.898 390.602 341.892 391.403 341.798 392.183C336.318 391.397 330.849 390.33 327.121 389.132C317.751 386.12 321.764 379.223 334.081 377.983Z",
    fill: "#FFE7C4"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M439.752 330.37C439.029 331.988 438.895 333.814 439.463 335.493C442.02 343.05 441.739 347.762 442.819 350.13C444.019 352.762 449.057 344.354 450.497 338.605C451.937 332.856 451.116 323.948 448.887 317.484C446.658 311.021 444.978 316.69 443.539 320.454C442.425 323.367 441.147 327.249 439.752 330.37Z",
    fill: "#FAFAFA"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M444.566 317.747C445.774 314.735 447.167 312.496 448.887 317.484C450.549 322.304 451.427 328.483 451.169 333.699C450.315 329.502 449.104 326.54 447.68 323.104C446.893 321.203 445.866 319.341 444.566 317.747Z",
    fill: "#F78C3A"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M444.566 317.747C445.774 314.735 447.167 312.496 448.887 317.484C450.549 322.304 451.427 328.483 451.169 333.699C450.315 329.502 449.104 326.54 447.68 323.104C446.893 321.203 445.866 319.341 444.566 317.747Z",
    fill: "#FFE7C4"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M425.226 177.595C418.666 184.386 410.047 188.001 401.281 188.457L397.189 188.422C389.005 187.902 380.953 184.605 374.607 178.477C360.409 164.761 360.009 142.057 373.725 127.859C379.852 121.513 387.791 117.933 395.943 117.13L400.036 116.963C408.813 117.098 417.551 120.416 424.343 126.976C438.542 140.692 438.941 163.397 425.226 177.595Z",
    fill: "white"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M426.45 124.793C411.048 109.916 386.406 110.345 371.541 125.753C358.194 139.571 357.181 160.813 368.232 175.773L363.553 186.893C362.754 188.792 364.709 190.68 366.579 189.815L377.531 184.75C392.871 195.273 414.063 193.517 427.4 179.703C442.278 164.303 441.852 139.67 426.45 124.793ZM425.226 177.595C418.666 184.386 410.048 188.001 401.282 188.457L397.19 188.422C389.006 187.902 380.954 184.605 374.608 178.477C360.41 164.761 360.01 142.057 373.726 127.859C379.854 121.513 387.792 117.933 395.944 117.13L400.038 116.963C408.815 117.098 417.553 120.416 424.344 126.976C438.542 140.692 438.941 163.397 425.226 177.595Z",
    fill: "#F78C3A"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M425.226 177.595C418.666 184.386 410.048 188.001 401.282 188.457L397.19 188.422C389.006 187.902 380.954 184.605 374.608 178.477C360.41 164.761 360.01 142.057 373.726 127.859C379.854 121.513 387.792 117.933 395.944 117.13L400.038 116.963C408.815 117.098 417.553 120.416 424.344 126.976C438.542 140.692 438.941 163.397 425.226 177.595Z",
    fill: "white"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M399.476 126.857C385.197 126.857 373.621 138.429 373.621 152.708C373.621 166.987 385.197 178.563 399.476 178.563C413.755 178.563 425.331 166.987 425.331 152.708C425.331 138.429 413.755 126.857 399.476 126.857ZM409.833 134.427C411.046 139.046 414.413 142.843 418.863 144.592C418.87 144.608 418.877 144.624 418.883 144.64C419.947 147.197 418.189 150.059 415.434 150.334C414.175 150.46 412.776 150.569 411.233 150.648C410.628 150.679 410.119 150.187 410.138 149.581C410.16 148.887 410.058 148.279 409.813 147.806C408.825 145.901 405.58 144.843 399.474 144.843C393.369 144.843 390.123 145.901 389.135 147.806C388.89 148.278 388.788 148.887 388.811 149.581C388.83 150.186 388.321 150.679 387.716 150.648C386.173 150.568 384.774 150.46 383.515 150.334C380.76 150.059 379.002 147.196 380.066 144.64L380.086 144.592C384.536 142.843 387.904 139.046 389.117 134.427C392.174 132.691 395.707 131.695 399.474 131.695C403.243 131.695 406.775 132.691 409.833 134.427ZM381.647 156.357C383.926 156.07 386.787 155.826 390.263 155.733C390.755 155.72 391.219 155.956 391.508 156.355C391.632 156.526 391.759 156.694 391.89 156.86C393.317 158.664 394.795 160.01 396.314 160.805C396.682 160.998 396.904 161.386 396.883 161.801C396.787 163.652 396.649 165.295 396.49 166.737C396.069 170.566 391.795 172.652 388.511 170.638C384.4 168.118 381.224 164.223 379.619 159.593C379.108 158.12 380.1 156.552 381.647 156.357ZM402.462 166.736C402.303 165.294 402.165 163.651 402.069 161.8C402.047 161.385 402.27 160.997 402.637 160.804C404.157 160.008 405.634 158.663 407.061 156.859C407.192 156.694 407.319 156.526 407.443 156.354C407.732 155.955 408.196 155.719 408.688 155.732C412.164 155.825 415.025 156.069 417.304 156.356C418.851 156.551 419.843 158.119 419.333 159.592C417.729 164.222 414.552 168.117 410.442 170.637C407.157 172.651 402.883 170.566 402.462 166.736Z",
    fill: "#08181E"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M399.476 166.85C400.493 166.85 401.485 166.74 402.442 166.536C402.292 165.141 402.161 163.569 402.07 161.801C402.048 161.386 402.271 160.998 402.638 160.805C404.158 160.009 405.635 158.664 407.062 156.86C407.192 156.695 407.32 156.527 407.444 156.355C407.733 155.956 408.197 155.72 408.689 155.733C410.345 155.777 411.857 155.857 413.237 155.958C413.482 154.915 413.616 153.828 413.616 152.71C413.616 151.961 413.557 151.227 413.445 150.509C412.744 150.562 412.007 150.609 411.234 150.649C410.629 150.68 410.12 150.188 410.139 149.582C410.161 148.888 410.059 148.28 409.814 147.807C408.826 145.902 405.581 144.844 399.475 144.844C393.37 144.844 390.124 145.902 389.136 147.807C388.891 148.279 388.789 148.888 388.812 149.582C388.831 150.187 388.322 150.68 387.717 150.649C386.944 150.609 386.207 150.562 385.506 150.509C385.394 151.226 385.335 151.961 385.335 152.71C385.335 153.828 385.469 154.914 385.714 155.958C387.094 155.857 388.606 155.778 390.262 155.733C390.754 155.72 391.218 155.956 391.507 156.355C391.631 156.526 391.758 156.694 391.889 156.86C393.315 158.664 394.793 160.01 396.313 160.805C396.681 160.998 396.903 161.386 396.882 161.801C396.79 163.569 396.659 165.141 396.51 166.536C397.467 166.741 398.458 166.85 399.476 166.85Z",
    fill: "#E0E0E0"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M399.476 166.85C400.493 166.85 401.485 166.74 402.442 166.536C402.292 165.141 402.161 163.569 402.07 161.801C402.048 161.386 402.271 160.998 402.638 160.805C404.158 160.009 405.635 158.664 407.062 156.86C407.192 156.695 407.32 156.527 407.444 156.355C407.733 155.956 408.197 155.72 408.689 155.733C410.345 155.777 411.857 155.857 413.237 155.958C413.482 154.915 413.616 153.828 413.616 152.71C413.616 151.961 413.557 151.227 413.445 150.509C412.744 150.562 412.007 150.609 411.234 150.649C410.629 150.68 410.12 150.188 410.139 149.582C410.161 148.888 410.059 148.28 409.814 147.807C408.826 145.902 405.581 144.844 399.475 144.844C393.37 144.844 390.124 145.902 389.136 147.807C388.891 148.279 388.789 148.888 388.812 149.582C388.831 150.187 388.322 150.68 387.717 150.649C386.944 150.609 386.207 150.562 385.506 150.509C385.394 151.226 385.335 151.961 385.335 152.71C385.335 153.828 385.469 154.914 385.714 155.958C387.094 155.857 388.606 155.778 390.262 155.733C390.754 155.72 391.218 155.956 391.507 156.355C391.631 156.526 391.758 156.694 391.889 156.86C393.315 158.664 394.793 160.01 396.313 160.805C396.681 160.998 396.903 161.386 396.882 161.801C396.79 163.569 396.659 165.141 396.51 166.536C397.467 166.741 398.458 166.85 399.476 166.85Z",
    fill: "black"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M399.476 161.638C396.832 161.638 394.289 159.895 391.89 156.861C389.491 153.827 388.15 149.714 389.137 147.809C390.125 145.904 393.37 144.846 399.476 144.846C405.581 144.846 408.827 145.904 409.815 147.809C410.803 149.714 409.461 153.827 407.062 156.861C404.663 159.894 402.12 161.638 399.476 161.638Z",
    fill: "#002F3F"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M399.476 160.005C397.346 160.005 395.297 158.6 393.364 156.156C391.431 153.712 390.35 150.398 391.146 148.863C391.942 147.328 394.557 146.475 399.476 146.475C404.395 146.475 407.01 147.328 407.806 148.863C408.602 150.398 407.521 153.711 405.588 156.156C403.655 158.601 401.606 160.005 399.476 160.005Z",
    fill: "#E0E0E0"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M399.476 148.5L406.66 154.561C407.883 152.424 408.438 150.082 407.806 148.863C407.01 147.328 404.395 146.475 399.476 146.475C394.557 146.475 391.942 147.328 391.146 148.863C390.514 150.082 391.069 152.424 392.292 154.561L399.476 148.5Z",
    fill: "#002F3F"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M399.476 157.98C397.983 157.98 396.547 156.996 395.193 155.283C393.839 153.57 393.081 151.248 393.639 150.173C394.197 149.097 396.029 148.5 399.476 148.5C402.923 148.5 404.755 149.097 405.313 150.173C405.871 151.249 405.113 153.57 403.759 155.283C402.404 156.996 400.968 157.98 399.476 157.98Z",
    fill: "#002F3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerSupport);
export default __webpack_public_path__ + "static/media/learner-support.179d8c02cf0649ae5446bf4f871fee64.svg";
export { ForwardRef as ReactComponent };